import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from './apiClient';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  mailing_address_first_name: Scalars['String'];
  mailing_address_last_name: Scalars['String'];
  postal_code: Scalars['String'];
  state_province: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city: Scalars['String'];
  mailing_address_first_name: Scalars['String'];
  mailing_address_last_name: Scalars['String'];
  postal_code: Scalars['String'];
  state_province: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2?: InputMaybe<Scalars['String']>;
};

export type AffiliateMonetization = {
  __typename?: 'AffiliateMonetization';
  creatorId: Scalars['String'];
  monetizationRate: Scalars['String'];
};

export type AffiliateMonetizationsResponse = {
  __typename?: 'AffiliateMonetizationsResponse';
  monetizations: Array<AffiliateMonetization>;
};

export type AffiliateProductInput = {
  affiliateSubType: AffiliateSubType;
  externalProductId: Scalars['String'];
};

export enum AffiliateSubType {
  Amazon = 'AMAZON',
  Impact = 'IMPACT',
  Skimlinks = 'SKIMLINKS'
}

export type AffiliateTag = {
  __typename?: 'AffiliateTag';
  affiliateSubtype: Scalars['String'];
  creatorId: Scalars['String'];
  id: Scalars['String'];
  tag: Scalars['String'];
};

export type AffiliateTagsResponse = {
  __typename?: 'AffiliateTagsResponse';
  affiliateTags: Array<AffiliateTag>;
};

export type AmazonAdsJobStatus = {
  __typename?: 'AmazonAdsJobStatus';
  brandExists?: Maybe<Scalars['Boolean']>;
  brandId: Scalars['String'];
  jobStatus: Scalars['String'];
  requestId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AmazonAllProfiles = {
  __typename?: 'AmazonAllProfiles';
  profileExists?: Maybe<Scalars['Boolean']>;
  profiles?: Maybe<Array<Maybe<SellerProfiles>>>;
  token?: Maybe<Scalars['String']>;
  totalProfiles?: Maybe<Scalars['Int']>;
};

export type AmazonBrand = {
  __typename?: 'AmazonBrand';
  abstractBrandId?: Maybe<Scalars['String']>;
  associateProductCount?: Maybe<Scalars['Int']>;
  brandBio?: Maybe<Scalars['String']>;
  brandLogo?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  childBrands?: Maybe<Array<Maybe<AmazonBrand>>>;
  commission?: Maybe<AmzProductCommission>;
  enabledProducts?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isAbstractBrand?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  isAttributionActive?: Maybe<Scalars['Boolean']>;
  sellerAccount?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type AmazonBuyBox = {
  __typename?: 'AmazonBuyBox';
  avgRating?: Maybe<Scalars['String']>;
  bestSellerRank?: Maybe<Scalars['String']>;
  discountPer?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  reviewCount?: Maybe<Scalars['String']>;
  strikeThroughPrice?: Maybe<Scalars['String']>;
};

export type AmazonProducts = {
  __typename?: 'AmazonProducts';
  amzSellerId?: Maybe<Scalars['String']>;
  associateCommission?: Maybe<AmzProductCommission>;
  availability?: Maybe<Scalars['String']>;
  bestSellerRank?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandPlatform?: Maybe<Scalars['String']>;
  commission?: Maybe<AmzProductCommission>;
  creatorPromoted?: Maybe<Scalars['Boolean']>;
  expertCount?: Maybe<Scalars['Int']>;
  externalProductId?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  isAttributionActive?: Maybe<Scalars['Boolean']>;
  isConflicted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  privateAssociate?: Maybe<Scalars['Boolean']>;
  privateCommissions?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type AmazonProductsResp = {
  __typename?: 'AmazonProductsResp';
  productCount?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<AmazonProducts>>>;
};

export type AmazonStorefront = {
  __typename?: 'AmazonStorefront';
  amazonId: Scalars['String'];
  creatorId: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  numCollections?: Maybe<Scalars['Int']>;
  numPosts?: Maybe<Scalars['Int']>;
  numProducts?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  url: Scalars['String'];
};

export type AmazonSyncResponse = {
  __typename?: 'AmazonSyncResponse';
  error?: Maybe<Scalars['String']>;
  errorDescription?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<Scalars['Boolean']>;
};

export type AmzProductCommission = {
  __typename?: 'AmzProductCommission';
  amountType?: Maybe<Scalars['String']>;
  amountValue?: Maybe<Scalars['String']>;
  coverage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum ApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type AssnPartnership = {
  __typename?: 'AssnPartnership';
  approvedAt?: Maybe<Scalars['String']>;
  partnershipStatus?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['String']>;
};

export type AssociateProductCommission = {
  __typename?: 'AssociateProductCommission';
  amountType?: Maybe<Scalars['String']>;
  amountValue?: Maybe<Scalars['String']>;
  coverage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BaseProduct = {
  __typename?: 'BaseProduct';
  badges?: Maybe<Array<Scalars['String']>>;
  brandId: Scalars['String'];
  brandName: Scalars['String'];
  brandPlatform?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  id: Scalars['String'];
  isDigital?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shoppingType: Scalars['String'];
};

export type BioLink = {
  __typename?: 'BioLink';
  data: Scalars['String'];
  id: Scalars['String'];
  linkType: BioLinkType;
};

export enum BioLinkType {
  Collection = 'COLLECTION',
  Header = 'HEADER',
  Product = 'PRODUCT',
  Url = 'URL'
}

export type BrandCommission = {
  __typename?: 'BrandCommission';
  brandName: Scalars['String'];
  commission?: Maybe<Commission>;
  monetizationRate?: Maybe<Scalars['String']>;
  reducedCommission?: Maybe<Commission>;
  unreducedCommission?: Maybe<Commission>;
};

export type BrandInfo = {
  __typename?: 'BrandInfo';
  associateFeatureFlag?: Maybe<Scalars['String']>;
  associateProductStatus?: Maybe<Scalars['Boolean']>;
  bio?: Maybe<Scalars['String']>;
  brandPlatform: BrandPlatform;
  brandType?: Maybe<Scalars['String']>;
  brexVendorId?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  companyInfo?: Maybe<CompanyInfo>;
  contactInfo?: Maybe<ContactInfo>;
  createOrderTags: Scalars['Boolean'];
  createdAt: Scalars['String'];
  customerSupport?: Maybe<CustomerSupport>;
  defaultCommission?: Maybe<Commission>;
  defaultDiscount?: Maybe<Discount>;
  description?: Maybe<Scalars['String']>;
  externalInventory: Scalars['Boolean'];
  externalStoreInfo?: Maybe<ExternalStoreInfo>;
  featureFlag?: Maybe<Scalars['String']>;
  hasBrexPayment: Scalars['Boolean'];
  id: Scalars['String'];
  ignoreInventoryUpdates: Scalars['Boolean'];
  ignorePriceUpdates: Scalars['Boolean'];
  invoiceType: BrandInvoiceType;
  isActive?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  isAssociateDefaultHidden?: Maybe<Scalars['Boolean']>;
  isDefaultHidden?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['String']>;
  matchSalePrice: Scalars['Boolean'];
  onBoardingInfoClicked?: Maybe<Scalars['Boolean']>;
  onboardingStatus?: Maybe<OnboardingStatus>;
  orderPaymentPending: Scalars['Boolean'];
  passCustomerEmail: Scalars['Boolean'];
  productStatus?: Maybe<Scalars['Boolean']>;
  productsIngestedDefaultEnabled: Scalars['Boolean'];
  requiresApproval: Scalars['Boolean'];
  requiresAssociatesApproval?: Maybe<Scalars['Boolean']>;
  shopifyAvailabilityMetafield?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  termsOfServiceAccepted: Scalars['Boolean'];
};

export enum BrandIntegrationType {
  Affiliate = 'AFFILIATE',
  Full = 'FULL',
  Hybrid = 'HYBRID'
}

export enum BrandInvoiceType {
  Commission = 'COMMISSION',
  Commissionfee = 'COMMISSIONFEE',
  Neither = 'NEITHER'
}

export type BrandOrder = {
  __typename?: 'BrandOrder';
  brandPayout: Scalars['String'];
  commission: Scalars['String'];
  creator: Scalars['String'];
  customer: Scalars['String'];
  date: Scalars['String'];
  discount: Scalars['String'];
  grossSalesPrice: Scalars['String'];
  lineItems: Array<BrandOrderLineItem>;
  netSalesAfterCommission: Scalars['String'];
  netSalesPrice: Scalars['String'];
  orderName: Scalars['String'];
  orderTotal: Scalars['String'];
  shipping: Scalars['String'];
  shopifyFee: Scalars['String'];
  tax: Scalars['String'];
};

export type BrandOrderLineItem = {
  __typename?: 'BrandOrderLineItem';
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export enum BrandPlatform {
  Amazon = 'AMAZON',
  Impact = 'IMPACT',
  Magento = 'MAGENTO',
  Shopify = 'SHOPIFY',
  Skimlinks = 'SKIMLINKS',
  Woocommerce = 'WOOCOMMERCE'
}

export type BrandProducts = {
  __typename?: 'BrandProducts';
  privateCommissions?: Maybe<Scalars['Boolean']>;
  productCount?: Maybe<Scalars['String']>;
};

export type BrandProductsForBrandResponse = {
  __typename?: 'BrandProductsForBrandResponse';
  logoUrl?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  products: Array<ProductForBrand>;
};

export type BrandProductsForCreatorFilters = {
  availability?: InputMaybe<Scalars['String']>;
  commission_percent?: InputMaybe<Scalars['String']>;
  deal?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  offering?: InputMaybe<Scalars['String']>;
};

export type BrandProductsResponse = {
  __typename?: 'BrandProductsResponse';
  associatepartnershipStatus?: Maybe<PartnershipStatus>;
  bio?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandLogoUrl: Scalars['String'];
  brandName: Scalars['String'];
  brandProducts?: Maybe<Array<Product>>;
  brandType?: Maybe<Scalars['String']>;
  commission?: Maybe<Commission>;
  defaultCommission?: Maybe<Commission>;
  defaultDiscount?: Maybe<Discount>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  partnershipStatus?: Maybe<PartnershipStatus>;
  requiresApproval?: Maybe<Scalars['Boolean']>;
  requiresAssociateApproval?: Maybe<Scalars['Boolean']>;
};

export type BrandSearchResponse = {
  __typename?: 'BrandSearchResponse';
  approvedAt?: Maybe<Scalars['String']>;
  associatePartnership?: Maybe<AssnPartnership>;
  avgAssociateCommission?: Maybe<Scalars['String']>;
  avgCommission?: Maybe<Scalars['String']>;
  brandType?: Maybe<Scalars['String']>;
  commission?: Maybe<Commission>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  id: Scalars['String'];
  integrationType?: Maybe<BrandIntegrationType>;
  isAssociate?: Maybe<Scalars['Boolean']>;
  isAttribution?: Maybe<Scalars['Boolean']>;
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  partnershipStatus?: Maybe<PartnershipStatus>;
  rejectedAt?: Maybe<Scalars['String']>;
  requiresApproval: Scalars['Boolean'];
  requiresAssociateApproval?: Maybe<Scalars['Boolean']>;
};

export type Carousel = {
  __typename?: 'Carousel';
  brands?: Maybe<Array<Maybe<BrandSearchResponse>>>;
  carouselType?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayPosition?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<Product>>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CheckInvitationResp = {
  __typename?: 'CheckInvitationResp';
  brandName?: Maybe<Scalars['String']>;
  expireDate?: Maybe<Scalars['String']>;
  inviteeEmail?: Maybe<Scalars['String']>;
  inviterName?: Maybe<Scalars['String']>;
  isInviteeUserExist?: Maybe<Scalars['Boolean']>;
};

export enum Children {
  ExpectingPregnant = 'EXPECTING_PREGNANT',
  Infant = 'INFANT',
  Kid = 'KID',
  Newborn = 'NEWBORN',
  NoChildren = 'NO_CHILDREN',
  Teen = 'TEEN',
  Toddler = 'TODDLER'
}

export type Collection = {
  __typename?: 'Collection';
  bannerImageUrl: Scalars['String'];
  collectionType?: Maybe<CollectionType>;
  createdAt?: Maybe<Scalars['String']>;
  creatorId: Scalars['String'];
  description: Scalars['String'];
  displayInHomePage: Scalars['Boolean'];
  displayInNavigation: Scalars['Boolean'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  mediaUrls?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  productIds?: Maybe<Array<Scalars['String']>>;
  productNum?: Maybe<Scalars['Int']>;
  products: Array<Product>;
  shortlink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  storefrontId: Scalars['String'];
};

export enum CollectionType {
  Collection = 'COLLECTION',
  Post = 'POST'
}

export type Commission = {
  __typename?: 'Commission';
  amountType: CommissionAmountType;
  amountValue: Scalars['String'];
  coverage: CommissionCoverage;
  description: Scalars['String'];
  id: Scalars['String'];
  isBrandDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  value: Scalars['Int'];
};

export enum CommissionAmountType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export enum CommissionCoverage {
  AllProducts = 'ALL_PRODUCTS',
  SpecificProducts = 'SPECIFIC_PRODUCTS'
}

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  name: Scalars['String'];
  website: Scalars['String'];
};

export type CompanyInfoInput = {
  name: Scalars['String'];
  website: Scalars['String'];
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  title: Scalars['String'];
};

export type ContactInfoInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  title: Scalars['String'];
};

export type CostPerView = {
  __typename?: 'CostPerView';
  clickEnd: Scalars['Int'];
  clickStart: Scalars['Int'];
  costPerThousand: Scalars['String'];
};

export type CostPerViewInput = {
  clickEnd: Scalars['Int'];
  clickStart: Scalars['Int'];
  costPerThousand: Scalars['String'];
};

export enum CrawlStatus {
  Initiated = 'INITIATED',
  InviteAccepted = 'INVITE_ACCEPTED',
  InviteAcceptFailed = 'INVITE_ACCEPT_FAILED',
  InviteDnr = 'INVITE_DNR',
  InviteProcessing = 'INVITE_PROCESSING',
  PermissionCheckFailed = 'PERMISSION_CHECK_FAILED',
  PermissionCheckInit = 'PERMISSION_CHECK_INIT',
  PermissionGranted = 'PERMISSION_GRANTED',
  PermissionNotGranted = 'PERMISSION_NOT_GRANTED',
  Revoke = 'REVOKE'
}

export type CreateLinkResponse = {
  __typename?: 'CreateLinkResponse';
  offers: Array<ProductOffer>;
};

export type CreateProductInput = {
  affiliateSubType?: InputMaybe<AffiliateSubType>;
  brandId: Scalars['String'];
  brandPlatform: BrandPlatform;
  description?: InputMaybe<Scalars['String']>;
  externalProductId: Scalars['String'];
  mediaUrls: Array<Scalars['String']>;
  name: Scalars['String'];
  outlink?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  shoppingType: ShoppingType;
};

export type CreateProductVariantInput = {
  externalProductVariantId: Scalars['String'];
  mediaId?: InputMaybe<Scalars['String']>;
  options: Array<VariantOptionInput>;
  price?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type CreatorCommissionInput = {
  amountType?: InputMaybe<CommissionAmountType>;
  amountValue?: InputMaybe<Scalars['String']>;
  useDefaultCommission: Scalars['Boolean'];
};

export type CreatorDiscountInput = {
  amountType?: InputMaybe<DiscountAmountType>;
  amountValue?: InputMaybe<Scalars['String']>;
  useDefaultDiscount: Scalars['Boolean'];
};

export type CreatorForBrand = {
  __typename?: 'CreatorForBrand';
  amzStorefront?: Maybe<Scalars['String']>;
  approvedAt?: Maybe<Scalars['String']>;
  associateBrandMeta?: Maybe<BrandProducts>;
  associateFlags?: Maybe<FeatureFlags>;
  bio?: Maybe<Scalars['String']>;
  brandMeta?: Maybe<BrandProducts>;
  children?: Maybe<Array<Children>>;
  commission?: Maybe<Commission>;
  creatorId: Scalars['String'];
  creatorName: Scalars['String'];
  creatorTheme?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  discount?: Maybe<Discount>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  flags?: Maybe<FeatureFlags>;
  gender?: Maybe<Gender>;
  isEligibleForAssociates: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  niches?: Maybe<Array<Niche>>;
  partnershipStatus?: Maybe<PartnershipStatus>;
  pets?: Maybe<Array<Pets>>;
  productsInStore: Scalars['Int'];
  rejectedAt?: Maybe<Scalars['String']>;
  requestedAt?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['String']>;
  socialMedia?: Maybe<SocialMediaLinks>;
  storeEnabled: Scalars['Boolean'];
};

export type CreatorMeta = {
  __typename?: 'CreatorMeta';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  storeName?: Maybe<Scalars['String']>;
};

export type CreatorOrder = {
  __typename?: 'CreatorOrder';
  commission: Scalars['String'];
  customer: Scalars['String'];
  date: Scalars['String'];
  earnings: Scalars['String'];
  grossSalesPrice: Scalars['String'];
  lineItems: Array<CreatorOrderLineItem>;
  paid: Scalars['Boolean'];
  paidDate: Scalars['String'];
};

export type CreatorOrderLineItem = {
  __typename?: 'CreatorOrderLineItem';
  commissionRate: Scalars['String'];
  commissionType: Scalars['String'];
  commissionableSales: Scalars['String'];
  discount: Scalars['String'];
  earnings: Scalars['String'];
  grossSalesPrice: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  salesTax?: Maybe<Scalars['String']>;
};

export type CreatorSocialMediaStat = {
  __typename?: 'CreatorSocialMediaStat';
  mediaIngestedNum?: Maybe<Scalars['Int']>;
  mediaLastIngestedAt?: Maybe<Scalars['String']>;
  mediaLastProcessedAt?: Maybe<Scalars['String']>;
  mediaProcessedNum?: Maybe<Scalars['Int']>;
};

export type CreatorSocialMediaStats = {
  __typename?: 'CreatorSocialMediaStats';
  instagram?: Maybe<CreatorSocialMediaStat>;
};

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String'];
  firstPurchaseDate: Scalars['String'];
  name: Scalars['String'];
  stateCode: Scalars['String'];
  totalGmvPurchased: Scalars['String'];
  totalPurchases: Scalars['Int'];
};

export type CustomerSupport = {
  __typename?: 'CustomerSupport';
  returnPolicy: Scalars['String'];
  supportEmail: Scalars['String'];
};

export type CustomerSupportInput = {
  returnPolicy: Scalars['String'];
  supportEmail: Scalars['String'];
};

export type DefaultCommissionInput = {
  amountType: CommissionAmountType;
  amountValue: Scalars['String'];
};

export type DefaultDiscountInput = {
  amountType: DiscountAmountType;
  amountValue: Scalars['String'];
};

export type Discount = {
  __typename?: 'Discount';
  amountType: DiscountAmountType;
  amountValue: Scalars['String'];
  appliesOnEachItem: Scalars['Boolean'];
  code: Scalars['String'];
  coverage: DiscountCoverage;
  displayStrikethrough: Scalars['Boolean'];
  id: Scalars['String'];
  isBrandDefaultOrChild?: Maybe<Scalars['Boolean']>;
  minimumOrderValue?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
};

export enum DiscountAmountType {
  Flat = 'FLAT',
  Percent = 'PERCENT'
}

export enum DiscountCoverage {
  AllProducts = 'ALL_PRODUCTS',
  SpecificProducts = 'SPECIFIC_PRODUCTS'
}

export type DiscountInput = {
  amountType: DiscountAmountType;
  amountValue: Scalars['String'];
  code: Scalars['String'];
  coverage: DiscountCoverage;
  isActive: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type DownloadReportRequestParameters = {
  brandId?: InputMaybe<Scalars['String']>;
  expertId?: InputMaybe<Scalars['String']>;
};

export type DownloadReportRequestRes = {
  __typename?: 'DownloadReportRequestRes';
  reportId: Scalars['String'];
  reportType: Scalars['String'];
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Expert = {
  __typename?: 'Expert';
  address?: Maybe<Address>;
  amzAssociateEnabled?: Maybe<Scalars['Boolean']>;
  amzAssociateTag?: Maybe<Scalars['String']>;
  amzStorefront?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  brexVendorId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<Children>>>;
  contactInfo: ExpertContactInfo;
  createdAt: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  hasBrexPayment: Scalars['Boolean'];
  id: Scalars['String'];
  instagramAuthorized: Scalars['Boolean'];
  instagramName?: Maybe<Scalars['String']>;
  isAssociateEnabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  niches?: Maybe<Array<Maybe<Niche>>>;
  notificationDelivery?: Maybe<NotificationDelivery>;
  notificationSchedule?: Maybe<NotificationSchedule>;
  onboardingDescription?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Maybe<Pets>>>;
  score?: Maybe<Scalars['String']>;
  socialMedia?: Maybe<SocialMediaLinks>;
  storeApprovalStatus: ApprovalStatus;
  storeApprovedAt: Scalars['String'];
  theme: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ExpertAmazonSources = {
  __typename?: 'ExpertAmazonSources';
  amzAssociateId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryTrackingId?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  subTrackingId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type ExpertAsinProducts = {
  __typename?: 'ExpertAsinProducts';
  associateCommission?: Maybe<AmzProductCommission>;
  associateUpdatedAt?: Maybe<Scalars['String']>;
  creatorInfo?: Maybe<CreatorForBrand>;
  productExpertCommission?: Maybe<AmzProductCommission>;
  productMeta?: Maybe<ProductMeta>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ExpertAsinProductsResp = {
  __typename?: 'ExpertAsinProductsResp';
  experts?: Maybe<Array<Maybe<ExpertAsinProducts>>>;
  expertsCount?: Maybe<Scalars['Int']>;
};

export type ExpertContactInfo = {
  __typename?: 'ExpertContactInfo';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type ExpertContactInfoInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type ExpertProducts = {
  __typename?: 'ExpertProducts';
  amzSellerId?: Maybe<Scalars['String']>;
  associateCommission?: Maybe<AmzProductCommission>;
  associateUpdatedAt?: Maybe<Scalars['String']>;
  bestSellerRank?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  commission?: Maybe<AmzProductCommission>;
  creator?: Maybe<CreatorMeta>;
  externalProductId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ExpertProductsResp = {
  __typename?: 'ExpertProductsResp';
  productCount?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<ExpertProducts>>>;
};

export type ExpertsByApprovalStatus = {
  __typename?: 'ExpertsByApprovalStatus';
  experts: Array<Expert>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ExternalStoreInfo = {
  __typename?: 'ExternalStoreInfo';
  externalStore: Scalars['String'];
  externalStoreView?: Maybe<Scalars['String']>;
};

export type ExternalStoreInfoInput = {
  apiToken?: InputMaybe<Scalars['String']>;
  consumerKey?: InputMaybe<Scalars['String']>;
  consumerSecret?: InputMaybe<Scalars['String']>;
  externalStore: Scalars['String'];
  externalStoreView?: InputMaybe<Scalars['String']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  allBrandsEnabled?: Maybe<Scalars['Boolean']>;
  allBrandsHidden?: Maybe<Scalars['Boolean']>;
  someBrandsEnabled?: Maybe<Scalars['Boolean']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Nonbinary = 'NONBINARY'
}

export type GenerateStorefrontPageLinkResponse = {
  __typename?: 'GenerateStorefrontPageLinkResponse';
  link: Scalars['String'];
  linkId: Scalars['String'];
};

export type GetAmazonPricesResponse = {
  __typename?: 'GetAmazonPricesResponse';
  productPrices: Array<ProductPrice>;
};

export type GetBillingResp = {
  __typename?: 'GetBillingResp';
  paymentMethodAttached?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
};

export type GetBioLinksResponse = {
  __typename?: 'GetBioLinksResponse';
  links: Array<BioLink>;
};

export type GetBrandByCheckoutSessionIdResponse = {
  __typename?: 'GetBrandByCheckoutSessionIdResponse';
  brandId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GetBrandProductsForConsumerResponse = {
  __typename?: 'GetBrandProductsForConsumerResponse';
  brandDescription: Scalars['String'];
  brandLogoUrl: Scalars['String'];
  brandName: Scalars['String'];
  brandSlug: Scalars['String'];
  products: Array<Product>;
};

export type GetBrandUserResp = {
  __typename?: 'GetBrandUserResp';
  brandId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type GetCategoryFullPathResponse = {
  __typename?: 'GetCategoryFullPathResponse';
  categoryIds: Array<Scalars['String']>;
};

export type GetOrdersByCustomerResponse = {
  __typename?: 'GetOrdersByCustomerResponse';
  orders: Array<CreatorOrder>;
};

export type GetStorefrontLinkSourcesForExpertResponse = {
  __typename?: 'GetStorefrontLinkSourcesForExpertResponse';
  sources?: Maybe<Array<Maybe<StorefrontLinkSource>>>;
};

export type GetStorefrontsResponse = {
  __typename?: 'GetStorefrontsResponse';
  storefront: Storefront;
};

export type GetSubscriptionResponse = {
  __typename?: 'GetSubscriptionResponse';
  internalSubscriptionId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum IsActiveFilter {
  All = 'ALL',
  OnlyActive = 'ONLY_ACTIVE',
  OnlyInactive = 'ONLY_INACTIVE'
}

export enum IsStoreVisibleFilter {
  All = 'ALL',
  OnlyInvisible = 'ONLY_INVISIBLE',
  OnlyVisible = 'ONLY_VISIBLE'
}

export enum LinkType {
  Pdp = 'PDP',
  Amazon = 'amazon'
}

export type LinksInput = {
  facebookName?: InputMaybe<Scalars['String']>;
  instagramName?: InputMaybe<Scalars['String']>;
  pinterestName?: InputMaybe<Scalars['String']>;
  threadsName?: InputMaybe<Scalars['String']>;
  tiktokName?: InputMaybe<Scalars['String']>;
  twitterName?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtubeName?: InputMaybe<Scalars['String']>;
};

export type ListAmazonBrand = {
  __typename?: 'ListAmazonBrand';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandType?: Maybe<Scalars['String']>;
  sellerAccount?: Maybe<Scalars['String']>;
};

export type ListAmazonBrandsResp = {
  __typename?: 'ListAmazonBrandsResp';
  brandCount?: Maybe<Scalars['Int']>;
  brands?: Maybe<Array<Maybe<AmazonBrand>>>;
};

export type ListBrandCreator = {
  __typename?: 'ListBrandCreator';
  associateStatus?: Maybe<Scalars['Boolean']>;
  attributionStatus?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandType?: Maybe<Scalars['String']>;
  isAssociateDisabled?: Maybe<Scalars['Boolean']>;
  isAssociateSelected?: Maybe<Scalars['Boolean']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  sellerAccount?: Maybe<Scalars['String']>;
};

export type ListBrandsResp = {
  __typename?: 'ListBrandsResp';
  brandCount?: Maybe<Scalars['Int']>;
  brands?: Maybe<Array<Maybe<BrandSearchResponse>>>;
};

export type ListBrandsResponse = {
  __typename?: 'ListBrandsResponse';
  brandName?: Maybe<Scalars['String']>;
  brandType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type ListCustomerResponse = {
  __typename?: 'ListCustomerResponse';
  customers: Array<Customer>;
  nextPageStartKey: Scalars['String'];
};

export type ListOrgUsersResp = {
  __typename?: 'ListOrgUsersResp';
  createdAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitationAccepted?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type ListUserBrandsResp = {
  __typename?: 'ListUserBrandsResp';
  activeBrandCount?: Maybe<Scalars['Int']>;
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  onboardingStatus?: Maybe<Scalars['String']>;
  syncBrandCount?: Maybe<Scalars['Int']>;
};

export type ListUsersResp = {
  __typename?: 'ListUsersResp';
  userCount?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<ListOrgUsersResp>>>;
};

export type MarketplaceProductSearchResults = {
  __typename?: 'MarketplaceProductSearchResults';
  affiliateSubType: AffiliateSubType;
  products: Array<SearchProduct>;
};

export type Media = {
  __typename?: 'Media';
  alt: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  mediaProductId: Scalars['String'];
  src: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type MediaUploadUrl = {
  __typename?: 'MediaUploadUrl';
  id: Scalars['String'];
  mediaUrl: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type MergeBrandsToNewAbstractBrandResponse = {
  __typename?: 'MergeBrandsToNewAbstractBrandResponse';
  abstractBrandId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MergeChildBrandIntoExistingAbstractBrandResponse = {
  __typename?: 'MergeChildBrandIntoExistingAbstractBrandResponse';
  brandId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPostToSponsoredPostCampaign: SponsoredPost;
  addProductToExpert: Scalars['Boolean'];
  bulkAddProductToStoreAndCreateShareLink: Array<ProductShareLink>;
  createBrandUser: Scalars['Boolean'];
  createCreatorMedia: Media;
  createExpertBrandDiscount: Discount;
  createInviteToOrg: Scalars['Boolean'];
  createLink: CreateLinkResponse;
  createProduct: Product;
  createProductByExternalId: Scalars['String'];
  createProductVariant: ProductVariant;
  createSyntheticProduct: Product;
  deleteBioLink: Scalars['Boolean'];
  deleteBrand: Scalars['Boolean'];
  deleteCollection: Scalars['Boolean'];
  deleteProduct: Scalars['Boolean'];
  deleteUserOrg: Scalars['Boolean'];
  enrollInSponsoredPostCampaign: Scalars['Boolean'];
  expertAmazonAssociateTag: Scalars['Boolean'];
  generatePostShareLink: ProductShareLink;
  generateProductShareLink?: Maybe<Array<Maybe<ViewAllLinks>>>;
  generateStorefrontPageLink: GenerateStorefrontPageLinkResponse;
  getAPIKey: Scalars['String'];
  mergeBrandsToNewAbstractBrand: MergeBrandsToNewAbstractBrandResponse;
  mergeChildBrandIntoExistingAbstractBrand: MergeChildBrandIntoExistingAbstractBrandResponse;
  removeExpertPrivateAssociateCommission?: Maybe<Scalars['Boolean']>;
  removeExpertPrivateCommission?: Maybe<Scalars['Boolean']>;
  removeProductFromExpert: Scalars['Boolean'];
  sendDownloadReportRequest?: Maybe<DownloadReportRequestRes>;
  sendUploadRequest?: Maybe<UploadRequestRes>;
  setBillingSubscription: SetSubscriptionResponse;
  setCategoriesOnProduct: Scalars['Boolean'];
  setOnboardingFlag?: Maybe<Scalars['Boolean']>;
  setProductAssociateCommissions: Scalars['Boolean'];
  setProductSpecificCommissions: Scalars['Boolean'];
  setStripeBilling?: Maybe<SetBillingResp>;
  syncAmazonAds: AmazonAdsJobStatus;
  triggerCrawl?: Maybe<Scalars['Boolean']>;
  unMergeChildBrandFromAbstractBrand: UnMergeBrandsFromAbstractBrandResponse;
  updateAccStatus?: Maybe<Scalars['Boolean']>;
  updateAmazonRefreshToken?: Maybe<AmazonSyncResponse>;
  updateAmazonTokenRefresh?: Maybe<AmazonAllProfiles>;
  updateBioLinkOrder: Scalars['Boolean'];
  updateBrandLogo: MediaUploadUrl;
  updateBrandStatusBulk?: Maybe<Scalars['Boolean']>;
  updateBrandStorefrontPages: Scalars['Boolean'];
  updateCollectionOrder: Scalars['Boolean'];
  updateCreatorLinks: SocialMediaLinks;
  updateCreatorProduct: Product;
  updateCreatorSpecificCommission: Commission;
  updateCreatorSpecificDiscount: Discount;
  updateExpertTheme: Scalars['String'];
  updatePartnership: Scalars['Boolean'];
  updatePartnershipsBulk?: Maybe<Scalars['Boolean']>;
  updateProductContent: Product;
  updateProductsIsActive: Scalars['Boolean'];
  updateUploadRequest?: Maybe<UploadResultRes>;
  upsertAffiliateProduct: Product;
  upsertAmazonStorefront?: Maybe<AmazonStorefront>;
  upsertBioLink: BioLink;
  upsertBrand: BrandInfo;
  upsertCollection: Collection;
  upsertCreatorConnections?: Maybe<UpsertResp>;
  upsertExpert: Expert;
  upsertPost: Collection;
  upsertSponsoredPostCampaign: SponsoredPostCampaign;
};


export type MutationAddPostToSponsoredPostCampaignArgs = {
  campaignId: Scalars['String'];
  creatorId: Scalars['String'];
  productIds: Array<Scalars['String']>;
  url: Scalars['String'];
};


export type MutationAddProductToExpertArgs = {
  expertId: Scalars['String'];
  externalProductId?: InputMaybe<Scalars['String']>;
  outlinkDiscountCode?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type MutationBulkAddProductToStoreAndCreateShareLinkArgs = {
  amzAssociateTag?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  primaryTrackingId?: InputMaybe<Scalars['String']>;
  productIds: Array<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
  subTrackingId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateBrandUserArgs = {
  id: Scalars['String'];
};


export type MutationCreateCreatorMediaArgs = {
  creatorId: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  url: Scalars['String'];
};


export type MutationCreateExpertBrandDiscountArgs = {
  brandId: Scalars['String'];
  discount: DiscountInput;
  expertId: Scalars['String'];
};


export type MutationCreateInviteToOrgArgs = {
  brandId: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};


export type MutationCreateLinkArgs = {
  creatorId: Scalars['String'];
  url: Scalars['String'];
};


export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};


export type MutationCreateProductByExternalIdArgs = {
  brandExternalStore: Scalars['String'];
  externalProductId: Scalars['String'];
};


export type MutationCreateProductVariantArgs = {
  createProductVariantInput: CreateProductVariantInput;
};


export type MutationCreateSyntheticProductArgs = {
  syntheticProductInput: SyntheticProductInput;
};


export type MutationDeleteBioLinkArgs = {
  bioLinkId: Scalars['String'];
  creatorId: Scalars['String'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCollectionArgs = {
  collectionId: Scalars['String'];
  creatorId: Scalars['String'];
};


export type MutationDeleteProductArgs = {
  externalProductId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUserOrgArgs = {
  id: Scalars['String'];
  isInvited?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEnrollInSponsoredPostCampaignArgs = {
  campaignId: Scalars['String'];
  creatorId: Scalars['String'];
};


export type MutationExpertAmazonAssociateTagArgs = {
  amzAssociateEnabled?: InputMaybe<Scalars['Boolean']>;
  amzAssociateTag?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
};


export type MutationGeneratePostShareLinkArgs = {
  creatorId: Scalars['String'];
  postId: Scalars['String'];
};


export type MutationGenerateProductShareLinkArgs = {
  amzAssociateTag?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  primaryTrackingId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sourceName?: InputMaybe<Scalars['String']>;
  subTrackingId?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateStorefrontPageLinkArgs = {
  abstractBrandId: Scalars['String'];
  amzAssociateTag: Scalars['String'];
  creatorId: Scalars['String'];
  primaryTrackingId?: InputMaybe<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
  storePageId: Scalars['String'];
  subTrackingId?: InputMaybe<Scalars['String']>;
};


export type MutationGetApiKeyArgs = {
  createKey?: InputMaybe<Scalars['Boolean']>;
  creatorId: Scalars['String'];
};


export type MutationMergeBrandsToNewAbstractBrandArgs = {
  abstractBrandBio?: InputMaybe<Scalars['String']>;
  abstractBrandCommission?: InputMaybe<Scalars['String']>;
  abstractBrandLogo?: InputMaybe<Scalars['String']>;
  abstractBrandName: Scalars['String'];
  brandId: Scalars['String'];
  childBrandIds: Array<Scalars['String']>;
  deferBrand?: InputMaybe<Scalars['String']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  isAssociateApproved?: InputMaybe<Scalars['Boolean']>;
  isAssociateHidden?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
  requiresAssociateApproval?: InputMaybe<Scalars['Boolean']>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMergeChildBrandIntoExistingAbstractBrandArgs = {
  abstractBrandId: Scalars['String'];
  childBrandIds: Array<Scalars['String']>;
};


export type MutationRemoveExpertPrivateAssociateCommissionArgs = {
  commissionId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expertId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRemoveExpertPrivateCommissionArgs = {
  commissionId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expertId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRemoveProductFromExpertArgs = {
  expertId: Scalars['String'];
  externalProductId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type MutationSendDownloadReportRequestArgs = {
  parameters?: InputMaybe<DownloadReportRequestParameters>;
  reportType: Scalars['String'];
};


export type MutationSendUploadRequestArgs = {
  parameters?: InputMaybe<UploadRequestParameters>;
  reportType: Scalars['String'];
};


export type MutationSetBillingSubscriptionArgs = {
  brandId: Scalars['String'];
};


export type MutationSetCategoriesOnProductArgs = {
  amazonCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  productId: Scalars['String'];
};


export type MutationSetOnboardingFlagArgs = {
  brandId: Scalars['String'];
};


export type MutationSetProductAssociateCommissionsArgs = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commission?: InputMaybe<DefaultCommissionInput>;
  discount?: InputMaybe<DefaultDiscountInput>;
  expertId?: InputMaybe<Array<Scalars['String']>>;
  productId?: InputMaybe<Array<Scalars['String']>>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  setParentDefaultCommission?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetProductSpecificCommissionsArgs = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  commission?: InputMaybe<DefaultCommissionInput>;
  discount?: InputMaybe<DefaultDiscountInput>;
  expertId?: InputMaybe<Array<Scalars['String']>>;
  productId?: InputMaybe<Array<Scalars['String']>>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  setParentDefaultCommission?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetStripeBillingArgs = {
  brandId: Scalars['String'];
};


export type MutationSyncAmazonAdsArgs = {
  brandId: Scalars['String'];
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenId: Scalars['String'];
};


export type MutationTriggerCrawlArgs = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationUnMergeChildBrandFromAbstractBrandArgs = {
  brandId: Scalars['String'];
  childBrandId: Scalars['String'];
  inheritCreatorPermissions?: InputMaybe<Scalars['Boolean']>;
  inheritDetailsFromAbstract?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateAccStatusArgs = {
  accEnabled?: InputMaybe<Scalars['Boolean']>;
  brandId: Scalars['String'];
};


export type MutationUpdateAmazonRefreshTokenArgs = {
  brandId: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type MutationUpdateAmazonTokenRefreshArgs = {
  brandId: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type MutationUpdateBioLinkOrderArgs = {
  bioLinkOrder: Array<Scalars['String']>;
  creatorId: Scalars['String'];
};


export type MutationUpdateBrandLogoArgs = {
  brandId: Scalars['String'];
  fileSize: Scalars['Int'];
  fileType: Scalars['String'];
};


export type MutationUpdateBrandStatusBulkArgs = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAttribution?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateBrandStorefrontPagesArgs = {
  pages: Array<UpdateBrandStorefrontPageArgs>;
};


export type MutationUpdateCollectionOrderArgs = {
  collectionOrder: Array<Scalars['String']>;
  creatorId: Scalars['String'];
};


export type MutationUpdateCreatorLinksArgs = {
  creatorId: Scalars['String'];
  linksInput: LinksInput;
};


export type MutationUpdateCreatorProductArgs = {
  updateCreatorProductArgs: UpdateCreatorProductArgs;
};


export type MutationUpdateCreatorSpecificCommissionArgs = {
  brandId: Scalars['String'];
  commission: CreatorCommissionInput;
  creatorId: Scalars['String'];
};


export type MutationUpdateCreatorSpecificDiscountArgs = {
  brandId: Scalars['String'];
  creatorId: Scalars['String'];
  discount: CreatorDiscountInput;
};


export type MutationUpdateExpertThemeArgs = {
  expertName?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
};


export type MutationUpdatePartnershipArgs = {
  allBrands?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  expertId: Scalars['String'];
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  partnershipStatus?: InputMaybe<PartnershipStatus>;
  productId?: InputMaybe<Scalars['String']>;
  requestNotes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePartnershipsBulkArgs = {
  brandIds?: InputMaybe<Array<InputMaybe<UpdateBrandPartnerships>>>;
  creatorId?: InputMaybe<Scalars['String']>;
  parentBrandId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProductContentArgs = {
  description?: InputMaybe<Scalars['String']>;
  expertName: Scalars['String'];
  mediaIds?: InputMaybe<Array<Scalars['String']>>;
  productId: Scalars['String'];
};


export type MutationUpdateProductsIsActiveArgs = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAttribution?: InputMaybe<Scalars['Boolean']>;
  productIds: Array<Scalars['String']>;
};


export type MutationUpdateUploadRequestArgs = {
  action: Scalars['String'];
  reportId: Scalars['String'];
};


export type MutationUpsertAffiliateProductArgs = {
  affiliateProductInput?: InputMaybe<AffiliateProductInput>;
};


export type MutationUpsertAmazonStorefrontArgs = {
  upsertAmazonStorefrontInput: UpsertAmazonStorefrontInput;
};


export type MutationUpsertBioLinkArgs = {
  upsertBioLinkInput: UpsertBioLinkInput;
};


export type MutationUpsertBrandArgs = {
  associateRequiresApproval?: InputMaybe<Scalars['Boolean']>;
  bio?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  brandPlatform?: InputMaybe<BrandPlatform>;
  brexPaymentId?: InputMaybe<Scalars['String']>;
  brexVendorId?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  companyInfo?: InputMaybe<CompanyInfoInput>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createOrderTags?: InputMaybe<Scalars['Boolean']>;
  customerSupport?: InputMaybe<CustomerSupportInput>;
  defaultCommission?: InputMaybe<DefaultCommissionInput>;
  defaultDiscount?: InputMaybe<DefaultDiscountInput>;
  description?: InputMaybe<Scalars['String']>;
  externalStoreInfo?: InputMaybe<ExternalStoreInfoInput>;
  integrationType?: InputMaybe<BrandIntegrationType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAssociateHidden?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  onboardingInfoClicked?: InputMaybe<Scalars['Boolean']>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  termsOfServiceAccepted?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpsertCollectionArgs = {
  upsertCollectionInput: UpsertCollectionInput;
};


export type MutationUpsertCreatorConnectionsArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  merchantToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertExpertArgs = {
  address?: InputMaybe<AddressInput>;
  amzStorefront?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  brandInvite?: InputMaybe<Scalars['String']>;
  brexPaymentId?: InputMaybe<Scalars['String']>;
  brexVendorId?: InputMaybe<Scalars['String']>;
  children?: InputMaybe<Array<InputMaybe<Children>>>;
  contactInfo?: InputMaybe<ExpertContactInfoInput>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  instagramAuthorized?: InputMaybe<Scalars['Boolean']>;
  instagramName?: InputMaybe<Scalars['String']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  niches?: InputMaybe<Array<InputMaybe<Niche>>>;
  notificationDelivery?: InputMaybe<NotificationDelivery>;
  notificationSchedule?: InputMaybe<NotificationSchedule>;
  onboardingDescription?: InputMaybe<Scalars['String']>;
  pets?: InputMaybe<Array<InputMaybe<Pets>>>;
  score?: InputMaybe<Scalars['String']>;
  socialAccounts?: InputMaybe<LinksInput>;
  storeApprovalStatus?: InputMaybe<ApprovalStatus>;
  termsOfServiceAccepted?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpsertPostArgs = {
  upsertPostInput: UpsertPostInput;
};


export type MutationUpsertSponsoredPostCampaignArgs = {
  upsertSponsoredPostCampaignInput?: InputMaybe<UpsertSponsoredPostCampaignInput>;
};

export enum Niche {
  BeautyCare = 'BEAUTY_CARE',
  BusinessFinance = 'BUSINESS_FINANCE',
  FashionStyle = 'FASHION_STYLE',
  FoodDrink = 'FOOD_DRINK',
  Gaming = 'GAMING',
  HealthWellness = 'HEALTH_WELLNESS',
  HomeGarden = 'HOME_GARDEN',
  KidsParenting = 'KIDS_PARENTING',
  Lifestyle = 'LIFESTYLE',
  Music = 'MUSIC',
  OutdoorsNature = 'OUTDOORS_NATURE',
  Pets = 'PETS',
  SportsFitness = 'SPORTS_FITNESS',
  Technology = 'TECHNOLOGY',
  Travel = 'TRAVEL'
}

export enum NotificationDelivery {
  EmailOnly = 'EMAIL_ONLY',
  SmsOnly = 'SMS_ONLY'
}

export enum NotificationSchedule {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export type OfferingCommissions = {
  maxValue?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['String']>;
};

export enum OnboardingStatus {
  CompanyInfo = 'COMPANY_INFO',
  Complete = 'COMPLETE',
  ContactInfo = 'CONTACT_INFO',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  DefaultCommissionDiscount = 'DEFAULT_COMMISSION_DISCOUNT',
  ExternalStoreInfo = 'EXTERNAL_STORE_INFO',
  New = 'NEW'
}

export type Partnership = {
  __typename?: 'Partnership';
  approvedAt?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandLogoUrl: Scalars['String'];
  brandName: Scalars['String'];
  commission?: Maybe<Commission>;
  creatorContactEmail: Scalars['String'];
  creatorContactFirstName: Scalars['String'];
  creatorContactLastName: Scalars['String'];
  creatorId: Scalars['String'];
  creatorInstagram: Scalars['String'];
  creatorName: Scalars['String'];
  creatorTheme: Scalars['String'];
  discount?: Maybe<Discount>;
  id: Scalars['String'];
  isAssociate?: Maybe<Scalars['Boolean']>;
  metaData?: Maybe<PartnershipMetaData>;
  partnershipStatus: PartnershipStatus;
  rejectedAt?: Maybe<Scalars['String']>;
  requestNotes?: Maybe<Scalars['String']>;
  requestedAt?: Maybe<Scalars['String']>;
};

export type PartnershipMetaData = {
  __typename?: 'PartnershipMetaData';
  asin?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export enum PartnershipStatus {
  ApplyToSell = 'APPLY_TO_SELL',
  Approved = 'APPROVED',
  Enabled = 'ENABLED',
  Hidden = 'HIDDEN',
  PendingApproval = 'PENDING_APPROVAL',
  Prequalified = 'PREQUALIFIED',
  Rejected = 'REJECTED'
}

export enum Pets {
  Cat = 'CAT',
  Dog = 'DOG',
  NoPets = 'NO_PETS',
  Other = 'OTHER'
}

export type PortalExpert = {
  __typename?: 'PortalExpert';
  address?: Maybe<Address>;
  amzAssociateEnabled: Scalars['Boolean'];
  amzAssociateTag?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  brexVendorId?: Maybe<Scalars['String']>;
  contactInfo: ExpertContactInfo;
  createdAt: Scalars['String'];
  hasBrexPayment: Scalars['Boolean'];
  id: Scalars['String'];
  instagramAuthorized: Scalars['Boolean'];
  instagramName: Scalars['String'];
  isAssociateEnabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  score?: Maybe<Scalars['String']>;
  socialMedia?: Maybe<SocialMediaLinks>;
  storeApprovalStatus: ApprovalStatus;
  storeApprovedAt: Scalars['String'];
  theme: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Product = {
  __typename?: 'Product';
  affiliateSubType?: Maybe<AffiliateSubType>;
  amazonBuyBox?: Maybe<AmazonBuyBox>;
  associateCommission?: Maybe<AssociateProductCommission>;
  brandDescription?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandLogoUrl: Scalars['String'];
  brandName: Scalars['String'];
  brandShippingSourceCountry: Scalars['String'];
  brandSlug?: Maybe<Scalars['String']>;
  brandType?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Category>>;
  commission?: Maybe<Commission>;
  couponType?: Maybe<Scalars['String']>;
  couponVal?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discount?: Maybe<Discount>;
  expertName: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  isDigital?: Maybe<Scalars['Boolean']>;
  isVisibleInStore?: Maybe<Scalars['Boolean']>;
  landerMedia?: Maybe<Array<Media>>;
  media: Array<Media>;
  name?: Maybe<Scalars['String']>;
  outlink: Scalars['String'];
  outlinkDiscountCode?: Maybe<Scalars['String']>;
  partnershipStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  requiresApproval?: Maybe<Scalars['Boolean']>;
  returnPolicy: Scalars['String'];
  reviewSummary?: Maybe<ReviewSummary>;
  reviews?: Maybe<Array<Review>>;
  setSize: Scalars['Int'];
  shoppingType: Scalars['String'];
  shortBlurb: Scalars['String'];
  shortlink?: Maybe<Scalars['String']>;
  supportEmail: Scalars['String'];
  variants?: Maybe<Array<ProductVariant>>;
  viewAllLinks?: Maybe<Array<Maybe<ViewAllLinks>>>;
};

export type ProductCategories = {
  __typename?: 'ProductCategories';
  amazonCategoryId: Scalars['String'];
  children: Array<ProductCategories>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProductCategoriesResponse = {
  __typename?: 'ProductCategoriesResponse';
  categories: Array<ProductCategories>;
};

export type ProductCommission = {
  __typename?: 'ProductCommission';
  commission?: Maybe<Commission>;
  monetizationRate?: Maybe<Scalars['String']>;
  product: BaseProduct;
  reducedCommission?: Maybe<Commission>;
  unreducedCommission?: Maybe<Commission>;
};

export type ProductDetails = {
  __typename?: 'ProductDetails';
  brandName?: Maybe<Scalars['String']>;
  numberOfProducts?: Maybe<Scalars['Int']>;
  sellerId?: Maybe<Scalars['String']>;
};

export type ProductForBrand = {
  __typename?: 'ProductForBrand';
  brandId: Scalars['String'];
  brandName: Scalars['String'];
  createdAt: Scalars['String'];
  creatorStoresNum: Scalars['Int'];
  externalId: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type ProductId = {
  __typename?: 'ProductId';
  externalId: Scalars['String'];
  id: Scalars['String'];
  shoppingType: Scalars['String'];
};

export type ProductListing = {
  __typename?: 'ProductListing';
  brand?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  priceCurrency?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductMeta = {
  __typename?: 'ProductMeta';
  brandId?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  externalProductId?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAssociateActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type ProductOffer = {
  __typename?: 'ProductOffer';
  affiliateSubType: AffiliateSubType;
  product: ProductListing;
  url: Scalars['String'];
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  asin: Scalars['String'];
  price: Scalars['String'];
  productId: Scalars['String'];
};

export type ProductShareLink = {
  __typename?: 'ProductShareLink';
  link: Scalars['String'];
};

export type ProductSyncStatus = {
  __typename?: 'ProductSyncStatus';
  syncComplete: Scalars['Boolean'];
  syncedProducts: Scalars['Int'];
  totalProducts: Scalars['Int'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  externalId: Scalars['String'];
  id: Scalars['String'];
  media?: Maybe<Media>;
  options: Array<VariantOption>;
  outlink: Scalars['String'];
  price?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  checkInvitation?: Maybe<CheckInvitationResp>;
  emitAnalyticsEvent?: Maybe<Scalars['Boolean']>;
  expertAmazonLinkSources?: Maybe<Array<Maybe<ExpertAmazonSources>>>;
  getAccStatus?: Maybe<Scalars['Boolean']>;
  getAffiliateMonetizations: AffiliateMonetizationsResponse;
  getAffiliateTags: AffiliateTagsResponse;
  getAmazonAdsSyncStatus: AmazonAdsJobStatus;
  getAmazonPrices: GetAmazonPricesResponse;
  getAmazonProducts?: Maybe<AmazonProductsResp>;
  getAmazonStorefront?: Maybe<AmazonStorefront>;
  getAsinExpertPrivateAssociateCommissions?: Maybe<ExpertAsinProductsResp>;
  getAsinExpertPrivateCommissions?: Maybe<ExpertAsinProductsResp>;
  getBillingSubscription?: Maybe<GetSubscriptionResponse>;
  getBioLinks: GetBioLinksResponse;
  getBrand: BrandInfo;
  getBrandByCheckoutSessionId?: Maybe<GetBrandByCheckoutSessionIdResponse>;
  getBrandCommissions: Array<BrandCommission>;
  getBrandOrders: Array<BrandOrder>;
  getBrandProducts: BrandProductsResponse;
  getBrandProductsForBrand: BrandProductsForBrandResponse;
  getBrandProductsForConsumer: GetBrandProductsForConsumerResponse;
  getBrandStorefrontsForCreator?: Maybe<GetStorefrontsResponse>;
  getBrandUser?: Maybe<GetBrandUserResp>;
  getBrands: Array<BrandSearchResponse>;
  getBrandsForCreator?: Maybe<Array<Maybe<ListBrandCreator>>>;
  getCategories: ProductCategoriesResponse;
  getCategoryFullPath: GetCategoryFullPathResponse;
  getCollection: Collection;
  getCommissions: Array<ProductCommission>;
  getCreatorConnection?: Maybe<UpsertResp>;
  getCreatorOrders: Array<CreatorOrder>;
  getCreatorSocialMediaStats: CreatorSocialMediaStats;
  getCreatorsForApproval: ExpertsByApprovalStatus;
  getCreatorsForBrand: Array<CreatorForBrand>;
  getDiscountsByCode: Array<Discount>;
  getDownloadReportStatus?: Maybe<DownloadReportRequestRes>;
  getExpert: Expert;
  getExpertForPortal: PortalExpert;
  getExpertPrivateAssociateCommissions?: Maybe<ExpertProductsResp>;
  getExpertPrivateCommissions?: Maybe<ExpertProductsResp>;
  getMedia: Array<Media>;
  getMediaUploadUrl: MediaUploadUrl;
  getOrdersByCustomer: GetOrdersByCustomerResponse;
  getPartnerships?: Maybe<Array<Maybe<Partnership>>>;
  getPost: Collection;
  getProduct: BaseProduct;
  getProductDetails: Product;
  getProductIdsForExpert: Array<ProductId>;
  getProductSyncStatus: ProductSyncStatus;
  getProducts: Array<Product>;
  getRecentlyUpdatedProducts: Array<UpdatedProduct>;
  getRecommendedProducts: Array<Product>;
  getShortlinkBySlug: Shortlink;
  getStorefrontLinkSourcesForExpert?: Maybe<GetStorefrontLinkSourcesForExpertResponse>;
  getStorefrontsForBrand?: Maybe<GetStorefrontsResponse>;
  getStripeBilling?: Maybe<GetBillingResp>;
  getUploadRequestStatus?: Maybe<UploadRequestRes>;
  listAmazonBrandFilterItems?: Maybe<Array<Maybe<ListAmazonBrand>>>;
  listAmazonBrandItems?: Maybe<ListAmazonBrandsResp>;
  listAmazonStorefrontCollections: Array<Collection>;
  listBrandNames?: Maybe<Array<Maybe<ListBrandsResponse>>>;
  listBrands?: Maybe<ListBrandsResp>;
  listCollections: Array<Collection>;
  listCreatorConnections?: Maybe<Array<Maybe<UpsertResp>>>;
  listCustomers: ListCustomerResponse;
  listEnrolledSponsoredPostCampaigns: Array<SponsoredPostCampaign>;
  listOrgUsers?: Maybe<ListUsersResp>;
  listPosts: Array<Collection>;
  listRecommendations: Array<Slate>;
  listSponsoredPostCampaigns: Array<SponsoredPostCampaign>;
  listSponsoredPosts: Array<SponsoredPost>;
  listSponsoredPostsForCampaign: Array<SponsoredPost>;
  listStoresWithProducts: Array<Store>;
  listUserBrands?: Maybe<Array<Maybe<ListUserBrandsResp>>>;
  requestSample?: Maybe<RequestSampleResponse>;
  searchBrands: Array<BrandSearchResponse>;
  searchCreators: Array<CreatorForBrand>;
  searchProducts?: Maybe<SearchProductsResp>;
  searchProductsAndBrandsForShopper: ShopperSearchResponse;
  searchProductsForCreator: SearchProductResponse;
  sendMessageToBrand?: Maybe<Scalars['Boolean']>;
  sendMessageToCreator?: Maybe<Scalars['Boolean']>;
  viewCarouselItems?: Maybe<Array<Maybe<Carousel>>>;
  viewProductLinks?: Maybe<Array<Maybe<ViewAllLinks>>>;
};


export type QueryCheckInvitationArgs = {
  id: Scalars['String'];
};


export type QueryEmitAnalyticsEventArgs = {
  event: Scalars['String'];
  properties?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};


export type QueryExpertAmazonLinkSourcesArgs = {
  creatorId: Scalars['String'];
};


export type QueryGetAccStatusArgs = {
  brandId: Scalars['String'];
};


export type QueryGetAffiliateMonetizationsArgs = {
  creatorIds: Array<Scalars['String']>;
};


export type QueryGetAffiliateTagsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  subtypeFilter?: InputMaybe<AffiliateSubType>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetAmazonAdsSyncStatusArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAmazonPricesArgs = {
  asins?: InputMaybe<Array<Scalars['String']>>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetAmazonProductsArgs = {
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  associateFilter?: InputMaybe<OfferingCommissions>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  isAttributionActive?: InputMaybe<Scalars['Boolean']>;
  isConflicted?: InputMaybe<Scalars['Boolean']>;
  isInStock?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  sellerId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryGetAmazonStorefrontArgs = {
  creatorName: Scalars['String'];
};


export type QueryGetAsinExpertPrivateAssociateCommissionsArgs = {
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type QueryGetAsinExpertPrivateCommissionsArgs = {
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  associateFilter?: InputMaybe<OfferingCommissions>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBillingSubscriptionArgs = {
  brandId: Scalars['String'];
};


export type QueryGetBioLinksArgs = {
  creatorName: Scalars['String'];
};


export type QueryGetBrandArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  externalStore?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandByCheckoutSessionIdArgs = {
  checkoutSessionId: Scalars['String'];
};


export type QueryGetBrandCommissionsArgs = {
  brandNames: Array<Scalars['String']>;
  expertName: Scalars['String'];
};


export type QueryGetBrandOrdersArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  externalStore?: InputMaybe<Scalars['String']>;
  startKey?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandProductsArgs = {
  creatorId?: InputMaybe<Scalars['String']>;
  filterOptions?: InputMaybe<BrandProductsForCreatorFilters>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sortCriteria?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandProductsForBrandArgs = {
  brandSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActiveFilter?: InputMaybe<IsActiveFilter>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetBrandProductsForConsumerArgs = {
  brandSlug: Scalars['String'];
  creatorName: Scalars['String'];
};


export type QueryGetBrandStorefrontsForCreatorArgs = {
  abstractBrandId: Scalars['String'];
  expertId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandUserArgs = {
  brandId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandsArgs = {
  brandIds: Array<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBrandsForCreatorArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  includeNonAmazon?: InputMaybe<Scalars['Boolean']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCategoriesArgs = {
  includeInvisible?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCategoryFullPathArgs = {
  categoryIds: Array<Scalars['String']>;
};


export type QueryGetCollectionArgs = {
  collectionId: Scalars['String'];
};


export type QueryGetCommissionsArgs = {
  expertName: Scalars['String'];
  externalProductIds: Array<Scalars['String']>;
};


export type QueryGetCreatorConnectionArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetCreatorOrdersArgs = {
  creatorId?: InputMaybe<Scalars['String']>;
  expertName?: InputMaybe<Scalars['String']>;
  startKey?: InputMaybe<Scalars['String']>;
};


export type QueryGetCreatorSocialMediaStatsArgs = {
  creatorId: Scalars['String'];
};


export type QueryGetCreatorsForApprovalArgs = {
  pageNumber: Scalars['Int'];
  storeApprovalStatus: ApprovalStatus;
};


export type QueryGetCreatorsForBrandArgs = {
  allBrands?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Array<Scalars['String']>>;
  childrenFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  genderFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isActiveFilter: IsActiveFilter;
  isAssociateDisabled?: InputMaybe<Scalars['Boolean']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  isEligibleForAssociates?: InputMaybe<Scalars['Boolean']>;
  nichesFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  onlyStoresWithBrandProducts: Scalars['Boolean'];
  page?: InputMaybe<Scalars['Int']>;
  petsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scoreFilter?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryGetDiscountsByCodeArgs = {
  discountCodes: Array<Scalars['String']>;
};


export type QueryGetDownloadReportStatusArgs = {
  reportId?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpertArgs = {
  expertName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  instagramName?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpertForPortalArgs = {
  expertName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpertPrivateAssociateCommissionsArgs = {
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creatorId: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  sellerId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryGetExpertPrivateCommissionsArgs = {
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  associateFilter?: InputMaybe<OfferingCommissions>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creatorId: Scalars['String'];
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  sellerId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryGetMediaArgs = {
  expertName: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};


export type QueryGetMediaUploadUrlArgs = {
  expertName?: InputMaybe<Scalars['String']>;
  fileSize: Scalars['Int'];
  fileType: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetOrdersByCustomerArgs = {
  creatorId: Scalars['String'];
  customerEmail: Scalars['String'];
};


export type QueryGetPartnershipsArgs = {
  brandId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  partnershipStatusFilter?: InputMaybe<PartnershipStatus>;
};


export type QueryGetPostArgs = {
  postId: Scalars['String'];
};


export type QueryGetProductArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductDetailsArgs = {
  creatorName: Scalars['String'];
  isPreview?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
};


export type QueryGetProductIdsForExpertArgs = {
  expertName: Scalars['String'];
  isStoreVisibleFilter?: InputMaybe<IsStoreVisibleFilter>;
};


export type QueryGetProductSyncStatusArgs = {
  brandId: Scalars['String'];
};


export type QueryGetProductsArgs = {
  expertName: Scalars['String'];
  externalProductIds?: InputMaybe<Array<Scalars['String']>>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
  isStoreVisibleFilter?: InputMaybe<IsStoreVisibleFilter>;
  productIds: Array<Scalars['String']>;
};


export type QueryGetRecentlyUpdatedProductsArgs = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page: Scalars['Int'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedSince: Scalars['String'];
};


export type QueryGetRecommendedProductsArgs = {
  creatorId: Scalars['String'];
};


export type QueryGetShortlinkBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetStorefrontLinkSourcesForExpertArgs = {
  expertId: Scalars['String'];
};


export type QueryGetStorefrontsForBrandArgs = {
  abstractBrandId: Scalars['String'];
};


export type QueryGetStripeBillingArgs = {
  brandId: Scalars['String'];
};


export type QueryGetUploadRequestStatusArgs = {
  reportId?: InputMaybe<Scalars['String']>;
};


export type QueryListAmazonBrandFilterItemsArgs = {
  brandId: Scalars['String'];
  includeNonAmazon?: InputMaybe<Scalars['Boolean']>;
};


export type QueryListAmazonBrandItemsArgs = {
  brandId: Scalars['String'];
  childBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  isAttributionActive?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryListAmazonStorefrontCollectionsArgs = {
  creatorName: Scalars['String'];
};


export type QueryListBrandNamesArgs = {
  carouselId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryListBrandsArgs = {
  brandType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAttribution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  relationshipStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QueryListCollectionsArgs = {
  expertName: Scalars['String'];
};


export type QueryListCreatorConnectionsArgs = {
  brandId?: InputMaybe<Scalars['String']>;
};


export type QueryListCustomersArgs = {
  creatorId: Scalars['String'];
  startKey?: InputMaybe<Scalars['String']>;
};


export type QueryListEnrolledSponsoredPostCampaignsArgs = {
  creatorId: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryListOrgUsersArgs = {
  brandId: Scalars['String'];
};


export type QueryListPostsArgs = {
  creatorName: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryListRecommendationsArgs = {
  context: RecommendationContext;
  creatorId: Scalars['String'];
};


export type QueryListSponsoredPostCampaignsArgs = {
  brandId: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryListSponsoredPostsArgs = {
  creatorId: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryListSponsoredPostsForCampaignArgs = {
  campaignId: Scalars['String'];
  page: Scalars['Int'];
};


export type QueryListStoresWithProductsArgs = {
  page: Scalars['Int'];
};


export type QueryListUserBrandsArgs = {
  brandId?: InputMaybe<Scalars['String']>;
};


export type QueryRequestSampleArgs = {
  input: RequestSampleInput;
};


export type QuerySearchBrandsArgs = {
  creatorId?: InputMaybe<Scalars['String']>;
  includeHybrid?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type QuerySearchCreatorsArgs = {
  brandId: Scalars['String'];
  name: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QuerySearchProductsArgs = {
  avgRating?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  deal?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAttribution?: InputMaybe<Scalars['Boolean']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type QuerySearchProductsAndBrandsForShopperArgs = {
  creatorName: Scalars['String'];
  page: Scalars['Int'];
  query: Scalars['String'];
};


export type QuerySearchProductsForCreatorArgs = {
  combineInternalProducts?: InputMaybe<Scalars['Boolean']>;
  creatorId: Scalars['String'];
  filterOptions?: InputMaybe<SearchProductsForCreatorFilterOptions>;
  page: Scalars['Int'];
  query: Scalars['String'];
  sortCriteria?: InputMaybe<SearchProductsForCreatorSortCriteria>;
};


export type QuerySendMessageToBrandArgs = {
  brand_email?: InputMaybe<Scalars['String']>;
  brand_id: Scalars['String'];
  creator_email?: InputMaybe<Scalars['String']>;
  creator_id: Scalars['String'];
  creator_name: Scalars['String'];
  message: Scalars['String'];
};


export type QuerySendMessageToCreatorArgs = {
  brand_email?: InputMaybe<Scalars['String']>;
  brand_first_name: Scalars['String'];
  brand_id: Scalars['String'];
  brand_name: Scalars['String'];
  creator_email?: InputMaybe<Scalars['String']>;
  creator_id: Scalars['String'];
  message: Scalars['String'];
};


export type QueryViewCarouselItemsArgs = {
  carouselId?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryViewProductLinksArgs = {
  creatorId: Scalars['String'];
  productId: Scalars['String'];
};

export type RatingSum = {
  __typename?: 'RatingSum';
  count: Scalars['Int'];
  rating: Scalars['Int'];
};

export enum RecommendationContext {
  Dashboard = 'DASHBOARD',
  Products = 'PRODUCTS'
}

export type RequestSampleInput = {
  city: Scalars['String'];
  creator_id: Scalars['String'];
  creator_name: Scalars['String'];
  facebook_handle?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  instagram_handle?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mailing_address: Scalars['String'];
  mailing_address_2?: InputMaybe<Scalars['String']>;
  mailing_address_first_name: Scalars['String'];
  mailing_address_last_name: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  pinterest_handle?: InputMaybe<Scalars['String']>;
  product_id: Scalars['String'];
  product_title?: InputMaybe<Scalars['String']>;
  product_type: Scalars['String'];
  replyAddress: Scalars['String'];
  state: Scalars['String'];
  subscriberKey: Scalars['String'];
  threads_handle?: InputMaybe<Scalars['String']>;
  tiktok_handle?: InputMaybe<Scalars['String']>;
  twitter_handle?: InputMaybe<Scalars['String']>;
  youtube_handle?: InputMaybe<Scalars['String']>;
  zip_code: Scalars['String'];
};

export type RequestSampleResponse = {
  __typename?: 'RequestSampleResponse';
  success: Scalars['Boolean'];
};

export type Review = {
  __typename?: 'Review';
  author: Scalars['String'];
  body: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  media: Array<Media>;
  rating: Scalars['Int'];
  title: Scalars['String'];
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  id: Scalars['String'];
  media: Array<Media>;
  ratingAverage: Scalars['Float'];
  ratingSum: Array<RatingSum>;
  reviewCount: Scalars['Int'];
};

export type SearchBrand = {
  __typename?: 'SearchBrand';
  brandId: Scalars['String'];
  brandLogoUrl: Scalars['String'];
  brandName: Scalars['String'];
  brandSlug: Scalars['String'];
};

export type SearchProduct = {
  __typename?: 'SearchProduct';
  defaultBrandCommission?: Maybe<Commission>;
  defaultBrandDiscount?: Maybe<Discount>;
  partnershipStatus?: Maybe<PartnershipStatus>;
  product: Product;
  requiresApproval?: Maybe<Scalars['Boolean']>;
};

export type SearchProductResponse = {
  __typename?: 'SearchProductResponse';
  affiliateProducts?: Maybe<Array<Maybe<SearchProduct>>>;
  isLinkSearch?: Maybe<Scalars['Boolean']>;
  marketplaceProducts?: Maybe<Array<Maybe<MarketplaceProductSearchResults>>>;
  productCount?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<SearchProduct>>>;
};

export type SearchProductsData = {
  __typename?: 'SearchProductsData';
  amazonBuyBox?: Maybe<AmazonBuyBox>;
  assnRequiresApproval?: Maybe<Scalars['Boolean']>;
  associateCommission?: Maybe<AssociateProductCommission>;
  associatePartnershipStatus?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['String']>;
  brandIsActive?: Maybe<Scalars['Boolean']>;
  brandIsAssnEnabled?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Array<Maybe<Scalars['String']>>>;
  commission?: Maybe<Commission>;
  couponType?: Maybe<Scalars['String']>;
  couponVal?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  externalProductId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isAssociate?: Maybe<Scalars['Boolean']>;
  isAttribution?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  outlink?: Maybe<Scalars['String']>;
  partnershipStatus?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  requiresApproval?: Maybe<Scalars['Boolean']>;
  viewAllLinks?: Maybe<Array<Maybe<ViewAllLinks>>>;
};

export type SearchProductsForCreatorFilterOptions = {
  availability?: InputMaybe<Scalars['String']>;
  brandName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  carouselId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<Scalars['String']>;
  deal?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['String']>;
  includeAmazonProducts: Scalars['Boolean'];
  includeWaywardProducts: Scalars['Boolean'];
  isParent?: InputMaybe<Scalars['Boolean']>;
  maxPrice?: InputMaybe<Scalars['String']>;
  minPrice?: InputMaybe<Scalars['String']>;
  partnership?: InputMaybe<PartnershipStatus>;
  rating?: InputMaybe<Scalars['String']>;
};

export enum SearchProductsForCreatorSortCriteria {
  Bestseller = 'BESTSELLER',
  CommissionDollar = 'COMMISSION_DOLLAR',
  CommissionPercent = 'COMMISSION_PERCENT',
  DiscountAsc = 'DISCOUNT_ASC',
  DiscountDesc = 'DISCOUNT_DESC',
  GrossMerchandiseValue = 'GROSS_MERCHANDISE_VALUE',
  HighestEarning = 'HIGHEST_EARNING',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Newest = 'NEWEST',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Ratings = 'RATINGS',
  Relevance = 'RELEVANCE',
  TotalDiscount = 'TOTAL_DISCOUNT',
  Wayward = 'WAYWARD'
}

export type SearchProductsResp = {
  __typename?: 'SearchProductsResp';
  creatorId?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  products?: Maybe<Array<Maybe<SearchProductsData>>>;
};

export type SellerProfiles = {
  __typename?: 'SellerProfiles';
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  newSync?: Maybe<Scalars['Boolean']>;
  sellerId?: Maybe<Scalars['String']>;
  syncOverLap?: Maybe<Scalars['Boolean']>;
  syncOverlapSameBrand?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type SetBillingResp = {
  __typename?: 'SetBillingResp';
  clientSecret?: Maybe<Scalars['String']>;
};

export type SetSubscriptionResponse = {
  __typename?: 'SetSubscriptionResponse';
  error?: Maybe<Scalars['String']>;
  internalSubscriptionId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['String']>;
};

export type ShareLinksResponse = {
  __typename?: 'ShareLinksResponse';
  linkType?: Maybe<Scalars['String']>;
  shortLinkUrl?: Maybe<Scalars['String']>;
};

export type ShopperSearchResponse = {
  __typename?: 'ShopperSearchResponse';
  brands: Array<SearchBrand>;
  products: Array<SearchProduct>;
};

export enum ShoppingType {
  Affiliate = 'AFFILIATE',
  FirstParty = 'FIRST_PARTY',
  Full = 'FULL',
  Partial = 'PARTIAL',
  Synthetic = 'SYNTHETIC'
}

export type Shortlink = {
  __typename?: 'Shortlink';
  createdAt: Scalars['String'];
  data: Scalars['String'];
  id: Scalars['String'];
  linkType: LinkType;
  slug: Scalars['String'];
};

export type Slate = {
  __typename?: 'Slate';
  description: Scalars['String'];
  id: Scalars['String'];
  productIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export enum SocialMediaChannel {
  InstagramReel = 'INSTAGRAM_REEL',
  Tiktok = 'TIKTOK'
}

export type SocialMediaLinks = {
  __typename?: 'SocialMediaLinks';
  facebookName?: Maybe<Scalars['String']>;
  instagramName?: Maybe<Scalars['String']>;
  pinterestName?: Maybe<Scalars['String']>;
  threadsName?: Maybe<Scalars['String']>;
  tiktokName?: Maybe<Scalars['String']>;
  twitterName?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtubeName?: Maybe<Scalars['String']>;
};

export type SponsoredPost = {
  __typename?: 'SponsoredPost';
  campaignId: Scalars['String'];
  earnings: Scalars['String'];
  mediaCreatedAt: Scalars['String'];
  mediaLink: Scalars['String'];
  postId: Scalars['String'];
  postLiveForRequiredDuration: Scalars['Boolean'];
  productIds: Array<Scalars['String']>;
  rejectionReason?: Maybe<Scalars['String']>;
  requirementsVerified: Scalars['Boolean'];
  socialMediaType: SocialMediaChannel;
  status: Scalars['String'];
  viewCount: Scalars['Int'];
  viewCountEndTime?: Maybe<Scalars['String']>;
};

export type SponsoredPostCampaign = {
  __typename?: 'SponsoredPostCampaign';
  allProductsEnabled: Scalars['Boolean'];
  brandContentRequirements?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  campaignId: Scalars['String'];
  contentSuggestions?: Maybe<Scalars['String']>;
  costPerView: Array<CostPerView>;
  description?: Maybe<Scalars['String']>;
  eligibleProductIds?: Maybe<Array<Scalars['String']>>;
  exampleMediaUrls?: Maybe<Array<Scalars['String']>>;
  instagramHandle?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  maxBudgetPerPost: Scalars['String'];
  maxPostsPerCreatorPerMonth: Scalars['Int'];
  monthlyBudget: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  socialMediaChannels: Array<SocialMediaChannel>;
  tiktokHandle?: Maybe<Scalars['String']>;
};

export type Store = {
  __typename?: 'Store';
  creatorId: Scalars['String'];
  creatorName: Scalars['String'];
};

export type Storefront = {
  __typename?: 'Storefront';
  pages?: Maybe<Array<StorefrontPage>>;
  store_name: Scalars['String'];
};

export type StorefrontLinkSource = {
  __typename?: 'StorefrontLinkSource';
  amzAssociateTag?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  primaryTrackingId?: Maybe<Scalars['String']>;
  sourceName: Scalars['String'];
  subTrackingId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type StorefrontPage = {
  __typename?: 'StorefrontPage';
  is_active?: Maybe<Scalars['Boolean']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<Maybe<StorefrontPageLink>>>;
  store_page_id: Scalars['String'];
  store_page_name: Scalars['String'];
  store_page_url: Scalars['String'];
};

export type StorefrontPageLink = {
  __typename?: 'StorefrontPageLink';
  generated_link?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  meta_data?: Maybe<Scalars['String']>;
  shortlink_id?: Maybe<Scalars['String']>;
  shortlink_slug?: Maybe<Scalars['String']>;
  source_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type SyntheticProductInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  variants: Array<VariantForSyntheticInput>;
};

export type UnMergeBrandsFromAbstractBrandResponse = {
  __typename?: 'UnMergeBrandsFromAbstractBrandResponse';
  brandId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateBrandPartnerships = {
  brandId?: InputMaybe<Scalars['String']>;
  isAssociateDisabled?: InputMaybe<Scalars['Boolean']>;
  isAttributionDisabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateBrandStorefrontPageArgs = {
  isActive: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  storePageId: Scalars['String'];
};

export type UpdateCreatorProductArgs = {
  creatorId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  discountCode?: InputMaybe<Scalars['String']>;
  isVisibleInStore?: InputMaybe<Scalars['Boolean']>;
  landerMediaIds?: InputMaybe<Array<Scalars['String']>>;
  mediaIds?: InputMaybe<Array<Scalars['String']>>;
  productId: Scalars['String'];
};

export type UpdatedProduct = {
  __typename?: 'UpdatedProduct';
  availability?: Maybe<Scalars['String']>;
  avgRating?: Maybe<Scalars['String']>;
  bestSellerRank?: Maybe<Scalars['String']>;
  brandId: Scalars['String'];
  brandIsActive?: Maybe<Scalars['Boolean']>;
  brandIsAssociateEnabled?: Maybe<Scalars['Boolean']>;
  brandIsDeleted?: Maybe<Scalars['Boolean']>;
  brandName: Scalars['String'];
  brandType?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Category>>;
  couponType?: Maybe<Scalars['String']>;
  couponValue?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
  isAssociateEnabled?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isEnabledByUser?: Maybe<Scalars['Boolean']>;
  isParent?: Maybe<Scalars['Boolean']>;
  listPrice?: Maybe<Scalars['String']>;
  parentAsin?: Maybe<Scalars['String']>;
  perDiscount?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  productName: Scalars['String'];
  termsOfServiceAccepted?: Maybe<Scalars['Boolean']>;
  totalReviews?: Maybe<Scalars['Int']>;
};

export type UploadFieldRes = {
  __typename?: 'UploadFieldRes';
  currentValue?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
};

export type UploadRequestParameters = {
  brandId?: InputMaybe<Scalars['String']>;
  expertId?: InputMaybe<Scalars['String']>;
};

export type UploadRequestRes = {
  __typename?: 'UploadRequestRes';
  reportId: Scalars['String'];
  reportType: Scalars['String'];
  status: Scalars['String'];
  summary?: Maybe<UploadSummaryRes>;
  url?: Maybe<Scalars['String']>;
};

export type UploadResultRes = {
  __typename?: 'UploadResultRes';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UploadRowDataRes = {
  __typename?: 'UploadRowDataRes';
  fields?: Maybe<Array<Maybe<UploadFieldRes>>>;
  key?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  rowNum?: Maybe<Scalars['Int']>;
};

export type UploadSummaryRes = {
  __typename?: 'UploadSummaryRes';
  errorData?: Maybe<Array<Maybe<UploadRowDataRes>>>;
  message?: Maybe<Scalars['String']>;
  processedRows?: Maybe<Scalars['Int']>;
  successData?: Maybe<Array<Maybe<UploadRowDataRes>>>;
  totalErrorRows?: Maybe<Scalars['Int']>;
  totalRows?: Maybe<Scalars['Int']>;
  totalSuccessRows?: Maybe<Scalars['Int']>;
};

export type UpsertAmazonStorefrontInput = {
  amazonId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  numCollections?: InputMaybe<Scalars['Int']>;
  numPosts?: InputMaybe<Scalars['Int']>;
  numProducts?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpsertBioLinkInput = {
  bioLinkId?: InputMaybe<Scalars['String']>;
  creatorId: Scalars['String'];
  data?: InputMaybe<Scalars['String']>;
  linkType?: InputMaybe<BioLinkType>;
};

export type UpsertCollectionInput = {
  bannerImageUrl?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayInHomePage?: InputMaybe<Scalars['Boolean']>;
  displayInNavigation?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  storefrontId?: InputMaybe<Scalars['String']>;
};

export type UpsertPostInput = {
  creatorId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayInHomePage?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  postId?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<Scalars['String']>>;
  storefrontId?: InputMaybe<Scalars['String']>;
};

export type UpsertResp = {
  __typename?: 'UpsertResp';
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inviteEmail?: Maybe<Scalars['String']>;
  merchantToken?: Maybe<Scalars['String']>;
  status?: Maybe<CrawlStatus>;
};

export type UpsertSponsoredPostCampaignInput = {
  allProductsEnabled?: InputMaybe<Scalars['Boolean']>;
  brandContentRequirements?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['String']>;
  campaignId?: InputMaybe<Scalars['String']>;
  contentSuggestions?: InputMaybe<Scalars['String']>;
  costPerView?: InputMaybe<Array<CostPerViewInput>>;
  description?: InputMaybe<Scalars['String']>;
  eligibleProductIds?: InputMaybe<Array<Scalars['String']>>;
  exampleMediaUrls?: InputMaybe<Array<Scalars['String']>>;
  instagramHandle?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  maxBudgetPerPost?: InputMaybe<Scalars['String']>;
  maxPostsPerCreatorPerMonth?: InputMaybe<Scalars['Int']>;
  monthlyBudget?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  socialMediaChannels?: InputMaybe<Array<SocialMediaChannel>>;
  tiktokHandle?: InputMaybe<Scalars['String']>;
};

export type VariantForSyntheticInput = {
  externalProductId: Scalars['String'];
  options: Array<VariantOptionInput>;
};

export type VariantOption = {
  __typename?: 'VariantOption';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type VariantOptionInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ViewAllLinks = {
  __typename?: 'ViewAllLinks';
  amzAssociateId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  primaryTrackingId?: Maybe<Scalars['String']>;
  shortlinkId?: Maybe<Scalars['String']>;
  shortlinkUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  subTrackingId?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ExpertAmazonAssociateTagMutationVariables = Exact<{
  creatorId: Scalars['String'];
  amzAssociateTag: Scalars['String'];
  amzAssociateEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExpertAmazonAssociateTagMutation = { __typename?: 'Mutation', expertAmazonAssociateTag: boolean };

export type AddProductToExpertMutationVariables = Exact<{
  expertId: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  externalProductId?: InputMaybe<Scalars['String']>;
}>;


export type AddProductToExpertMutation = { __typename?: 'Mutation', addProductToExpert: boolean };

export type AmazonStorefrontFieldsFragment = { __typename?: 'AmazonStorefront', id: string, creatorId: string, url: string, amazonId: string, status: string, isActive: boolean, numCollections?: number | null, numPosts?: number | null, numProducts?: number | null };

export type BaseProductFieldsFragment = { __typename?: 'Product', id: string, brandName: string, expertName: string, externalId: string, name?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, brandLogoUrl: string, brandShippingSourceCountry: string, shoppingType: string, affiliateSubType?: AffiliateSubType | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }> };

export type BrandResponseFieldsFragment = { __typename?: 'BrandSearchResponse', id: string, name: string, logoUrl: string, requiresApproval: boolean, partnershipStatus?: PartnershipStatus | null, approvedAt?: string | null, rejectedAt?: string | null, integrationType?: BrandIntegrationType | null, brandType?: string | null, avgCommission?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null };

export type BulkAddProductToStoreAndCreateShareLinkMutationVariables = Exact<{
  creatorId: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkAddProductToStoreAndCreateShareLinkMutation = { __typename?: 'Mutation', bulkAddProductToStoreAndCreateShareLink: Array<{ __typename?: 'ProductShareLink', link: string }> };

export type CollectionFieldsFragment = { __typename?: 'Collection', id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null };

export type CreateBrandUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CreateBrandUserMutation = { __typename?: 'Mutation', createBrandUser: boolean };

export type CreateCreatorMediaMutationVariables = Exact<{
  creatorId: Scalars['String'];
  url: Scalars['String'];
}>;


export type CreateCreatorMediaMutation = { __typename?: 'Mutation', createCreatorMedia: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string } };

export type GetApiKeyMutationVariables = Exact<{
  creatorId: Scalars['String'];
  createKey?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetApiKeyMutation = { __typename?: 'Mutation', getAPIKey: string };

export type CreatorForBrandFieldsFragment = { __typename?: 'CreatorForBrand', creatorId: string, creatorName: string, creatorTheme?: string | null, storeEnabled: boolean, productsInStore: number, firstName?: string | null, lastName?: string | null, email?: string | null, bio?: string | null, niches?: Array<Niche> | null, dateOfBirth?: string | null, gender?: Gender | null, children?: Array<Children> | null, pets?: Array<Pets> | null, score?: string | null, isEligibleForAssociates: boolean, amzStorefront?: string | null, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, brandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null, flags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateFlags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateBrandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null };

export type DeleteBioLinkMutationVariables = Exact<{
  creatorId: Scalars['String'];
  bioLinkId: Scalars['String'];
}>;


export type DeleteBioLinkMutation = { __typename?: 'Mutation', deleteBioLink: boolean };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: boolean };

export type DeleteCollectionMutationVariables = Exact<{
  creatorId: Scalars['String'];
  collectionId: Scalars['String'];
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection: boolean };

export type DiscountFieldsFragment = { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null };

export type EmitAnalyticsEventQueryVariables = Exact<{
  user_id: Scalars['String'];
  event: Scalars['String'];
  properties?: InputMaybe<Scalars['String']>;
}>;


export type EmitAnalyticsEventQuery = { __typename?: 'Query', emitAnalyticsEvent?: boolean | null };

export type GenerateProductShareLinkMutationVariables = Exact<{
  creatorId: Scalars['String'];
  productId: Scalars['String'];
  primaryTrackingId?: InputMaybe<Scalars['String']>;
  subTrackingId?: InputMaybe<Scalars['String']>;
  amzAssociateTag?: InputMaybe<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
}>;


export type GenerateProductShareLinkMutation = { __typename?: 'Mutation', generateProductShareLink?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null };

export type GenerateStorefrontPageLinkMutationVariables = Exact<{
  creatorId: Scalars['String'];
  abstractBrandId: Scalars['String'];
  storePageId: Scalars['String'];
  primaryTrackingId?: InputMaybe<Scalars['String']>;
  subTrackingId?: InputMaybe<Scalars['String']>;
  amzAssociateTag: Scalars['String'];
  sourceName?: InputMaybe<Scalars['String']>;
}>;


export type GenerateStorefrontPageLinkMutation = { __typename?: 'Mutation', generateStorefrontPageLink: { __typename?: 'GenerateStorefrontPageLinkResponse', link: string, linkId: string } };

export type GetAmazonAdsSyncStatusQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  requestId?: InputMaybe<Scalars['String']>;
}>;


export type GetAmazonAdsSyncStatusQuery = { __typename?: 'Query', getAmazonAdsSyncStatus: { __typename?: 'AmazonAdsJobStatus', brandId: string, requestId?: string | null, jobStatus: string, updatedAt?: string | null, brandExists?: boolean | null } };

export type ListAmazonBrandFilterItemsQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type ListAmazonBrandFilterItemsQuery = { __typename?: 'Query', listAmazonBrandFilterItems?: Array<{ __typename?: 'ListAmazonBrand', brandId?: string | null, brandName?: string | null, sellerAccount?: string | null } | null> | null };

export type GetAmazonPricesQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  asins?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetAmazonPricesQuery = { __typename?: 'Query', getAmazonPrices: { __typename?: 'GetAmazonPricesResponse', productPrices: Array<{ __typename?: 'ProductPrice', productId: string, price: string, asin: string }> } };

export type GetAmazonProductsQueryVariables = Exact<{
  brandId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
  isAttributionActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  isInStock?: InputMaybe<Scalars['Boolean']>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  associateFilter?: InputMaybe<OfferingCommissions>;
  isConflicted?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAmazonProductsQuery = { __typename?: 'Query', getAmazonProducts?: { __typename?: 'AmazonProductsResp', productCount?: number | null, products?: Array<{ __typename?: 'AmazonProducts', brandId?: string | null, imageUrl?: string | null, productId?: string | null, externalProductId?: string | null, name?: string | null, price?: string | null, bestSellerRank?: string | null, isActive?: boolean | null, brandName?: string | null, amzSellerId?: string | null, brandPlatform?: string | null, expertCount?: number | null, updatedAt?: string | null, creatorPromoted?: boolean | null, availability?: string | null, privateCommissions?: boolean | null, isAttributionActive?: boolean | null, isAssociateActive?: boolean | null, privateAssociate?: boolean | null, isConflicted?: boolean | null, commission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null } | null, associateCommission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null } | null } | null> | null } | null };

export type GetAmazonStorefrontQueryVariables = Exact<{
  creatorName: Scalars['String'];
}>;


export type GetAmazonStorefrontQuery = { __typename?: 'Query', getAmazonStorefront?: { __typename?: 'AmazonStorefront', id: string, creatorId: string, url: string, amazonId: string, status: string, isActive: boolean, numCollections?: number | null, numPosts?: number | null, numProducts?: number | null } | null };

export type GetAsinExpertPrivateCommissionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  associateFilter?: InputMaybe<OfferingCommissions>;
}>;


export type GetAsinExpertPrivateCommissionsQuery = { __typename?: 'Query', getAsinExpertPrivateCommissions?: { __typename?: 'ExpertAsinProductsResp', expertsCount?: number | null, experts?: Array<{ __typename?: 'ExpertAsinProducts', updatedAt?: string | null, creatorInfo?: { __typename?: 'CreatorForBrand', partnershipStatus?: PartnershipStatus | null, requestedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, creatorTheme?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, bio?: string | null, dateOfBirth?: string | null, gender?: Gender | null, score?: string | null, children?: Array<Children> | null, creatorId: string, creatorName: string, niches?: Array<Niche> | null, productsInStore: number, pets?: Array<Pets> | null, storeEnabled: boolean, brandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null, socialMedia?: { __typename?: 'SocialMediaLinks', facebookName?: string | null, instagramName?: string | null, tiktokName?: string | null, pinterestName?: string | null, threadsName?: string | null, twitterName?: string | null, website?: string | null, youtubeName?: string | null } | null, discount?: { __typename?: 'Discount', amountType: DiscountAmountType, amountValue: string, appliesOnEachItem: boolean, code: string, coverage: DiscountCoverage, displayStrikethrough: boolean, id: string, isBrandDefaultOrChild?: boolean | null, minimumOrderValue?: string | null, value: number } | null, commission?: { __typename?: 'Commission', amountType: CommissionAmountType, amountValue: string, coverage: CommissionCoverage, description: string, id: string, isBrandDefault?: boolean | null, name: string, value: number } | null } | null, productMeta?: { __typename?: 'ProductMeta', brandId?: string | null, brandName?: string | null, externalProductId?: string | null, name?: string | null, productId?: string | null, isActive?: boolean | null, isAssociateActive?: boolean | null } | null, productExpertCommission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null, coverage?: string | null, description?: string | null, id?: string | null, name?: string | null } | null, associateCommission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null, coverage?: string | null, description?: string | null, id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetAccStatusQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetAccStatusQuery = { __typename?: 'Query', getAccStatus?: boolean | null };

export type GetBillingSubscriptionQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetBillingSubscriptionQuery = { __typename?: 'Query', getBillingSubscription?: { __typename?: 'GetSubscriptionResponse', internalSubscriptionId?: string | null, status?: string | null } | null };

export type GetBioLinksQueryVariables = Exact<{
  creatorName: Scalars['String'];
}>;


export type GetBioLinksQuery = { __typename?: 'Query', getBioLinks: { __typename?: 'GetBioLinksResponse', links: Array<{ __typename?: 'BioLink', id: string, linkType: BioLinkType, data: string }> } };

export type GetBrandQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
}>;


export type GetBrandQuery = { __typename?: 'Query', getBrand: { __typename?: 'BrandInfo', id: string, bio?: string | null, isActive?: boolean | null, createdAt: string, termsOfServiceAccepted: boolean, hasBrexPayment: boolean, brexVendorId?: string | null, requiresApproval: boolean, createOrderTags: boolean, logoUrl?: string | null, slug?: string | null, onboardingStatus?: OnboardingStatus | null, brandPlatform: BrandPlatform, brandType?: string | null, productStatus?: boolean | null, featureFlag?: string | null, isDefaultHidden?: boolean | null, isDeleted?: boolean | null, requiresAssociatesApproval?: boolean | null, isAssociateActive?: boolean | null, associateProductStatus?: boolean | null, associateFeatureFlag?: string | null, isAssociateDefaultHidden?: boolean | null, onBoardingInfoClicked?: boolean | null, companyInfo?: { __typename?: 'CompanyInfo', name: string, website: string } | null, contactInfo?: { __typename?: 'ContactInfo', firstName: string, lastName: string, title: string, email: string, phone: string } | null, externalStoreInfo?: { __typename?: 'ExternalStoreInfo', externalStore: string, externalStoreView?: string | null } | null, defaultCommission?: { __typename?: 'Commission', amountType: CommissionAmountType, amountValue: string } | null, defaultDiscount?: { __typename?: 'Discount', amountType: DiscountAmountType, amountValue: string } | null, customerSupport?: { __typename?: 'CustomerSupport', returnPolicy: string, supportEmail: string } | null } };

export type GetBrandByCheckoutSessionIdQueryVariables = Exact<{
  checkoutSessionId: Scalars['String'];
}>;


export type GetBrandByCheckoutSessionIdQuery = { __typename?: 'Query', getBrandByCheckoutSessionId?: { __typename?: 'GetBrandByCheckoutSessionIdResponse', brandId?: string | null, status?: string | null } | null };

export type GetBrandsForCreatorQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  includeNonAmazon?: InputMaybe<Scalars['Boolean']>;
  creatorId?: InputMaybe<Scalars['String']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetBrandsForCreatorQuery = { __typename?: 'Query', getBrandsForCreator?: Array<{ __typename?: 'ListBrandCreator', brandId?: string | null, brandName?: string | null, sellerAccount?: string | null, isDisabled?: boolean | null, brandType?: string | null, isSelected?: boolean | null, isAssociateDisabled?: boolean | null, isAssociateSelected?: boolean | null, attributionStatus?: boolean | null, associateStatus?: boolean | null } | null> | null };

export type GetBrandOrdersQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  externalStore?: InputMaybe<Scalars['String']>;
  startKey?: InputMaybe<Scalars['String']>;
}>;


export type GetBrandOrdersQuery = { __typename?: 'Query', getBrandOrders: Array<{ __typename?: 'BrandOrder', orderName: string, date: string, customer: string, creator: string, grossSalesPrice: string, tax: string, discount: string, netSalesPrice: string, commission: string, shipping: string, netSalesAfterCommission: string, shopifyFee: string, brandPayout: string, lineItems: Array<{ __typename?: 'BrandOrderLineItem', name: string, quantity: number }> }> };

export type GetBrandProductsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  creatorId?: InputMaybe<Scalars['String']>;
  sortCriteria?: InputMaybe<Scalars['String']>;
  filterOptions?: InputMaybe<BrandProductsForCreatorFilters>;
}>;


export type GetBrandProductsQuery = { __typename?: 'Query', getBrandProducts: { __typename?: 'BrandProductsResponse', bio?: string | null, requiresApproval?: boolean | null, partnershipStatus?: PartnershipStatus | null, brandType?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, brandProducts?: Array<{ __typename?: 'Product', price?: string | null, id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null }> | null } };

export type GetBrandProductsForBrandQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  brandSlug?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  isActiveFilter?: InputMaybe<IsActiveFilter>;
}>;


export type GetBrandProductsForBrandQuery = { __typename?: 'Query', getBrandProductsForBrand: { __typename?: 'BrandProductsForBrandResponse', productCount?: number | null, logoUrl?: string | null, products: Array<{ __typename?: 'ProductForBrand', id: string, brandId: string, brandName: string, externalId: string, createdAt: string, name: string, isActive: boolean, creatorStoresNum: number }> } };

export type GetBrandProductsForConsumerQueryVariables = Exact<{
  creatorName: Scalars['String'];
  brandSlug: Scalars['String'];
}>;


export type GetBrandProductsForConsumerQuery = { __typename?: 'Query', getBrandProductsForConsumer: { __typename?: 'GetBrandProductsForConsumerResponse', brandName: string, brandDescription: string, brandLogoUrl: string, brandSlug: string, products: Array<{ __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }> } };

export type GetBrandStorefrontsForCreatorQueryVariables = Exact<{
  abstractBrandId: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
  expertId?: InputMaybe<Scalars['String']>;
}>;


export type GetBrandStorefrontsForCreatorQuery = { __typename?: 'Query', getBrandStorefrontsForCreator?: { __typename?: 'GetStorefrontsResponse', storefront: { __typename?: 'Storefront', store_name: string, pages?: Array<{ __typename?: 'StorefrontPage', store_page_id: string, store_page_url: string, store_page_name: string, is_active?: boolean | null, is_primary?: boolean | null, links?: Array<{ __typename?: 'StorefrontPageLink', id?: string | null, generated_link?: string | null, type?: string | null, meta_data?: string | null, is_active?: boolean | null, shortlink_id?: string | null, version?: number | null, source_id?: string | null, shortlink_slug?: string | null } | null> | null }> | null } } | null };

export type GetBrandUserQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
}>;


export type GetBrandUserQuery = { __typename?: 'Query', getBrandUser?: { __typename?: 'GetBrandUserResp', createdAt?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, id?: string | null, role?: string | null, brandId?: string | null } | null };

export type ListOrgUsersQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type ListOrgUsersQuery = { __typename?: 'Query', listOrgUsers?: { __typename?: 'ListUsersResp', userCount?: number | null, users?: Array<{ __typename?: 'ListOrgUsersResp', createdAt?: string | null, email?: string | null, expiresAt?: string | null, id?: string | null, name?: string | null, role?: string | null, isOwner?: boolean | null, invitationAccepted?: boolean | null } | null> | null } | null };

export type GetBrandsQueryVariables = Exact<{
  creatorId?: InputMaybe<Scalars['String']>;
  brandIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetBrandsQuery = { __typename?: 'Query', getBrands: Array<{ __typename?: 'BrandSearchResponse', id: string, name: string, logoUrl: string, requiresApproval: boolean, partnershipStatus?: PartnershipStatus | null, approvedAt?: string | null, rejectedAt?: string | null, integrationType?: BrandIntegrationType | null, brandType?: string | null, avgCommission?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null }> };

export type GetCategoriesQueryVariables = Exact<{
  includeInvisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', getCategories: { __typename?: 'ProductCategoriesResponse', categories: Array<{ __typename?: 'ProductCategories', id: string, name: string, amazonCategoryId: string, isActive: boolean, isVisible: boolean, children: Array<{ __typename?: 'ProductCategories', id: string, name: string, amazonCategoryId: string, isActive: boolean, isVisible: boolean, children: Array<{ __typename?: 'ProductCategories', id: string, name: string, amazonCategoryId: string, isActive: boolean, isVisible: boolean }> }> }> } };

export type GetCategoryFullPathQueryVariables = Exact<{
  categoryIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCategoryFullPathQuery = { __typename?: 'Query', getCategoryFullPath: { __typename?: 'GetCategoryFullPathResponse', categoryIds: Array<string> } };

export type GetCollectionQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null } };

export type GetCollectionForPortalQueryVariables = Exact<{
  collectionId: Scalars['String'];
}>;


export type GetCollectionForPortalQuery = { __typename?: 'Query', getCollection: { __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null } };

export type GetCreatorConnectionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetCreatorConnectionQuery = { __typename?: 'Query', getCreatorConnection?: { __typename?: 'UpsertResp', brandId?: string | null, id?: string | null, inviteEmail?: string | null, merchantToken?: string | null, status?: CrawlStatus | null } | null };

export type GetCreatorOrdersQueryVariables = Exact<{
  creatorId?: InputMaybe<Scalars['String']>;
  expertName?: InputMaybe<Scalars['String']>;
  startKey?: InputMaybe<Scalars['String']>;
}>;


export type GetCreatorOrdersQuery = { __typename?: 'Query', getCreatorOrders: Array<{ __typename?: 'CreatorOrder', date: string, customer: string, grossSalesPrice: string, earnings: string, paid: boolean, paidDate: string, lineItems: Array<{ __typename?: 'CreatorOrderLineItem', name: string, quantity: number, grossSalesPrice: string, salesTax?: string | null, discount: string, commissionableSales: string, commissionRate: string, commissionType: string, earnings: string }> }> };

export type GetCreatorsForApprovalQueryVariables = Exact<{
  storeApprovalStatus: ApprovalStatus;
  pageNumber: Scalars['Int'];
}>;


export type GetCreatorsForApprovalQuery = { __typename?: 'Query', getCreatorsForApproval: { __typename?: 'ExpertsByApprovalStatus', pageSize: number, totalCount: number, totalPages: number, pageNumber: number, experts: Array<{ __typename?: 'Expert', id: string, name: string, instagramName?: string | null, storeApprovalStatus: ApprovalStatus, onboardingDescription?: string | null, score?: string | null, amzStorefront?: string | null, contactInfo: { __typename?: 'ExpertContactInfo', email: string, phone: string, firstName: string, lastName: string }, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null }> } };

export type GetCreatorsForBrandQueryVariables = Exact<{
  brandId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isActiveFilter: IsActiveFilter;
  onlyStoresWithBrandProducts: Scalars['Boolean'];
  page?: InputMaybe<Scalars['Int']>;
  nichesFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  genderFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  petsFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  childrenFilter?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  scoreFilter?: InputMaybe<Scalars['String']>;
  allBrands?: InputMaybe<Scalars['Boolean']>;
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  isAssociateDisabled?: InputMaybe<Scalars['Boolean']>;
  isEligibleForAssociates?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCreatorsForBrandQuery = { __typename?: 'Query', getCreatorsForBrand: Array<{ __typename?: 'CreatorForBrand', creatorId: string, creatorName: string, creatorTheme?: string | null, storeEnabled: boolean, productsInStore: number, firstName?: string | null, lastName?: string | null, email?: string | null, bio?: string | null, niches?: Array<Niche> | null, dateOfBirth?: string | null, gender?: Gender | null, children?: Array<Children> | null, pets?: Array<Pets> | null, score?: string | null, isEligibleForAssociates: boolean, amzStorefront?: string | null, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, brandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null, flags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateFlags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateBrandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null }> };

export type GetDashboardProductsQueryVariables = Exact<{
  expertName: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDashboardProductsQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', price?: string | null, brandType?: string | null, id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null }> };

export type GetDownloadReportStatusQueryVariables = Exact<{
  reportId?: InputMaybe<Scalars['String']>;
}>;


export type GetDownloadReportStatusQuery = { __typename?: 'Query', getDownloadReportStatus?: { __typename?: 'DownloadReportRequestRes', url?: string | null, reportId: string, reportType: string, status: string } | null };

export type GetExpertQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  expertName?: InputMaybe<Scalars['String']>;
  instagramName?: InputMaybe<Scalars['String']>;
}>;


export type GetExpertQuery = { __typename?: 'Query', getExpert: { __typename?: 'Expert', id: string, name: string, instagramName?: string | null, instagramAuthorized: boolean, theme: string, hasBrexPayment: boolean, storeApprovalStatus: ApprovalStatus, storeApprovedAt: string, bio?: string | null, niches?: Array<Niche | null> | null, dateOfBirth?: string | null, gender?: Gender | null, children?: Array<Children | null> | null, pets?: Array<Pets | null> | null, onboardingDescription?: string | null, score?: string | null, amzAssociateTag?: string | null, amzAssociateEnabled?: boolean | null, amzStorefront?: string | null, isAssociateEnabled?: boolean | null, contactInfo: { __typename?: 'ExpertContactInfo', email: string, phone: string, firstName: string, lastName: string }, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null, address?: { __typename?: 'Address', city: string, postal_code: string, state_province: string, street_address_1: string, street_address_2?: string | null, mailing_address_first_name: string, mailing_address_last_name: string } | null } };

export type ExpertAmazonSourcesQueryVariables = Exact<{
  creatorId: Scalars['String'];
}>;


export type ExpertAmazonSourcesQuery = { __typename?: 'Query', expertAmazonLinkSources?: Array<{ __typename?: 'ExpertAmazonSources', id?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, campaignId?: string | null, tag?: string | null } | null> | null };

export type GetExpertForPortalQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  expertName?: InputMaybe<Scalars['String']>;
}>;


export type GetExpertForPortalQuery = { __typename?: 'Query', getExpertForPortal: { __typename?: 'PortalExpert', id: string, name: string, createdAt: string, instagramName: string, instagramAuthorized: boolean, theme: string, hasBrexPayment: boolean, brexVendorId?: string | null, storeApprovalStatus: ApprovalStatus, storeApprovedAt: string, bio?: string | null, amzAssociateTag?: string | null, amzAssociateEnabled: boolean, score?: string | null, isAssociateEnabled?: boolean | null, contactInfo: { __typename?: 'ExpertContactInfo', email: string, phone: string, firstName: string, lastName: string }, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null } | null, address?: { __typename?: 'Address', street_address_1: string, street_address_2?: string | null, city: string, state_province: string, postal_code: string, mailing_address_first_name: string, mailing_address_last_name: string } | null } };

export type GetExpertPrivateCommissionsQueryVariables = Exact<{
  creatorId: Scalars['String'];
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
  sellerId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  hasPrivateCommission?: InputMaybe<Scalars['Boolean']>;
  hasPrivateAssociateCommission?: InputMaybe<Scalars['Boolean']>;
  applyAttributionValueFilter?: InputMaybe<Scalars['Boolean']>;
  applyAssociateValueFilter?: InputMaybe<Scalars['Boolean']>;
  attributionFilter?: InputMaybe<OfferingCommissions>;
  associateFilter?: InputMaybe<OfferingCommissions>;
}>;


export type GetExpertPrivateCommissionsQuery = { __typename?: 'Query', getExpertPrivateCommissions?: { __typename?: 'ExpertProductsResp', productCount?: number | null, products?: Array<{ __typename?: 'ExpertProducts', brandId?: string | null, brandName?: string | null, amzSellerId?: string | null, externalProductId?: string | null, isActive?: boolean | null, price?: string | null, name?: string | null, productId?: string | null, updatedAt?: string | null, isAssociateActive?: boolean | null, commission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null, coverage?: string | null, description?: string | null, id?: string | null, name?: string | null } | null, creator?: { __typename?: 'CreatorMeta', storeName?: string | null, lastName?: string | null, firstName?: string | null } | null, associateCommission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null, coverage?: string | null, description?: string | null, id?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetLanderProductQueryVariables = Exact<{
  creatorName: Scalars['String'];
  productId: Scalars['String'];
  isPreview: Scalars['Boolean'];
}>;


export type GetLanderProductQuery = { __typename?: 'Query', getProductDetails: { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, landerMedia?: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }> | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null } };

export type GetMediaQueryVariables = Exact<{
  expertName: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
}>;


export type GetMediaQuery = { __typename?: 'Query', getMedia: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string, tags?: Array<string> | null }> };

export type GetMediaUploadUrlQueryVariables = Exact<{
  expertName: Scalars['String'];
  fileSize: Scalars['Int'];
  fileType: Scalars['String'];
}>;


export type GetMediaUploadUrlQuery = { __typename?: 'Query', getMediaUploadUrl: { __typename?: 'MediaUploadUrl', id: string, uploadUrl: string, mediaUrl: string } };

export type GetPartnershipsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
  partnershipStatusFilter?: InputMaybe<PartnershipStatus>;
}>;


export type GetPartnershipsQuery = { __typename?: 'Query', getPartnerships?: Array<{ __typename?: 'Partnership', id: string, partnershipStatus: PartnershipStatus, brandId: string, brandName: string, brandLogoUrl: string, creatorId: string, creatorName: string, creatorContactFirstName: string, creatorContactLastName: string, creatorContactEmail: string, creatorTheme: string, creatorInstagram: string, requestNotes?: string | null, requestedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, isAssociate?: boolean | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, metaData?: { __typename?: 'PartnershipMetaData', productId?: string | null, asin?: string | null, brandName?: string | null, brandId?: string | null } | null } | null> | null };

export type GetPostQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostQuery = { __typename?: 'Query', getPost: { __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null } };

export type GetProductQueryVariables = Exact<{
  creatorName: Scalars['String'];
  productId: Scalars['String'];
  isPreview: Scalars['Boolean'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProductDetails: { __typename?: 'Product', brandType?: string | null, isActive: boolean, setSize: number, id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null } };

export type GetProductIdsForExpertQueryVariables = Exact<{
  expertName: Scalars['String'];
  isStoreVisibleFilter?: InputMaybe<IsStoreVisibleFilter>;
}>;


export type GetProductIdsForExpertQuery = { __typename?: 'Query', getProductIdsForExpert: Array<{ __typename?: 'ProductId', id: string, externalId: string, shoppingType: string }> };

export type ViewProductLinksQueryVariables = Exact<{
  creatorId: Scalars['String'];
  productId: Scalars['String'];
}>;


export type ViewProductLinksQuery = { __typename?: 'Query', viewProductLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null };

export type GetProductSyncStatusQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetProductSyncStatusQuery = { __typename?: 'Query', getProductSyncStatus: { __typename?: 'ProductSyncStatus', totalProducts: number, syncedProducts: number, syncComplete: boolean } };

export type GetProductsQueryVariables = Exact<{
  expertName: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
  externalProductIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', brandType?: string | null, setSize: number, id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }> };

export type GetRecommendedProductsQueryVariables = Exact<{
  creatorId: Scalars['String'];
}>;


export type GetRecommendedProductsQuery = { __typename?: 'Query', getRecommendedProducts: Array<{ __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }> };

export type GetShortlinkBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetShortlinkBySlugQuery = { __typename?: 'Query', getShortlinkBySlug: { __typename?: 'Shortlink', id: string, slug: string, linkType: LinkType, data: string, createdAt: string } };

export type GetStorefrontLinkSourcesForExpertQueryVariables = Exact<{
  expertId: Scalars['String'];
}>;


export type GetStorefrontLinkSourcesForExpertQuery = { __typename?: 'Query', getStorefrontLinkSourcesForExpert?: { __typename?: 'GetStorefrontLinkSourcesForExpertResponse', sources?: Array<{ __typename?: 'StorefrontLinkSource', id: string, sourceName: string, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateTag?: string | null, tag?: string | null, campaignId?: string | null } | null> | null } | null };

export type GetStorefrontsForBrandQueryVariables = Exact<{
  abstractBrandId: Scalars['String'];
}>;


export type GetStorefrontsForBrandQuery = { __typename?: 'Query', getStorefrontsForBrand?: { __typename?: 'GetStorefrontsResponse', storefront: { __typename?: 'Storefront', store_name: string, pages?: Array<{ __typename?: 'StorefrontPage', store_page_id: string, store_page_url: string, store_page_name: string, is_active?: boolean | null, is_primary?: boolean | null }> | null } } | null };

export type GetStripeBillingQueryVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type GetStripeBillingQuery = { __typename?: 'Query', getStripeBilling?: { __typename?: 'GetBillingResp', paymentMethodAttached?: boolean | null } | null };

export type GetUploadRequestStatusQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;


export type GetUploadRequestStatusQuery = { __typename?: 'Query', getUploadRequestStatus?: { __typename?: 'UploadRequestRes', reportId: string, reportType: string, status: string, url?: string | null, summary?: { __typename?: 'UploadSummaryRes', totalRows?: number | null, totalSuccessRows?: number | null, processedRows?: number | null, totalErrorRows?: number | null, message?: string | null, successData?: Array<{ __typename?: 'UploadRowDataRes', rowNum?: number | null, message?: string | null, key?: string | null, fields?: Array<{ __typename?: 'UploadFieldRes', field?: string | null, currentValue?: string | null, newValue?: string | null } | null> | null } | null> | null, errorData?: Array<{ __typename?: 'UploadRowDataRes', rowNum?: number | null, message?: string | null, key?: string | null, fields?: Array<{ __typename?: 'UploadFieldRes', field?: string | null, currentValue?: string | null, newValue?: string | null } | null> | null } | null> | null } | null } | null };

export type GetVisibleProductsQueryVariables = Exact<{
  expertName: Scalars['String'];
  productIds: Array<Scalars['String']> | Scalars['String'];
  externalProductIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVisibleProductsQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: string, externalId: string, isVisibleInStore?: boolean | null }> };

export type CreateInviteToOrgMutationVariables = Exact<{
  brandId: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}>;


export type CreateInviteToOrgMutation = { __typename?: 'Mutation', createInviteToOrg: boolean };

export type ListAmazonBrandItemsQueryVariables = Exact<{
  brandId: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
  childBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isAttributionActive?: InputMaybe<Scalars['Boolean']>;
  isAssociateActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListAmazonBrandItemsQuery = { __typename?: 'Query', listAmazonBrandItems?: { __typename?: 'ListAmazonBrandsResp', brandCount?: number | null, brands?: Array<{ __typename?: 'AmazonBrand', id?: string | null, brandName?: string | null, sellerAccount?: string | null, status?: boolean | null, enabledProducts?: number | null, brandLogo?: string | null, brandBio?: string | null, isAttributionActive?: boolean | null, isAssociateActive?: boolean | null, associateProductCount?: number | null, commission?: { __typename?: 'AmzProductCommission', amountType?: string | null, amountValue?: string | null } | null, childBrands?: Array<{ __typename?: 'AmazonBrand', id?: string | null, brandName?: string | null, sellerAccount?: string | null, status?: boolean | null, enabledProducts?: number | null, brandLogo?: string | null, abstractBrandId?: string | null, isAttributionActive?: boolean | null, isAssociateActive?: boolean | null, associateProductCount?: number | null } | null> | null } | null> | null } | null };

export type ListBrandNamesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']>;
  carouselId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['String']>;
}>;


export type ListBrandNamesQuery = { __typename?: 'Query', listBrandNames?: Array<{ __typename?: 'ListBrandsResponse', id?: string | null, brandName?: string | null, brandType?: string | null } | null> | null };

export type ListBrandsQueryVariables = Exact<{
  page: Scalars['Int'];
  creatorId?: InputMaybe<Scalars['String']>;
  brandType?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  relationshipStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  orderBy?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type ListBrandsQuery = { __typename?: 'Query', listBrands?: { __typename?: 'ListBrandsResp', brandCount?: number | null, brands?: Array<{ __typename?: 'BrandSearchResponse', id: string, name: string, logoUrl: string, requiresApproval: boolean, partnershipStatus?: PartnershipStatus | null, approvedAt?: string | null, rejectedAt?: string | null, integrationType?: BrandIntegrationType | null, brandType?: string | null, avgCommission?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null } | null> | null } | null };

export type ListCollectionsQueryVariables = Exact<{
  expertName: Scalars['String'];
}>;


export type ListCollectionsQuery = { __typename?: 'Query', listCollections: Array<{ __typename?: 'Collection', id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null }> };

export type ListCollectionsForNavigationQueryVariables = Exact<{
  expertName: Scalars['String'];
}>;


export type ListCollectionsForNavigationQuery = { __typename?: 'Query', listCollections: Array<{ __typename?: 'Collection', id: string, slug: string, name: string, displayInNavigation: boolean }> };

export type ListCollectionsNoProductsQueryVariables = Exact<{
  expertName: Scalars['String'];
}>;


export type ListCollectionsNoProductsQuery = { __typename?: 'Query', listCollections: Array<{ __typename?: 'Collection', id: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string }> };

export type ListCollectionsWithProductsQueryVariables = Exact<{
  expertName: Scalars['String'];
}>;


export type ListCollectionsWithProductsQuery = { __typename?: 'Query', listCollections: Array<{ __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null }> };

export type ListCreatorConnectionsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
}>;


export type ListCreatorConnectionsQuery = { __typename?: 'Query', listCreatorConnections?: Array<{ __typename?: 'UpsertResp', brandId?: string | null, id?: string | null, inviteEmail?: string | null, merchantToken?: string | null, status?: CrawlStatus | null } | null> | null };

export type ListCustomersQueryVariables = Exact<{
  creatorId: Scalars['String'];
  startKey?: InputMaybe<Scalars['String']>;
}>;


export type ListCustomersQuery = { __typename?: 'Query', listCustomers: { __typename?: 'ListCustomerResponse', nextPageStartKey: string, customers: Array<{ __typename?: 'Customer', name: string, email: string, stateCode: string, firstPurchaseDate: string, totalPurchases: number, totalGmvPurchased: string }> } };

export type ListPostsQueryVariables = Exact<{
  creatorName: Scalars['String'];
  page: Scalars['Int'];
}>;


export type ListPostsQuery = { __typename?: 'Query', listPosts: Array<{ __typename?: 'Collection', id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null }> };

export type ListRecommendationsQueryVariables = Exact<{
  creatorId: Scalars['String'];
  context: RecommendationContext;
}>;


export type ListRecommendationsQuery = { __typename?: 'Query', listRecommendations: Array<{ __typename?: 'Slate', id: string, title: string, description: string, productIds?: Array<string> | null }> };

export type ListUserBrandsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
}>;


export type ListUserBrandsQuery = { __typename?: 'Query', listUserBrands?: Array<{ __typename?: 'ListUserBrandsResp', brandId?: string | null, id?: string | null, name?: string | null, onboardingStatus?: string | null, isOwner?: boolean | null, syncBrandCount?: number | null, activeBrandCount?: number | null } | null> | null };

export type MediaFieldsFragment = { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string };

export type MergeBrandsToNewAbstractBrandMutationVariables = Exact<{
  abstractBrandName: Scalars['String'];
  brandId: Scalars['String'];
  childBrandIds: Array<Scalars['String']> | Scalars['String'];
  abstractBrandBio?: InputMaybe<Scalars['String']>;
  abstractBrandCommission?: InputMaybe<Scalars['String']>;
  abstractBrandLogo?: InputMaybe<Scalars['String']>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
  isApproved?: InputMaybe<Scalars['Boolean']>;
  deferBrand?: InputMaybe<Scalars['String']>;
}>;


export type MergeBrandsToNewAbstractBrandMutation = { __typename?: 'Mutation', mergeBrandsToNewAbstractBrand: { __typename?: 'MergeBrandsToNewAbstractBrandResponse', error?: string | null, success: boolean, abstractBrandId?: string | null } };

export type MergeChildBrandIntoExistingAbstractBrandMutationVariables = Exact<{
  abstractBrandId: Scalars['String'];
  childBrandIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type MergeChildBrandIntoExistingAbstractBrandMutation = { __typename?: 'Mutation', mergeChildBrandIntoExistingAbstractBrand: { __typename?: 'MergeChildBrandIntoExistingAbstractBrandResponse', brandId?: string | null, success: boolean, error?: string | null } };

export type ProductCategoriesFieldsFragment = { __typename?: 'ProductCategories', id: string, name: string, amazonCategoryId: string, isActive: boolean, isVisible: boolean };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null };

export type ProductReviewsFragment = { __typename?: 'Product', reviews?: Array<{ __typename?: 'Review', id: string, createdAt: string, author: string, title: string, body: string, rating: number, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string }> }> | null, reviewSummary?: { __typename?: 'ReviewSummary', id: string, reviewCount: number, ratingAverage: number, ratingSum: Array<{ __typename?: 'RatingSum', rating: number, count: number }>, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string }> } | null };

export type DeleteUserOrgMutationVariables = Exact<{
  id: Scalars['String'];
  isInvited?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteUserOrgMutation = { __typename?: 'Mutation', deleteUserOrg: boolean };

export type RemoveExpertPrivateAssociateCommissionMutationVariables = Exact<{
  expertId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type RemoveExpertPrivateAssociateCommissionMutation = { __typename?: 'Mutation', removeExpertPrivateAssociateCommission?: boolean | null };

export type RemoveExpertPrivateCommissionMutationVariables = Exact<{
  expertId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  productId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type RemoveExpertPrivateCommissionMutation = { __typename?: 'Mutation', removeExpertPrivateCommission?: boolean | null };

export type RemoveProductFromExpertMutationVariables = Exact<{
  expertId: Scalars['String'];
  productId?: InputMaybe<Scalars['String']>;
  externalProductId?: InputMaybe<Scalars['String']>;
}>;


export type RemoveProductFromExpertMutation = { __typename?: 'Mutation', removeProductFromExpert: boolean };

export type SendDownloadReportRequestMutationVariables = Exact<{
  reportType: Scalars['String'];
  parameters?: InputMaybe<DownloadReportRequestParameters>;
}>;


export type SendDownloadReportRequestMutation = { __typename?: 'Mutation', sendDownloadReportRequest?: { __typename?: 'DownloadReportRequestRes', url?: string | null, reportId: string, reportType: string, status: string } | null };

export type RequestSampleQueryVariables = Exact<{
  subscriberKey: Scalars['String'];
  productId: Scalars['String'];
  productType: Scalars['String'];
  productTitle: Scalars['String'];
  message: Scalars['String'];
  mailingAddress: Scalars['String'];
  mailingAddress2: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mailingAddressFirstName: Scalars['String'];
  mailingAddressLastName: Scalars['String'];
  creatorName: Scalars['String'];
  creatorId: Scalars['String'];
  replyAddress: Scalars['String'];
  instagramHandle: Scalars['String'];
  tiktokHandle: Scalars['String'];
  facebookHandle: Scalars['String'];
  youtubeHandle: Scalars['String'];
  twitterHandle: Scalars['String'];
  threadsHandle: Scalars['String'];
  pinterestHandle: Scalars['String'];
}>;


export type RequestSampleQuery = { __typename?: 'Query', requestSample?: { __typename?: 'RequestSampleResponse', success: boolean } | null };

export type SearchBrandsQueryVariables = Exact<{
  name: Scalars['String'];
  creatorId?: InputMaybe<Scalars['String']>;
  includeHybrid?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchBrandsQuery = { __typename?: 'Query', searchBrands: Array<{ __typename?: 'BrandSearchResponse', id: string, name: string, logoUrl: string, requiresApproval: boolean, partnershipStatus?: PartnershipStatus | null, approvedAt?: string | null, rejectedAt?: string | null, integrationType?: BrandIntegrationType | null, brandType?: string | null, avgCommission?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null }> };

export type SearchCreatorsQueryVariables = Exact<{
  name: Scalars['String'];
  brandId: Scalars['String'];
  sortBy?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SearchCreatorsQuery = { __typename?: 'Query', searchCreators: Array<{ __typename?: 'CreatorForBrand', creatorId: string, creatorName: string, creatorTheme?: string | null, storeEnabled: boolean, productsInStore: number, firstName?: string | null, lastName?: string | null, email?: string | null, bio?: string | null, niches?: Array<Niche> | null, dateOfBirth?: string | null, gender?: Gender | null, children?: Array<Children> | null, pets?: Array<Pets> | null, score?: string | null, isEligibleForAssociates: boolean, amzStorefront?: string | null, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, brandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null, flags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateFlags?: { __typename?: 'FeatureFlags', allBrandsEnabled?: boolean | null, allBrandsHidden?: boolean | null, someBrandsEnabled?: boolean | null } | null, associateBrandMeta?: { __typename?: 'BrandProducts', productCount?: string | null, privateCommissions?: boolean | null } | null }> };

export type SearchProductsAndBrandsForShopperQueryVariables = Exact<{
  query: Scalars['String'];
  creatorName: Scalars['String'];
  page: Scalars['Int'];
}>;


export type SearchProductsAndBrandsForShopperQuery = { __typename?: 'Query', searchProductsAndBrandsForShopper: { __typename?: 'ShopperSearchResponse', products: Array<{ __typename?: 'SearchProduct', requiresApproval?: boolean | null, partnershipStatus?: PartnershipStatus | null, product: { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }, defaultBrandCommission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, defaultBrandDiscount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null }>, brands: Array<{ __typename?: 'SearchBrand', brandName: string, brandId: string, brandLogoUrl: string, brandSlug: string }> } };

export type SearchProductsForCreatorQueryVariables = Exact<{
  query: Scalars['String'];
  creatorId: Scalars['String'];
  page: Scalars['Int'];
  sortCriteria?: InputMaybe<SearchProductsForCreatorSortCriteria>;
  filterOptions?: InputMaybe<SearchProductsForCreatorFilterOptions>;
  combineInternalProducts?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchProductsForCreatorQuery = { __typename?: 'Query', searchProductsForCreator: { __typename?: 'SearchProductResponse', productCount?: number | null, products?: Array<{ __typename?: 'SearchProduct', requiresApproval?: boolean | null, partnershipStatus?: PartnershipStatus | null, product: { __typename?: 'Product', requiresApproval?: boolean | null, partnershipStatus?: string | null, id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }, defaultBrandCommission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, defaultBrandDiscount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null } | null> | null, marketplaceProducts?: Array<{ __typename?: 'MarketplaceProductSearchResults', affiliateSubType: AffiliateSubType, products: Array<{ __typename?: 'SearchProduct', requiresApproval?: boolean | null, partnershipStatus?: PartnershipStatus | null, product: { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }, defaultBrandCommission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, defaultBrandDiscount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null }> } | null> | null, affiliateProducts?: Array<{ __typename?: 'SearchProduct', requiresApproval?: boolean | null, partnershipStatus?: PartnershipStatus | null, product: { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null }, defaultBrandCommission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, defaultBrandDiscount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null } | null> | null } };

export type SendMessageToBrandQueryVariables = Exact<{
  creator_id: Scalars['String'];
  creator_email?: InputMaybe<Scalars['String']>;
  creator_name: Scalars['String'];
  message: Scalars['String'];
  brand_id: Scalars['String'];
  brand_email?: InputMaybe<Scalars['String']>;
}>;


export type SendMessageToBrandQuery = { __typename?: 'Query', sendMessageToBrand?: boolean | null };

export type SendMessageToCreatorQueryVariables = Exact<{
  creatorId: Scalars['String'];
  creator_email?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  brand_id: Scalars['String'];
  brand_name: Scalars['String'];
  brand_email?: InputMaybe<Scalars['String']>;
  brand_first_name: Scalars['String'];
}>;


export type SendMessageToCreatorQuery = { __typename?: 'Query', sendMessageToCreator?: boolean | null };

export type SendUploadRequestMutationVariables = Exact<{
  reportType: Scalars['String'];
  parameters?: InputMaybe<UploadRequestParameters>;
}>;


export type SendUploadRequestMutation = { __typename?: 'Mutation', sendUploadRequest?: { __typename?: 'UploadRequestRes', url?: string | null, reportId: string, reportType: string, status: string } | null };

export type SetBillingSubscriptionMutationVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type SetBillingSubscriptionMutation = { __typename?: 'Mutation', setBillingSubscription: { __typename?: 'SetSubscriptionResponse', internalSubscriptionId?: string | null, success?: string | null, error?: string | null } };

export type SetOnboardingFlagMutationVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type SetOnboardingFlagMutation = { __typename?: 'Mutation', setOnboardingFlag?: boolean | null };

export type SetProductAssociateCommissionsMutationVariables = Exact<{
  brandId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  commission?: InputMaybe<DefaultCommissionInput>;
  discount?: InputMaybe<DefaultDiscountInput>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  setParentDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  expertId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SetProductAssociateCommissionsMutation = { __typename?: 'Mutation', setProductAssociateCommissions: boolean };

export type SetProductSpecificCommissionsMutationVariables = Exact<{
  brandId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  commission?: InputMaybe<DefaultCommissionInput>;
  discount?: InputMaybe<DefaultDiscountInput>;
  setDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  setParentDefaultCommission?: InputMaybe<Scalars['Boolean']>;
  expertId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type SetProductSpecificCommissionsMutation = { __typename?: 'Mutation', setProductSpecificCommissions: boolean };

export type SetStripeBillingMutationVariables = Exact<{
  brandId: Scalars['String'];
}>;


export type SetStripeBillingMutation = { __typename?: 'Mutation', setStripeBilling?: { __typename?: 'SetBillingResp', clientSecret?: string | null } | null };

export type SyncAmazonAdsMutationVariables = Exact<{
  brandId: Scalars['String'];
  tokenId: Scalars['String'];
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SyncAmazonAdsMutation = { __typename?: 'Mutation', syncAmazonAds: { __typename?: 'AmazonAdsJobStatus', brandId: string, requestId?: string | null, jobStatus: string } };

export type TriggerCrawlMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type TriggerCrawlMutation = { __typename?: 'Mutation', triggerCrawl?: boolean | null };

export type UnMergeChildBrandFromAbstractBrandMutationVariables = Exact<{
  brandId: Scalars['String'];
  childBrandId: Scalars['String'];
  inheritDetailsFromAbstract?: InputMaybe<Scalars['Boolean']>;
  inheritCreatorPermissions?: InputMaybe<Scalars['Boolean']>;
}>;


export type UnMergeChildBrandFromAbstractBrandMutation = { __typename?: 'Mutation', unMergeChildBrandFromAbstractBrand: { __typename?: 'UnMergeBrandsFromAbstractBrandResponse', brandId?: string | null, success: boolean, error?: string | null } };

export type UpdateAmazonTokenRefreshMutationVariables = Exact<{
  brandId: Scalars['String'];
  refreshToken: Scalars['String'];
}>;


export type UpdateAmazonTokenRefreshMutation = { __typename?: 'Mutation', updateAmazonTokenRefresh?: { __typename?: 'AmazonAllProfiles', totalProfiles?: number | null, token?: string | null, profileExists?: boolean | null, profiles?: Array<{ __typename?: 'SellerProfiles', id?: string | null, sellerId?: string | null, name?: string | null, type?: string | null, newSync?: boolean | null, syncOverLap?: boolean | null, syncOverlapSameBrand?: boolean | null, isActive?: boolean | null } | null> | null } | null };

export type UpdateAccStatusMutationVariables = Exact<{
  brandId: Scalars['String'];
  accEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAccStatusMutation = { __typename?: 'Mutation', updateAccStatus?: boolean | null };

export type UpdateBioLinkOrderMutationVariables = Exact<{
  creatorId: Scalars['String'];
  bioLinkOrder: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateBioLinkOrderMutation = { __typename?: 'Mutation', updateBioLinkOrder: boolean };

export type UpdateBrandStatusBulkMutationVariables = Exact<{
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isAttribution?: InputMaybe<Scalars['Boolean']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateBrandStatusBulkMutation = { __typename?: 'Mutation', updateBrandStatusBulk?: boolean | null };

export type UpdateBrandStorefrontPagesMutationVariables = Exact<{
  pages: Array<UpdateBrandStorefrontPageArgs> | UpdateBrandStorefrontPageArgs;
}>;


export type UpdateBrandStorefrontPagesMutation = { __typename?: 'Mutation', updateBrandStorefrontPages: boolean };

export type UpdateCollectionOrderMutationVariables = Exact<{
  creatorId: Scalars['String'];
  collectionOrder: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateCollectionOrderMutation = { __typename?: 'Mutation', updateCollectionOrder: boolean };

export type UpdateCreatorLinksMutationVariables = Exact<{
  creatorId: Scalars['String'];
  linksInput: LinksInput;
}>;


export type UpdateCreatorLinksMutation = { __typename?: 'Mutation', updateCreatorLinks: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null } };

export type UpdateCreatorProductMutationVariables = Exact<{
  updateCreatorProductArgs: UpdateCreatorProductArgs;
}>;


export type UpdateCreatorProductMutation = { __typename?: 'Mutation', updateCreatorProduct: { __typename?: 'Product', id: string, brandName: string, expertName: string, externalId: string, name?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, brandLogoUrl: string, brandShippingSourceCountry: string, shoppingType: string, affiliateSubType?: AffiliateSubType | null, landerMedia?: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }> } };

export type UpdateCreatorSpecificCommissionMutationVariables = Exact<{
  creatorId: Scalars['String'];
  brandId: Scalars['String'];
  commission: CreatorCommissionInput;
}>;


export type UpdateCreatorSpecificCommissionMutation = { __typename?: 'Mutation', updateCreatorSpecificCommission: { __typename?: 'Commission', id: string } };

export type UpdateCreatorSpecificDiscountMutationVariables = Exact<{
  creatorId: Scalars['String'];
  brandId: Scalars['String'];
  discount: CreatorDiscountInput;
}>;


export type UpdateCreatorSpecificDiscountMutation = { __typename?: 'Mutation', updateCreatorSpecificDiscount: { __typename?: 'Discount', id: string } };

export type UpdateExpertThemeMutationVariables = Exact<{
  expertName?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
}>;


export type UpdateExpertThemeMutation = { __typename?: 'Mutation', updateExpertTheme: string };

export type UpdatePartnershipMutationVariables = Exact<{
  expertId: Scalars['String'];
  brandId?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  partnershipStatus?: InputMaybe<PartnershipStatus>;
  requestNotes?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  allBrands?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePartnershipMutation = { __typename?: 'Mutation', updatePartnership: boolean };

export type UpdatePartnershipsBulkMutationVariables = Exact<{
  creatorId: Scalars['String'];
  brandIds?: InputMaybe<Array<InputMaybe<UpdateBrandPartnerships>> | InputMaybe<UpdateBrandPartnerships>>;
  parentBrandId?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePartnershipsBulkMutation = { __typename?: 'Mutation', updatePartnershipsBulk?: boolean | null };

export type UpdateProductIsActiveMutationVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
  isAttribution?: InputMaybe<Scalars['Boolean']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type UpdateProductIsActiveMutation = { __typename?: 'Mutation', updateProductsIsActive: boolean };

export type UpdateUploadRequestMutationVariables = Exact<{
  action: Scalars['String'];
  reportId: Scalars['String'];
}>;


export type UpdateUploadRequestMutation = { __typename?: 'Mutation', updateUploadRequest?: { __typename?: 'UploadResultRes', success?: boolean | null, message?: string | null } | null };

export type UpsertAffiliateProductMutationVariables = Exact<{
  affiliateProductInput: AffiliateProductInput;
}>;


export type UpsertAffiliateProductMutation = { __typename?: 'Mutation', upsertAffiliateProduct: { __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null } };

export type UpsertAmazonStorefrontMutationVariables = Exact<{
  upsertAmazonStorefrontInput: UpsertAmazonStorefrontInput;
}>;


export type UpsertAmazonStorefrontMutation = { __typename?: 'Mutation', upsertAmazonStorefront?: { __typename?: 'AmazonStorefront', id: string, creatorId: string, url: string, amazonId: string, status: string, isActive: boolean, numCollections?: number | null, numPosts?: number | null, numProducts?: number | null } | null };

export type UpsertBioLinkMutationVariables = Exact<{
  upsertBioLinkInput: UpsertBioLinkInput;
}>;


export type UpsertBioLinkMutation = { __typename?: 'Mutation', upsertBioLink: { __typename?: 'BioLink', id: string, linkType: BioLinkType, data: string } };

export type UpsertBrandMutationVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  companyInfo?: InputMaybe<CompanyInfoInput>;
  contactInfo?: InputMaybe<ContactInfoInput>;
  externalStoreInfo?: InputMaybe<ExternalStoreInfoInput>;
  defaultCommission?: InputMaybe<DefaultCommissionInput>;
  defaultDiscount?: InputMaybe<DefaultDiscountInput>;
  customerSupport?: InputMaybe<CustomerSupportInput>;
  termsOfServiceAccepted?: InputMaybe<Scalars['Boolean']>;
  brexPaymentId?: InputMaybe<Scalars['String']>;
  brexVendorId?: InputMaybe<Scalars['String']>;
  requiresApproval?: InputMaybe<Scalars['Boolean']>;
  createOrderTags?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  brandPlatform?: InputMaybe<BrandPlatform>;
  bio?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isAssociate?: InputMaybe<Scalars['Boolean']>;
  isAssociateHidden?: InputMaybe<Scalars['Boolean']>;
  associateRequiresApproval?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  onboardingInfoClicked?: InputMaybe<Scalars['Boolean']>;
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type UpsertBrandMutation = { __typename?: 'Mutation', upsertBrand: { __typename?: 'BrandInfo', id: string, createdAt: string, onboardingStatus?: OnboardingStatus | null, termsOfServiceAccepted: boolean, hasBrexPayment: boolean, requiresApproval: boolean, brexVendorId?: string | null, logoUrl?: string | null, brandPlatform: BrandPlatform, bio?: string | null, isActive?: boolean | null, isDefaultHidden?: boolean | null, requiresAssociatesApproval?: boolean | null, isAssociateActive?: boolean | null, isAssociateDefaultHidden?: boolean | null, associateProductStatus?: boolean | null, associateFeatureFlag?: string | null, source?: string | null, onBoardingInfoClicked?: boolean | null, companyInfo?: { __typename?: 'CompanyInfo', name: string, website: string } | null, customerSupport?: { __typename?: 'CustomerSupport', returnPolicy: string, supportEmail: string } | null, contactInfo?: { __typename?: 'ContactInfo', firstName: string, lastName: string, phone: string, email: string, title: string } | null, externalStoreInfo?: { __typename?: 'ExternalStoreInfo', externalStore: string, externalStoreView?: string | null } | null, defaultCommission?: { __typename?: 'Commission', amountType: CommissionAmountType, amountValue: string } | null, defaultDiscount?: { __typename?: 'Discount', amountType: DiscountAmountType, amountValue: string } | null } };

export type UpsertCollectionMutationVariables = Exact<{
  upsertCollectionInput: UpsertCollectionInput;
}>;


export type UpsertCollectionMutation = { __typename?: 'Mutation', upsertCollection: { __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null } };

export type UpsertCreatorConnectionsMutationVariables = Exact<{
  brandId?: InputMaybe<Scalars['String']>;
  merchantToken?: InputMaybe<Scalars['String']>;
}>;


export type UpsertCreatorConnectionsMutation = { __typename?: 'Mutation', upsertCreatorConnections?: { __typename?: 'UpsertResp', brandId?: string | null, id?: string | null, inviteEmail?: string | null, merchantToken?: string | null, status?: CrawlStatus | null } | null };

export type UpsertExpertMutationVariables = Exact<{
  name: Scalars['String'];
  instagramName?: InputMaybe<Scalars['String']>;
  instagramAuthorized?: InputMaybe<Scalars['Boolean']>;
  contactInfo?: InputMaybe<ExpertContactInfoInput>;
  brexPaymentId?: InputMaybe<Scalars['String']>;
  brexVendorId?: InputMaybe<Scalars['String']>;
  termsOfServiceAccepted?: InputMaybe<Scalars['Boolean']>;
  storeApprovalStatus?: InputMaybe<ApprovalStatus>;
  brandInvite?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  children?: InputMaybe<Array<InputMaybe<Children>> | InputMaybe<Children>>;
  pets?: InputMaybe<Array<InputMaybe<Pets>> | InputMaybe<Pets>>;
  niches?: InputMaybe<Array<InputMaybe<Niche>> | InputMaybe<Niche>>;
  socialAccounts?: InputMaybe<LinksInput>;
  onboardingDescription?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
  inviteCode?: InputMaybe<Scalars['String']>;
  amzStorefront?: InputMaybe<Scalars['String']>;
}>;


export type UpsertExpertMutation = { __typename?: 'Mutation', upsertExpert: { __typename?: 'Expert', id: string, name: string, instagramName?: string | null, instagramAuthorized: boolean, theme: string, hasBrexPayment: boolean, brexVendorId?: string | null, bio?: string | null, dateOfBirth?: string | null, gender?: Gender | null, children?: Array<Children | null> | null, pets?: Array<Pets | null> | null, niches?: Array<Niche | null> | null, onboardingDescription?: string | null, score?: string | null, amzStorefront?: string | null, contactInfo: { __typename?: 'ExpertContactInfo', email: string, phone: string, firstName: string, lastName: string }, socialMedia?: { __typename?: 'SocialMediaLinks', instagramName?: string | null, facebookName?: string | null, tiktokName?: string | null, pinterestName?: string | null, youtubeName?: string | null, twitterName?: string | null, threadsName?: string | null, website?: string | null } | null } };

export type UpsertPostMutationVariables = Exact<{
  upsertPostInput: UpsertPostInput;
}>;


export type UpsertPostMutation = { __typename?: 'Mutation', upsertPost: { __typename?: 'Collection', productIds?: Array<string> | null, id: string, creatorId: string, name: string, slug: string, description: string, displayInNavigation: boolean, displayInHomePage: boolean, bannerImageUrl: string, productNum?: number | null, mediaUrls?: Array<string> | null } };

export type CheckInvitationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckInvitationQuery = { __typename?: 'Query', checkInvitation?: { __typename?: 'CheckInvitationResp', brandName?: string | null, inviteeEmail?: string | null, inviterName?: string | null, expireDate?: string | null, isInviteeUserExist?: boolean | null } | null };

export type VariantFieldsFragment = { __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null };

export type ViewCarouselItemsQueryVariables = Exact<{
  creatorId: Scalars['String'];
  carouselId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type ViewCarouselItemsQuery = { __typename?: 'Query', viewCarouselItems?: Array<{ __typename?: 'Carousel', id?: string | null, name?: string | null, displayName?: string | null, displayPosition?: number | null, carouselType?: string | null, updatedAt?: string | null, productCount?: number | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null, affiliateSubType?: AffiliateSubType | null, brandName: string, brandDescription?: string | null, brandId: string, brandLogoUrl: string, brandShippingSourceCountry: string, brandSlug?: string | null, description: string, isVisibleInStore?: boolean | null, shortlink?: string | null, shortBlurb: string, returnPolicy: string, supportEmail: string, outlink: string, outlinkDiscountCode?: string | null, shoppingType: string, expertName: string, externalId: string, brandType?: string | null, price?: string | null, couponVal?: string | null, couponType?: string | null, requiresApproval?: boolean | null, partnershipStatus?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string }> | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, media: Array<{ __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, externalId: string, outlink: string, price?: string | null, options: Array<{ __typename?: 'VariantOption', key: string, value: string }>, media?: { __typename?: 'Media', id: string, src: string, alt: string, createdAt: string, mediaProductId: string } | null }> | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null, amazonBuyBox?: { __typename?: 'AmazonBuyBox', avgRating?: string | null, discountPer?: string | null, price?: string | null, strikeThroughPrice?: string | null, reviewCount?: string | null, bestSellerRank?: string | null } | null, viewAllLinks?: Array<{ __typename?: 'ViewAllLinks', id?: string | null, shortlinkId?: string | null, slug?: string | null, url?: string | null, linkType?: string | null, createdAt?: string | null, primaryTrackingId?: string | null, subTrackingId?: string | null, amzAssociateId?: string | null, sourceName?: string | null, shortlinkUrl?: string | null } | null> | null } | null> | null, brands?: Array<{ __typename?: 'BrandSearchResponse', id: string, name: string, logoUrl: string, requiresApproval: boolean, partnershipStatus?: PartnershipStatus | null, approvedAt?: string | null, rejectedAt?: string | null, integrationType?: BrandIntegrationType | null, brandType?: string | null, avgCommission?: string | null, discount?: { __typename?: 'Discount', id: string, coverage: DiscountCoverage, amountType: DiscountAmountType, value: number, amountValue: string, code: string, displayStrikethrough: boolean, appliesOnEachItem: boolean, minimumOrderValue?: string | null } | null, commission?: { __typename?: 'Commission', id: string, coverage: CommissionCoverage, amountType: CommissionAmountType, value: number, amountValue: string, name: string, description: string } | null } | null> | null } | null> | null };

export const AmazonStorefrontFieldsFragmentDoc = `
    fragment AmazonStorefrontFields on AmazonStorefront {
  id
  creatorId
  url
  amazonId
  status
  isActive
  numCollections
  numPosts
  numProducts
}
    `;
export const DiscountFieldsFragmentDoc = `
    fragment DiscountFields on Discount {
  id
  coverage
  amountType
  value
  amountValue
  code
  displayStrikethrough
  appliesOnEachItem
  minimumOrderValue
}
    `;
export const MediaFieldsFragmentDoc = `
    fragment MediaFields on Media {
  id
  src
  alt
  createdAt
  mediaProductId
}
    `;
export const BaseProductFieldsFragmentDoc = `
    fragment BaseProductFields on Product {
  id
  brandName
  expertName
  externalId
  name
  description
  isVisibleInStore
  shortlink
  shortBlurb
  returnPolicy
  supportEmail
  brandLogoUrl
  brandShippingSourceCountry
  shoppingType
  affiliateSubType
  discount {
    ...DiscountFields
  }
  media {
    ...MediaFields
  }
}
    ${DiscountFieldsFragmentDoc}
${MediaFieldsFragmentDoc}`;
export const BrandResponseFieldsFragmentDoc = `
    fragment BrandResponseFields on BrandSearchResponse {
  id
  name
  logoUrl
  requiresApproval
  partnershipStatus
  approvedAt
  rejectedAt
  integrationType
  discount {
    ...DiscountFields
  }
  commission {
    id
    coverage
    amountType
    value
    amountValue
    name
    description
  }
  brandType
  avgCommission
}
    ${DiscountFieldsFragmentDoc}`;
export const CollectionFieldsFragmentDoc = `
    fragment CollectionFields on Collection {
  id
  creatorId
  name
  slug
  description
  displayInNavigation
  displayInHomePage
  bannerImageUrl
  productNum
  mediaUrls
}
    `;
export const CreatorForBrandFieldsFragmentDoc = `
    fragment CreatorForBrandFields on CreatorForBrand {
  creatorId
  creatorName
  creatorTheme
  storeEnabled
  productsInStore
  socialMedia {
    instagramName
    facebookName
    tiktokName
    pinterestName
    youtubeName
    twitterName
    threadsName
    website
  }
  discount {
    id
    coverage
    amountType
    value
    amountValue
    code
    displayStrikethrough
    appliesOnEachItem
    minimumOrderValue
  }
  commission {
    id
    coverage
    amountType
    value
    amountValue
    name
    description
  }
  firstName
  lastName
  email
  bio
  niches
  dateOfBirth
  gender
  children
  pets
  score
  brandMeta {
    productCount
    privateCommissions
  }
  flags {
    allBrandsEnabled
    allBrandsHidden
    someBrandsEnabled
  }
  associateFlags {
    allBrandsEnabled
    allBrandsHidden
    someBrandsEnabled
  }
  associateBrandMeta {
    productCount
    privateCommissions
  }
  isEligibleForAssociates
  amzStorefront
}
    `;
export const ProductCategoriesFieldsFragmentDoc = `
    fragment ProductCategoriesFields on ProductCategories {
  id
  name
  amazonCategoryId
  isActive
  isVisible
}
    `;
export const VariantFieldsFragmentDoc = `
    fragment VariantFields on ProductVariant {
  id
  externalId
  options {
    key
    value
  }
  outlink
  price
  media {
    ...MediaFields
  }
}
    ${MediaFieldsFragmentDoc}`;
export const ProductFieldsFragmentDoc = `
    fragment ProductFields on Product {
  id
  name
  affiliateSubType
  brandName
  brandDescription
  brandId
  brandLogoUrl
  brandShippingSourceCountry
  brandSlug
  description
  isVisibleInStore
  shortlink
  shortBlurb
  returnPolicy
  supportEmail
  outlink
  outlinkDiscountCode
  shoppingType
  categories {
    id
    name
  }
  discount {
    ...DiscountFields
  }
  expertName
  externalId
  media {
    ...MediaFields
  }
  variants {
    ...VariantFields
  }
  commission {
    id
    coverage
    amountType
    value
    amountValue
    name
    description
  }
  amazonBuyBox {
    avgRating
    discountPer
    price
    strikeThroughPrice
    reviewCount
    bestSellerRank
  }
  brandType
  price
  viewAllLinks {
    id
    shortlinkId
    slug
    url
    linkType
    createdAt
    primaryTrackingId
    subTrackingId
    amzAssociateId
    sourceName
    shortlinkUrl
  }
  couponVal
  couponType
  requiresApproval
  partnershipStatus
}
    ${DiscountFieldsFragmentDoc}
${MediaFieldsFragmentDoc}
${VariantFieldsFragmentDoc}`;
export const ProductReviewsFragmentDoc = `
    fragment ProductReviews on Product {
  reviews {
    id
    createdAt
    author
    title
    body
    rating
    media {
      id
      src
      alt
    }
  }
  reviewSummary {
    id
    ratingSum {
      rating
      count
    }
    reviewCount
    ratingAverage
    media {
      id
      src
      alt
    }
  }
}
    `;
export const ExpertAmazonAssociateTagDocument = `
    mutation expertAmazonAssociateTag($creatorId: String!, $amzAssociateTag: String!, $amzAssociateEnabled: Boolean) {
  expertAmazonAssociateTag(
    creatorId: $creatorId
    amzAssociateTag: $amzAssociateTag
    amzAssociateEnabled: $amzAssociateEnabled
  )
}
    `;
export const useExpertAmazonAssociateTagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExpertAmazonAssociateTagMutation, TError, ExpertAmazonAssociateTagMutationVariables, TContext>) =>
    useMutation<ExpertAmazonAssociateTagMutation, TError, ExpertAmazonAssociateTagMutationVariables, TContext>(
      ['expertAmazonAssociateTag'],
      (variables?: ExpertAmazonAssociateTagMutationVariables) => fetcher<ExpertAmazonAssociateTagMutation, ExpertAmazonAssociateTagMutationVariables>(ExpertAmazonAssociateTagDocument, variables)(),
      options
    );
useExpertAmazonAssociateTagMutation.getKey = () => ['expertAmazonAssociateTag'];

useExpertAmazonAssociateTagMutation.fetcher = (variables: ExpertAmazonAssociateTagMutationVariables, options?: RequestInit['headers']) => fetcher<ExpertAmazonAssociateTagMutation, ExpertAmazonAssociateTagMutationVariables>(ExpertAmazonAssociateTagDocument, variables, options);
export const AddProductToExpertDocument = `
    mutation AddProductToExpert($expertId: String!, $productId: String, $externalProductId: String) {
  addProductToExpert(
    expertId: $expertId
    productId: $productId
    externalProductId: $externalProductId
  )
}
    `;
export const useAddProductToExpertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProductToExpertMutation, TError, AddProductToExpertMutationVariables, TContext>) =>
    useMutation<AddProductToExpertMutation, TError, AddProductToExpertMutationVariables, TContext>(
      ['AddProductToExpert'],
      (variables?: AddProductToExpertMutationVariables) => fetcher<AddProductToExpertMutation, AddProductToExpertMutationVariables>(AddProductToExpertDocument, variables)(),
      options
    );
useAddProductToExpertMutation.getKey = () => ['AddProductToExpert'];

useAddProductToExpertMutation.fetcher = (variables: AddProductToExpertMutationVariables, options?: RequestInit['headers']) => fetcher<AddProductToExpertMutation, AddProductToExpertMutationVariables>(AddProductToExpertDocument, variables, options);
export const BulkAddProductToStoreAndCreateShareLinkDocument = `
    mutation BulkAddProductToStoreAndCreateShareLink($creatorId: String!, $productIds: [String!]!) {
  bulkAddProductToStoreAndCreateShareLink(
    creatorId: $creatorId
    productIds: $productIds
  ) {
    link
  }
}
    `;
export const useBulkAddProductToStoreAndCreateShareLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkAddProductToStoreAndCreateShareLinkMutation, TError, BulkAddProductToStoreAndCreateShareLinkMutationVariables, TContext>) =>
    useMutation<BulkAddProductToStoreAndCreateShareLinkMutation, TError, BulkAddProductToStoreAndCreateShareLinkMutationVariables, TContext>(
      ['BulkAddProductToStoreAndCreateShareLink'],
      (variables?: BulkAddProductToStoreAndCreateShareLinkMutationVariables) => fetcher<BulkAddProductToStoreAndCreateShareLinkMutation, BulkAddProductToStoreAndCreateShareLinkMutationVariables>(BulkAddProductToStoreAndCreateShareLinkDocument, variables)(),
      options
    );
useBulkAddProductToStoreAndCreateShareLinkMutation.getKey = () => ['BulkAddProductToStoreAndCreateShareLink'];

useBulkAddProductToStoreAndCreateShareLinkMutation.fetcher = (variables: BulkAddProductToStoreAndCreateShareLinkMutationVariables, options?: RequestInit['headers']) => fetcher<BulkAddProductToStoreAndCreateShareLinkMutation, BulkAddProductToStoreAndCreateShareLinkMutationVariables>(BulkAddProductToStoreAndCreateShareLinkDocument, variables, options);
export const CreateBrandUserDocument = `
    mutation createBrandUser($id: String!) {
  createBrandUser(id: $id)
}
    `;
export const useCreateBrandUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBrandUserMutation, TError, CreateBrandUserMutationVariables, TContext>) =>
    useMutation<CreateBrandUserMutation, TError, CreateBrandUserMutationVariables, TContext>(
      ['createBrandUser'],
      (variables?: CreateBrandUserMutationVariables) => fetcher<CreateBrandUserMutation, CreateBrandUserMutationVariables>(CreateBrandUserDocument, variables)(),
      options
    );
useCreateBrandUserMutation.getKey = () => ['createBrandUser'];

useCreateBrandUserMutation.fetcher = (variables: CreateBrandUserMutationVariables, options?: RequestInit['headers']) => fetcher<CreateBrandUserMutation, CreateBrandUserMutationVariables>(CreateBrandUserDocument, variables, options);
export const CreateCreatorMediaDocument = `
    mutation createCreatorMedia($creatorId: String!, $url: String!) {
  createCreatorMedia(creatorId: $creatorId, url: $url) {
    id
    src
    alt
    createdAt
  }
}
    `;
export const useCreateCreatorMediaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCreatorMediaMutation, TError, CreateCreatorMediaMutationVariables, TContext>) =>
    useMutation<CreateCreatorMediaMutation, TError, CreateCreatorMediaMutationVariables, TContext>(
      ['createCreatorMedia'],
      (variables?: CreateCreatorMediaMutationVariables) => fetcher<CreateCreatorMediaMutation, CreateCreatorMediaMutationVariables>(CreateCreatorMediaDocument, variables)(),
      options
    );
useCreateCreatorMediaMutation.getKey = () => ['createCreatorMedia'];

useCreateCreatorMediaMutation.fetcher = (variables: CreateCreatorMediaMutationVariables, options?: RequestInit['headers']) => fetcher<CreateCreatorMediaMutation, CreateCreatorMediaMutationVariables>(CreateCreatorMediaDocument, variables, options);
export const GetApiKeyDocument = `
    mutation getAPIKey($creatorId: String!, $createKey: Boolean) {
  getAPIKey(creatorId: $creatorId, createKey: $createKey)
}
    `;
export const useGetApiKeyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetApiKeyMutation, TError, GetApiKeyMutationVariables, TContext>) =>
    useMutation<GetApiKeyMutation, TError, GetApiKeyMutationVariables, TContext>(
      ['getAPIKey'],
      (variables?: GetApiKeyMutationVariables) => fetcher<GetApiKeyMutation, GetApiKeyMutationVariables>(GetApiKeyDocument, variables)(),
      options
    );
useGetApiKeyMutation.getKey = () => ['getAPIKey'];

useGetApiKeyMutation.fetcher = (variables: GetApiKeyMutationVariables, options?: RequestInit['headers']) => fetcher<GetApiKeyMutation, GetApiKeyMutationVariables>(GetApiKeyDocument, variables, options);
export const DeleteBioLinkDocument = `
    mutation DeleteBioLink($creatorId: String!, $bioLinkId: String!) {
  deleteBioLink(creatorId: $creatorId, bioLinkId: $bioLinkId)
}
    `;
export const useDeleteBioLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBioLinkMutation, TError, DeleteBioLinkMutationVariables, TContext>) =>
    useMutation<DeleteBioLinkMutation, TError, DeleteBioLinkMutationVariables, TContext>(
      ['DeleteBioLink'],
      (variables?: DeleteBioLinkMutationVariables) => fetcher<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>(DeleteBioLinkDocument, variables)(),
      options
    );
useDeleteBioLinkMutation.getKey = () => ['DeleteBioLink'];

useDeleteBioLinkMutation.fetcher = (variables: DeleteBioLinkMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteBioLinkMutation, DeleteBioLinkMutationVariables>(DeleteBioLinkDocument, variables, options);
export const DeleteBrandDocument = `
    mutation deleteBrand($id: String!) {
  deleteBrand(id: $id)
}
    `;
export const useDeleteBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBrandMutation, TError, DeleteBrandMutationVariables, TContext>) =>
    useMutation<DeleteBrandMutation, TError, DeleteBrandMutationVariables, TContext>(
      ['deleteBrand'],
      (variables?: DeleteBrandMutationVariables) => fetcher<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, variables)(),
      options
    );
useDeleteBrandMutation.getKey = () => ['deleteBrand'];

useDeleteBrandMutation.fetcher = (variables: DeleteBrandMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, variables, options);
export const DeleteCollectionDocument = `
    mutation DeleteCollection($creatorId: String!, $collectionId: String!) {
  deleteCollection(creatorId: $creatorId, collectionId: $collectionId)
}
    `;
export const useDeleteCollectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>) =>
    useMutation<DeleteCollectionMutation, TError, DeleteCollectionMutationVariables, TContext>(
      ['DeleteCollection'],
      (variables?: DeleteCollectionMutationVariables) => fetcher<DeleteCollectionMutation, DeleteCollectionMutationVariables>(DeleteCollectionDocument, variables)(),
      options
    );
useDeleteCollectionMutation.getKey = () => ['DeleteCollection'];

useDeleteCollectionMutation.fetcher = (variables: DeleteCollectionMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteCollectionMutation, DeleteCollectionMutationVariables>(DeleteCollectionDocument, variables, options);
export const EmitAnalyticsEventDocument = `
    query EmitAnalyticsEvent($user_id: String!, $event: String!, $properties: String) {
  emitAnalyticsEvent(user_id: $user_id, event: $event, properties: $properties)
}
    `;
export const useEmitAnalyticsEventQuery = <
      TData = EmitAnalyticsEventQuery,
      TError = unknown
    >(
      variables: EmitAnalyticsEventQueryVariables,
      options?: UseQueryOptions<EmitAnalyticsEventQuery, TError, TData>
    ) =>
    useQuery<EmitAnalyticsEventQuery, TError, TData>(
      ['EmitAnalyticsEvent', variables],
      fetcher<EmitAnalyticsEventQuery, EmitAnalyticsEventQueryVariables>(EmitAnalyticsEventDocument, variables),
      options
    );
useEmitAnalyticsEventQuery.document = EmitAnalyticsEventDocument;


useEmitAnalyticsEventQuery.getKey = (variables: EmitAnalyticsEventQueryVariables) => ['EmitAnalyticsEvent', variables];
;

useEmitAnalyticsEventQuery.fetcher = (variables: EmitAnalyticsEventQueryVariables, options?: RequestInit['headers']) => fetcher<EmitAnalyticsEventQuery, EmitAnalyticsEventQueryVariables>(EmitAnalyticsEventDocument, variables, options);
export const GenerateProductShareLinkDocument = `
    mutation GenerateProductShareLink($creatorId: String!, $productId: String!, $primaryTrackingId: String, $subTrackingId: String, $amzAssociateTag: String, $sourceName: String) {
  generateProductShareLink(
    creatorId: $creatorId
    productId: $productId
    primaryTrackingId: $primaryTrackingId
    subTrackingId: $subTrackingId
    amzAssociateTag: $amzAssociateTag
    sourceName: $sourceName
  ) {
    id
    shortlinkId
    slug
    url
    linkType
    createdAt
    primaryTrackingId
    subTrackingId
    amzAssociateId
    sourceName
    shortlinkUrl
  }
}
    `;
export const useGenerateProductShareLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateProductShareLinkMutation, TError, GenerateProductShareLinkMutationVariables, TContext>) =>
    useMutation<GenerateProductShareLinkMutation, TError, GenerateProductShareLinkMutationVariables, TContext>(
      ['GenerateProductShareLink'],
      (variables?: GenerateProductShareLinkMutationVariables) => fetcher<GenerateProductShareLinkMutation, GenerateProductShareLinkMutationVariables>(GenerateProductShareLinkDocument, variables)(),
      options
    );
useGenerateProductShareLinkMutation.getKey = () => ['GenerateProductShareLink'];

useGenerateProductShareLinkMutation.fetcher = (variables: GenerateProductShareLinkMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateProductShareLinkMutation, GenerateProductShareLinkMutationVariables>(GenerateProductShareLinkDocument, variables, options);
export const GenerateStorefrontPageLinkDocument = `
    mutation generateStorefrontPageLink($creatorId: String!, $abstractBrandId: String!, $storePageId: String!, $primaryTrackingId: String, $subTrackingId: String, $amzAssociateTag: String!, $sourceName: String) {
  generateStorefrontPageLink(
    creatorId: $creatorId
    abstractBrandId: $abstractBrandId
    storePageId: $storePageId
    primaryTrackingId: $primaryTrackingId
    subTrackingId: $subTrackingId
    amzAssociateTag: $amzAssociateTag
    sourceName: $sourceName
  ) {
    link
    linkId
  }
}
    `;
export const useGenerateStorefrontPageLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateStorefrontPageLinkMutation, TError, GenerateStorefrontPageLinkMutationVariables, TContext>) =>
    useMutation<GenerateStorefrontPageLinkMutation, TError, GenerateStorefrontPageLinkMutationVariables, TContext>(
      ['generateStorefrontPageLink'],
      (variables?: GenerateStorefrontPageLinkMutationVariables) => fetcher<GenerateStorefrontPageLinkMutation, GenerateStorefrontPageLinkMutationVariables>(GenerateStorefrontPageLinkDocument, variables)(),
      options
    );
useGenerateStorefrontPageLinkMutation.getKey = () => ['generateStorefrontPageLink'];

useGenerateStorefrontPageLinkMutation.fetcher = (variables: GenerateStorefrontPageLinkMutationVariables, options?: RequestInit['headers']) => fetcher<GenerateStorefrontPageLinkMutation, GenerateStorefrontPageLinkMutationVariables>(GenerateStorefrontPageLinkDocument, variables, options);
export const GetAmazonAdsSyncStatusDocument = `
    query getAmazonAdsSyncStatus($brandId: String, $requestId: String) {
  getAmazonAdsSyncStatus(brandId: $brandId, requestId: $requestId) {
    brandId
    requestId
    jobStatus
    updatedAt
    brandExists
  }
}
    `;
export const useGetAmazonAdsSyncStatusQuery = <
      TData = GetAmazonAdsSyncStatusQuery,
      TError = unknown
    >(
      variables?: GetAmazonAdsSyncStatusQueryVariables,
      options?: UseQueryOptions<GetAmazonAdsSyncStatusQuery, TError, TData>
    ) =>
    useQuery<GetAmazonAdsSyncStatusQuery, TError, TData>(
      variables === undefined ? ['getAmazonAdsSyncStatus'] : ['getAmazonAdsSyncStatus', variables],
      fetcher<GetAmazonAdsSyncStatusQuery, GetAmazonAdsSyncStatusQueryVariables>(GetAmazonAdsSyncStatusDocument, variables),
      options
    );
useGetAmazonAdsSyncStatusQuery.document = GetAmazonAdsSyncStatusDocument;


useGetAmazonAdsSyncStatusQuery.getKey = (variables?: GetAmazonAdsSyncStatusQueryVariables) => variables === undefined ? ['getAmazonAdsSyncStatus'] : ['getAmazonAdsSyncStatus', variables];
;

useGetAmazonAdsSyncStatusQuery.fetcher = (variables?: GetAmazonAdsSyncStatusQueryVariables, options?: RequestInit['headers']) => fetcher<GetAmazonAdsSyncStatusQuery, GetAmazonAdsSyncStatusQueryVariables>(GetAmazonAdsSyncStatusDocument, variables, options);
export const ListAmazonBrandFilterItemsDocument = `
    query listAmazonBrandFilterItems($brandId: String!) {
  listAmazonBrandFilterItems(brandId: $brandId) {
    brandId
    brandName
    sellerAccount
  }
}
    `;
export const useListAmazonBrandFilterItemsQuery = <
      TData = ListAmazonBrandFilterItemsQuery,
      TError = unknown
    >(
      variables: ListAmazonBrandFilterItemsQueryVariables,
      options?: UseQueryOptions<ListAmazonBrandFilterItemsQuery, TError, TData>
    ) =>
    useQuery<ListAmazonBrandFilterItemsQuery, TError, TData>(
      ['listAmazonBrandFilterItems', variables],
      fetcher<ListAmazonBrandFilterItemsQuery, ListAmazonBrandFilterItemsQueryVariables>(ListAmazonBrandFilterItemsDocument, variables),
      options
    );
useListAmazonBrandFilterItemsQuery.document = ListAmazonBrandFilterItemsDocument;


useListAmazonBrandFilterItemsQuery.getKey = (variables: ListAmazonBrandFilterItemsQueryVariables) => ['listAmazonBrandFilterItems', variables];
;

useListAmazonBrandFilterItemsQuery.fetcher = (variables: ListAmazonBrandFilterItemsQueryVariables, options?: RequestInit['headers']) => fetcher<ListAmazonBrandFilterItemsQuery, ListAmazonBrandFilterItemsQueryVariables>(ListAmazonBrandFilterItemsDocument, variables, options);
export const GetAmazonPricesDocument = `
    query getAmazonPrices($productIds: [String!], $asins: [String!]) {
  getAmazonPrices(productIds: $productIds, asins: $asins) {
    productPrices {
      productId
      price
      asin
    }
  }
}
    `;
export const useGetAmazonPricesQuery = <
      TData = GetAmazonPricesQuery,
      TError = unknown
    >(
      variables?: GetAmazonPricesQueryVariables,
      options?: UseQueryOptions<GetAmazonPricesQuery, TError, TData>
    ) =>
    useQuery<GetAmazonPricesQuery, TError, TData>(
      variables === undefined ? ['getAmazonPrices'] : ['getAmazonPrices', variables],
      fetcher<GetAmazonPricesQuery, GetAmazonPricesQueryVariables>(GetAmazonPricesDocument, variables),
      options
    );
useGetAmazonPricesQuery.document = GetAmazonPricesDocument;


useGetAmazonPricesQuery.getKey = (variables?: GetAmazonPricesQueryVariables) => variables === undefined ? ['getAmazonPrices'] : ['getAmazonPrices', variables];
;

useGetAmazonPricesQuery.fetcher = (variables?: GetAmazonPricesQueryVariables, options?: RequestInit['headers']) => fetcher<GetAmazonPricesQuery, GetAmazonPricesQueryVariables>(GetAmazonPricesDocument, variables, options);
export const GetAmazonProductsDocument = `
    query getAmazonProducts($brandId: [String!], $page: Int, $term: String, $isAttributionActive: Boolean, $isAssociateActive: Boolean, $isInStock: Boolean, $hasPrivateCommission: Boolean, $hasPrivateAssociateCommission: Boolean, $applyAttributionValueFilter: Boolean, $applyAssociateValueFilter: Boolean, $attributionFilter: OfferingCommissions, $associateFilter: OfferingCommissions, $isConflicted: Boolean) {
  getAmazonProducts(
    brandId: $brandId
    page: $page
    term: $term
    isAttributionActive: $isAttributionActive
    isAssociateActive: $isAssociateActive
    isInStock: $isInStock
    hasPrivateCommission: $hasPrivateCommission
    hasPrivateAssociateCommission: $hasPrivateAssociateCommission
    applyAttributionValueFilter: $applyAttributionValueFilter
    applyAssociateValueFilter: $applyAssociateValueFilter
    attributionFilter: $attributionFilter
    associateFilter: $associateFilter
    isConflicted: $isConflicted
  ) {
    productCount
    products {
      brandId
      imageUrl
      productId
      externalProductId
      name
      price
      bestSellerRank
      isActive
      brandName
      amzSellerId
      commission {
        amountType
        amountValue
      }
      brandPlatform
      expertCount
      updatedAt
      creatorPromoted
      availability
      privateCommissions
      isAttributionActive
      isAssociateActive
      associateCommission {
        amountType
        amountValue
      }
      privateAssociate
      isConflicted
    }
  }
}
    `;
export const useGetAmazonProductsQuery = <
      TData = GetAmazonProductsQuery,
      TError = unknown
    >(
      variables?: GetAmazonProductsQueryVariables,
      options?: UseQueryOptions<GetAmazonProductsQuery, TError, TData>
    ) =>
    useQuery<GetAmazonProductsQuery, TError, TData>(
      variables === undefined ? ['getAmazonProducts'] : ['getAmazonProducts', variables],
      fetcher<GetAmazonProductsQuery, GetAmazonProductsQueryVariables>(GetAmazonProductsDocument, variables),
      options
    );
useGetAmazonProductsQuery.document = GetAmazonProductsDocument;


useGetAmazonProductsQuery.getKey = (variables?: GetAmazonProductsQueryVariables) => variables === undefined ? ['getAmazonProducts'] : ['getAmazonProducts', variables];
;

useGetAmazonProductsQuery.fetcher = (variables?: GetAmazonProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAmazonProductsQuery, GetAmazonProductsQueryVariables>(GetAmazonProductsDocument, variables, options);
export const GetAmazonStorefrontDocument = `
    query GetAmazonStorefront($creatorName: String!) {
  getAmazonStorefront(creatorName: $creatorName) {
    ...AmazonStorefrontFields
  }
}
    ${AmazonStorefrontFieldsFragmentDoc}`;
export const useGetAmazonStorefrontQuery = <
      TData = GetAmazonStorefrontQuery,
      TError = unknown
    >(
      variables: GetAmazonStorefrontQueryVariables,
      options?: UseQueryOptions<GetAmazonStorefrontQuery, TError, TData>
    ) =>
    useQuery<GetAmazonStorefrontQuery, TError, TData>(
      ['GetAmazonStorefront', variables],
      fetcher<GetAmazonStorefrontQuery, GetAmazonStorefrontQueryVariables>(GetAmazonStorefrontDocument, variables),
      options
    );
useGetAmazonStorefrontQuery.document = GetAmazonStorefrontDocument;


useGetAmazonStorefrontQuery.getKey = (variables: GetAmazonStorefrontQueryVariables) => ['GetAmazonStorefront', variables];
;

useGetAmazonStorefrontQuery.fetcher = (variables: GetAmazonStorefrontQueryVariables, options?: RequestInit['headers']) => fetcher<GetAmazonStorefrontQuery, GetAmazonStorefrontQueryVariables>(GetAmazonStorefrontDocument, variables, options);
export const GetAsinExpertPrivateCommissionsDocument = `
    query getAsinExpertPrivateCommissions($page: Int, $productId: String, $name: String, $isActive: Boolean, $isAssociateActive: Boolean, $hasPrivateCommission: Boolean, $hasPrivateAssociateCommission: Boolean, $applyAttributionValueFilter: Boolean, $applyAssociateValueFilter: Boolean, $attributionFilter: OfferingCommissions, $associateFilter: OfferingCommissions) {
  getAsinExpertPrivateCommissions(
    page: $page
    productId: $productId
    name: $name
    isActive: $isActive
    isAssociateActive: $isAssociateActive
    hasPrivateCommission: $hasPrivateCommission
    hasPrivateAssociateCommission: $hasPrivateAssociateCommission
    applyAttributionValueFilter: $applyAttributionValueFilter
    applyAssociateValueFilter: $applyAssociateValueFilter
    attributionFilter: $attributionFilter
    associateFilter: $associateFilter
  ) {
    experts {
      creatorInfo {
        partnershipStatus
        requestedAt
        approvedAt
        rejectedAt
        creatorTheme
        firstName
        lastName
        email
        bio
        dateOfBirth
        gender
        score
        children
        creatorId
        creatorName
        niches
        productsInStore
        pets
        storeEnabled
        brandMeta {
          productCount
          privateCommissions
        }
        socialMedia {
          facebookName
          instagramName
          tiktokName
          pinterestName
          threadsName
          twitterName
          website
          youtubeName
        }
        discount {
          amountType
          amountValue
          appliesOnEachItem
          code
          coverage
          displayStrikethrough
          id
          isBrandDefaultOrChild
          minimumOrderValue
          value
        }
        commission {
          amountType
          amountValue
          coverage
          description
          id
          isBrandDefault
          name
          value
        }
      }
      updatedAt
      productMeta {
        brandId
        brandName
        externalProductId
        name
        productId
        isActive
        isAssociateActive
      }
      productExpertCommission {
        amountType
        amountValue
        coverage
        description
        id
        name
      }
      associateCommission {
        amountType
        amountValue
        coverage
        description
        id
        name
      }
    }
    expertsCount
  }
}
    `;
export const useGetAsinExpertPrivateCommissionsQuery = <
      TData = GetAsinExpertPrivateCommissionsQuery,
      TError = unknown
    >(
      variables?: GetAsinExpertPrivateCommissionsQueryVariables,
      options?: UseQueryOptions<GetAsinExpertPrivateCommissionsQuery, TError, TData>
    ) =>
    useQuery<GetAsinExpertPrivateCommissionsQuery, TError, TData>(
      variables === undefined ? ['getAsinExpertPrivateCommissions'] : ['getAsinExpertPrivateCommissions', variables],
      fetcher<GetAsinExpertPrivateCommissionsQuery, GetAsinExpertPrivateCommissionsQueryVariables>(GetAsinExpertPrivateCommissionsDocument, variables),
      options
    );
useGetAsinExpertPrivateCommissionsQuery.document = GetAsinExpertPrivateCommissionsDocument;


useGetAsinExpertPrivateCommissionsQuery.getKey = (variables?: GetAsinExpertPrivateCommissionsQueryVariables) => variables === undefined ? ['getAsinExpertPrivateCommissions'] : ['getAsinExpertPrivateCommissions', variables];
;

useGetAsinExpertPrivateCommissionsQuery.fetcher = (variables?: GetAsinExpertPrivateCommissionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAsinExpertPrivateCommissionsQuery, GetAsinExpertPrivateCommissionsQueryVariables>(GetAsinExpertPrivateCommissionsDocument, variables, options);
export const GetAccStatusDocument = `
    query getAccStatus($brandId: String!) {
  getAccStatus(brandId: $brandId)
}
    `;
export const useGetAccStatusQuery = <
      TData = GetAccStatusQuery,
      TError = unknown
    >(
      variables: GetAccStatusQueryVariables,
      options?: UseQueryOptions<GetAccStatusQuery, TError, TData>
    ) =>
    useQuery<GetAccStatusQuery, TError, TData>(
      ['getAccStatus', variables],
      fetcher<GetAccStatusQuery, GetAccStatusQueryVariables>(GetAccStatusDocument, variables),
      options
    );
useGetAccStatusQuery.document = GetAccStatusDocument;


useGetAccStatusQuery.getKey = (variables: GetAccStatusQueryVariables) => ['getAccStatus', variables];
;

useGetAccStatusQuery.fetcher = (variables: GetAccStatusQueryVariables, options?: RequestInit['headers']) => fetcher<GetAccStatusQuery, GetAccStatusQueryVariables>(GetAccStatusDocument, variables, options);
export const GetBillingSubscriptionDocument = `
    query getBillingSubscription($brandId: String!) {
  getBillingSubscription(brandId: $brandId) {
    internalSubscriptionId
    status
  }
}
    `;
export const useGetBillingSubscriptionQuery = <
      TData = GetBillingSubscriptionQuery,
      TError = unknown
    >(
      variables: GetBillingSubscriptionQueryVariables,
      options?: UseQueryOptions<GetBillingSubscriptionQuery, TError, TData>
    ) =>
    useQuery<GetBillingSubscriptionQuery, TError, TData>(
      ['getBillingSubscription', variables],
      fetcher<GetBillingSubscriptionQuery, GetBillingSubscriptionQueryVariables>(GetBillingSubscriptionDocument, variables),
      options
    );
useGetBillingSubscriptionQuery.document = GetBillingSubscriptionDocument;


useGetBillingSubscriptionQuery.getKey = (variables: GetBillingSubscriptionQueryVariables) => ['getBillingSubscription', variables];
;

useGetBillingSubscriptionQuery.fetcher = (variables: GetBillingSubscriptionQueryVariables, options?: RequestInit['headers']) => fetcher<GetBillingSubscriptionQuery, GetBillingSubscriptionQueryVariables>(GetBillingSubscriptionDocument, variables, options);
export const GetBioLinksDocument = `
    query GetBioLinks($creatorName: String!) {
  getBioLinks(creatorName: $creatorName) {
    links {
      id
      linkType
      data
    }
  }
}
    `;
export const useGetBioLinksQuery = <
      TData = GetBioLinksQuery,
      TError = unknown
    >(
      variables: GetBioLinksQueryVariables,
      options?: UseQueryOptions<GetBioLinksQuery, TError, TData>
    ) =>
    useQuery<GetBioLinksQuery, TError, TData>(
      ['GetBioLinks', variables],
      fetcher<GetBioLinksQuery, GetBioLinksQueryVariables>(GetBioLinksDocument, variables),
      options
    );
useGetBioLinksQuery.document = GetBioLinksDocument;


useGetBioLinksQuery.getKey = (variables: GetBioLinksQueryVariables) => ['GetBioLinks', variables];
;

useGetBioLinksQuery.fetcher = (variables: GetBioLinksQueryVariables, options?: RequestInit['headers']) => fetcher<GetBioLinksQuery, GetBioLinksQueryVariables>(GetBioLinksDocument, variables, options);
export const GetBrandDocument = `
    query GetBrand($brandId: String) {
  getBrand(brandId: $brandId) {
    id
    bio
    isActive
    createdAt
    termsOfServiceAccepted
    hasBrexPayment
    brexVendorId
    requiresApproval
    createOrderTags
    logoUrl
    slug
    companyInfo {
      name
      website
    }
    contactInfo {
      firstName
      lastName
      title
      email
      phone
    }
    externalStoreInfo {
      externalStore
      externalStoreView
    }
    defaultCommission {
      amountType
      amountValue
    }
    defaultDiscount {
      amountType
      amountValue
    }
    customerSupport {
      returnPolicy
      supportEmail
    }
    onboardingStatus
    brandPlatform
    brandType
    productStatus
    featureFlag
    isDefaultHidden
    isDeleted
    requiresAssociatesApproval
    isAssociateActive
    associateProductStatus
    associateFeatureFlag
    isAssociateDefaultHidden
    onBoardingInfoClicked
  }
}
    `;
export const useGetBrandQuery = <
      TData = GetBrandQuery,
      TError = unknown
    >(
      variables?: GetBrandQueryVariables,
      options?: UseQueryOptions<GetBrandQuery, TError, TData>
    ) =>
    useQuery<GetBrandQuery, TError, TData>(
      variables === undefined ? ['GetBrand'] : ['GetBrand', variables],
      fetcher<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, variables),
      options
    );
useGetBrandQuery.document = GetBrandDocument;


useGetBrandQuery.getKey = (variables?: GetBrandQueryVariables) => variables === undefined ? ['GetBrand'] : ['GetBrand', variables];
;

useGetBrandQuery.fetcher = (variables?: GetBrandQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, variables, options);
export const GetBrandByCheckoutSessionIdDocument = `
    query getBrandByCheckoutSessionId($checkoutSessionId: String!) {
  getBrandByCheckoutSessionId(checkoutSessionId: $checkoutSessionId) {
    brandId
    status
  }
}
    `;
export const useGetBrandByCheckoutSessionIdQuery = <
      TData = GetBrandByCheckoutSessionIdQuery,
      TError = unknown
    >(
      variables: GetBrandByCheckoutSessionIdQueryVariables,
      options?: UseQueryOptions<GetBrandByCheckoutSessionIdQuery, TError, TData>
    ) =>
    useQuery<GetBrandByCheckoutSessionIdQuery, TError, TData>(
      ['getBrandByCheckoutSessionId', variables],
      fetcher<GetBrandByCheckoutSessionIdQuery, GetBrandByCheckoutSessionIdQueryVariables>(GetBrandByCheckoutSessionIdDocument, variables),
      options
    );
useGetBrandByCheckoutSessionIdQuery.document = GetBrandByCheckoutSessionIdDocument;


useGetBrandByCheckoutSessionIdQuery.getKey = (variables: GetBrandByCheckoutSessionIdQueryVariables) => ['getBrandByCheckoutSessionId', variables];
;

useGetBrandByCheckoutSessionIdQuery.fetcher = (variables: GetBrandByCheckoutSessionIdQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandByCheckoutSessionIdQuery, GetBrandByCheckoutSessionIdQueryVariables>(GetBrandByCheckoutSessionIdDocument, variables, options);
export const GetBrandsForCreatorDocument = `
    query getBrandsForCreator($brandId: String, $includeNonAmazon: Boolean, $creatorId: String, $isDisabled: Boolean) {
  getBrandsForCreator(
    brandId: $brandId
    includeNonAmazon: $includeNonAmazon
    creatorId: $creatorId
    isDisabled: $isDisabled
  ) {
    brandId
    brandName
    sellerAccount
    isDisabled
    brandType
    isSelected
    isAssociateDisabled
    isAssociateSelected
    attributionStatus
    associateStatus
  }
}
    `;
export const useGetBrandsForCreatorQuery = <
      TData = GetBrandsForCreatorQuery,
      TError = unknown
    >(
      variables?: GetBrandsForCreatorQueryVariables,
      options?: UseQueryOptions<GetBrandsForCreatorQuery, TError, TData>
    ) =>
    useQuery<GetBrandsForCreatorQuery, TError, TData>(
      variables === undefined ? ['getBrandsForCreator'] : ['getBrandsForCreator', variables],
      fetcher<GetBrandsForCreatorQuery, GetBrandsForCreatorQueryVariables>(GetBrandsForCreatorDocument, variables),
      options
    );
useGetBrandsForCreatorQuery.document = GetBrandsForCreatorDocument;


useGetBrandsForCreatorQuery.getKey = (variables?: GetBrandsForCreatorQueryVariables) => variables === undefined ? ['getBrandsForCreator'] : ['getBrandsForCreator', variables];
;

useGetBrandsForCreatorQuery.fetcher = (variables?: GetBrandsForCreatorQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandsForCreatorQuery, GetBrandsForCreatorQueryVariables>(GetBrandsForCreatorDocument, variables, options);
export const GetBrandOrdersDocument = `
    query GetBrandOrders($brandId: String, $externalStore: String, $startKey: String) {
  getBrandOrders(
    brandId: $brandId
    externalStore: $externalStore
    startKey: $startKey
  ) {
    orderName
    date
    customer
    creator
    lineItems {
      name
      quantity
    }
    grossSalesPrice
    tax
    discount
    netSalesPrice
    commission
    shipping
    netSalesAfterCommission
    shopifyFee
    brandPayout
  }
}
    `;
export const useGetBrandOrdersQuery = <
      TData = GetBrandOrdersQuery,
      TError = unknown
    >(
      variables?: GetBrandOrdersQueryVariables,
      options?: UseQueryOptions<GetBrandOrdersQuery, TError, TData>
    ) =>
    useQuery<GetBrandOrdersQuery, TError, TData>(
      variables === undefined ? ['GetBrandOrders'] : ['GetBrandOrders', variables],
      fetcher<GetBrandOrdersQuery, GetBrandOrdersQueryVariables>(GetBrandOrdersDocument, variables),
      options
    );
useGetBrandOrdersQuery.document = GetBrandOrdersDocument;


useGetBrandOrdersQuery.getKey = (variables?: GetBrandOrdersQueryVariables) => variables === undefined ? ['GetBrandOrders'] : ['GetBrandOrders', variables];
;

useGetBrandOrdersQuery.fetcher = (variables?: GetBrandOrdersQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandOrdersQuery, GetBrandOrdersQueryVariables>(GetBrandOrdersDocument, variables, options);
export const GetBrandProductsDocument = `
    query GetBrandProducts($name: String, $id: String, $page: Int, $creatorId: String, $sortCriteria: String, $filterOptions: BrandProductsForCreatorFilters) {
  getBrandProducts(
    name: $name
    id: $id
    page: $page
    creatorId: $creatorId
    sortCriteria: $sortCriteria
    filterOptions: $filterOptions
  ) {
    discount {
      ...DiscountFields
    }
    commission {
      id
      coverage
      amountType
      value
      amountValue
      name
      description
    }
    bio
    brandProducts {
      ...ProductFields
      price
      viewAllLinks {
        id
        shortlinkId
        slug
        url
        linkType
        createdAt
        primaryTrackingId
        subTrackingId
        amzAssociateId
        sourceName
        shortlinkUrl
      }
      amazonBuyBox {
        avgRating
        discountPer
        price
        strikeThroughPrice
        reviewCount
        bestSellerRank
      }
    }
    requiresApproval
    partnershipStatus
    brandType
  }
}
    ${DiscountFieldsFragmentDoc}
${ProductFieldsFragmentDoc}`;
export const useGetBrandProductsQuery = <
      TData = GetBrandProductsQuery,
      TError = unknown
    >(
      variables?: GetBrandProductsQueryVariables,
      options?: UseQueryOptions<GetBrandProductsQuery, TError, TData>
    ) =>
    useQuery<GetBrandProductsQuery, TError, TData>(
      variables === undefined ? ['GetBrandProducts'] : ['GetBrandProducts', variables],
      fetcher<GetBrandProductsQuery, GetBrandProductsQueryVariables>(GetBrandProductsDocument, variables),
      options
    );
useGetBrandProductsQuery.document = GetBrandProductsDocument;


useGetBrandProductsQuery.getKey = (variables?: GetBrandProductsQueryVariables) => variables === undefined ? ['GetBrandProducts'] : ['GetBrandProducts', variables];
;

useGetBrandProductsQuery.fetcher = (variables?: GetBrandProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandProductsQuery, GetBrandProductsQueryVariables>(GetBrandProductsDocument, variables, options);
export const GetBrandProductsForBrandDocument = `
    query GetBrandProductsForBrand($id: String, $brandSlug: String, $page: Int, $isActiveFilter: IsActiveFilter) {
  getBrandProductsForBrand(
    id: $id
    brandSlug: $brandSlug
    page: $page
    isActiveFilter: $isActiveFilter
  ) {
    products {
      id
      brandId
      brandName
      externalId
      createdAt
      name
      isActive
      creatorStoresNum
    }
    productCount
    logoUrl
  }
}
    `;
export const useGetBrandProductsForBrandQuery = <
      TData = GetBrandProductsForBrandQuery,
      TError = unknown
    >(
      variables?: GetBrandProductsForBrandQueryVariables,
      options?: UseQueryOptions<GetBrandProductsForBrandQuery, TError, TData>
    ) =>
    useQuery<GetBrandProductsForBrandQuery, TError, TData>(
      variables === undefined ? ['GetBrandProductsForBrand'] : ['GetBrandProductsForBrand', variables],
      fetcher<GetBrandProductsForBrandQuery, GetBrandProductsForBrandQueryVariables>(GetBrandProductsForBrandDocument, variables),
      options
    );
useGetBrandProductsForBrandQuery.document = GetBrandProductsForBrandDocument;


useGetBrandProductsForBrandQuery.getKey = (variables?: GetBrandProductsForBrandQueryVariables) => variables === undefined ? ['GetBrandProductsForBrand'] : ['GetBrandProductsForBrand', variables];
;

useGetBrandProductsForBrandQuery.fetcher = (variables?: GetBrandProductsForBrandQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandProductsForBrandQuery, GetBrandProductsForBrandQueryVariables>(GetBrandProductsForBrandDocument, variables, options);
export const GetBrandProductsForConsumerDocument = `
    query GetBrandProductsForConsumer($creatorName: String!, $brandSlug: String!) {
  getBrandProductsForConsumer(creatorName: $creatorName, brandSlug: $brandSlug) {
    products {
      ...ProductFields
    }
    brandName
    brandDescription
    brandLogoUrl
    brandSlug
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useGetBrandProductsForConsumerQuery = <
      TData = GetBrandProductsForConsumerQuery,
      TError = unknown
    >(
      variables: GetBrandProductsForConsumerQueryVariables,
      options?: UseQueryOptions<GetBrandProductsForConsumerQuery, TError, TData>
    ) =>
    useQuery<GetBrandProductsForConsumerQuery, TError, TData>(
      ['GetBrandProductsForConsumer', variables],
      fetcher<GetBrandProductsForConsumerQuery, GetBrandProductsForConsumerQueryVariables>(GetBrandProductsForConsumerDocument, variables),
      options
    );
useGetBrandProductsForConsumerQuery.document = GetBrandProductsForConsumerDocument;


useGetBrandProductsForConsumerQuery.getKey = (variables: GetBrandProductsForConsumerQueryVariables) => ['GetBrandProductsForConsumer', variables];
;

useGetBrandProductsForConsumerQuery.fetcher = (variables: GetBrandProductsForConsumerQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandProductsForConsumerQuery, GetBrandProductsForConsumerQueryVariables>(GetBrandProductsForConsumerDocument, variables, options);
export const GetBrandStorefrontsForCreatorDocument = `
    query getBrandStorefrontsForCreator($abstractBrandId: String!, $searchTerm: String, $expertId: String) {
  getBrandStorefrontsForCreator(
    abstractBrandId: $abstractBrandId
    searchTerm: $searchTerm
    expertId: $expertId
  ) {
    storefront {
      store_name
      pages {
        store_page_id
        store_page_url
        store_page_name
        is_active
        is_primary
        links {
          id
          generated_link
          type
          meta_data
          is_active
          shortlink_id
          version
          source_id
          shortlink_slug
        }
      }
    }
  }
}
    `;
export const useGetBrandStorefrontsForCreatorQuery = <
      TData = GetBrandStorefrontsForCreatorQuery,
      TError = unknown
    >(
      variables: GetBrandStorefrontsForCreatorQueryVariables,
      options?: UseQueryOptions<GetBrandStorefrontsForCreatorQuery, TError, TData>
    ) =>
    useQuery<GetBrandStorefrontsForCreatorQuery, TError, TData>(
      ['getBrandStorefrontsForCreator', variables],
      fetcher<GetBrandStorefrontsForCreatorQuery, GetBrandStorefrontsForCreatorQueryVariables>(GetBrandStorefrontsForCreatorDocument, variables),
      options
    );
useGetBrandStorefrontsForCreatorQuery.document = GetBrandStorefrontsForCreatorDocument;


useGetBrandStorefrontsForCreatorQuery.getKey = (variables: GetBrandStorefrontsForCreatorQueryVariables) => ['getBrandStorefrontsForCreator', variables];
;

useGetBrandStorefrontsForCreatorQuery.fetcher = (variables: GetBrandStorefrontsForCreatorQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandStorefrontsForCreatorQuery, GetBrandStorefrontsForCreatorQueryVariables>(GetBrandStorefrontsForCreatorDocument, variables, options);
export const GetBrandUserDocument = `
    query getBrandUser($brandId: String) {
  getBrandUser(brandId: $brandId) {
    createdAt
    email
    firstName
    lastName
    id
    role
    brandId
  }
}
    `;
export const useGetBrandUserQuery = <
      TData = GetBrandUserQuery,
      TError = unknown
    >(
      variables?: GetBrandUserQueryVariables,
      options?: UseQueryOptions<GetBrandUserQuery, TError, TData>
    ) =>
    useQuery<GetBrandUserQuery, TError, TData>(
      variables === undefined ? ['getBrandUser'] : ['getBrandUser', variables],
      fetcher<GetBrandUserQuery, GetBrandUserQueryVariables>(GetBrandUserDocument, variables),
      options
    );
useGetBrandUserQuery.document = GetBrandUserDocument;


useGetBrandUserQuery.getKey = (variables?: GetBrandUserQueryVariables) => variables === undefined ? ['getBrandUser'] : ['getBrandUser', variables];
;

useGetBrandUserQuery.fetcher = (variables?: GetBrandUserQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandUserQuery, GetBrandUserQueryVariables>(GetBrandUserDocument, variables, options);
export const ListOrgUsersDocument = `
    query listOrgUsers($brandId: String!) {
  listOrgUsers(brandId: $brandId) {
    userCount
    users {
      createdAt
      email
      expiresAt
      id
      name
      role
      isOwner
      invitationAccepted
    }
  }
}
    `;
export const useListOrgUsersQuery = <
      TData = ListOrgUsersQuery,
      TError = unknown
    >(
      variables: ListOrgUsersQueryVariables,
      options?: UseQueryOptions<ListOrgUsersQuery, TError, TData>
    ) =>
    useQuery<ListOrgUsersQuery, TError, TData>(
      ['listOrgUsers', variables],
      fetcher<ListOrgUsersQuery, ListOrgUsersQueryVariables>(ListOrgUsersDocument, variables),
      options
    );
useListOrgUsersQuery.document = ListOrgUsersDocument;


useListOrgUsersQuery.getKey = (variables: ListOrgUsersQueryVariables) => ['listOrgUsers', variables];
;

useListOrgUsersQuery.fetcher = (variables: ListOrgUsersQueryVariables, options?: RequestInit['headers']) => fetcher<ListOrgUsersQuery, ListOrgUsersQueryVariables>(ListOrgUsersDocument, variables, options);
export const GetBrandsDocument = `
    query GetBrands($creatorId: String, $brandIds: [String!]!) {
  getBrands(creatorId: $creatorId, brandIds: $brandIds) {
    ...BrandResponseFields
  }
}
    ${BrandResponseFieldsFragmentDoc}`;
export const useGetBrandsQuery = <
      TData = GetBrandsQuery,
      TError = unknown
    >(
      variables: GetBrandsQueryVariables,
      options?: UseQueryOptions<GetBrandsQuery, TError, TData>
    ) =>
    useQuery<GetBrandsQuery, TError, TData>(
      ['GetBrands', variables],
      fetcher<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, variables),
      options
    );
useGetBrandsQuery.document = GetBrandsDocument;


useGetBrandsQuery.getKey = (variables: GetBrandsQueryVariables) => ['GetBrands', variables];
;

useGetBrandsQuery.fetcher = (variables: GetBrandsQueryVariables, options?: RequestInit['headers']) => fetcher<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, variables, options);
export const GetCategoriesDocument = `
    query getCategories($includeInvisible: Boolean) {
  getCategories(includeInvisible: $includeInvisible) {
    categories {
      ...ProductCategoriesFields
      children {
        ...ProductCategoriesFields
        children {
          ...ProductCategoriesFields
        }
      }
    }
  }
}
    ${ProductCategoriesFieldsFragmentDoc}`;
export const useGetCategoriesQuery = <
      TData = GetCategoriesQuery,
      TError = unknown
    >(
      variables?: GetCategoriesQueryVariables,
      options?: UseQueryOptions<GetCategoriesQuery, TError, TData>
    ) =>
    useQuery<GetCategoriesQuery, TError, TData>(
      variables === undefined ? ['getCategories'] : ['getCategories', variables],
      fetcher<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, variables),
      options
    );
useGetCategoriesQuery.document = GetCategoriesDocument;


useGetCategoriesQuery.getKey = (variables?: GetCategoriesQueryVariables) => variables === undefined ? ['getCategories'] : ['getCategories', variables];
;

useGetCategoriesQuery.fetcher = (variables?: GetCategoriesQueryVariables, options?: RequestInit['headers']) => fetcher<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, variables, options);
export const GetCategoryFullPathDocument = `
    query getCategoryFullPath($categoryIds: [String!]!) {
  getCategoryFullPath(categoryIds: $categoryIds) {
    categoryIds
  }
}
    `;
export const useGetCategoryFullPathQuery = <
      TData = GetCategoryFullPathQuery,
      TError = unknown
    >(
      variables: GetCategoryFullPathQueryVariables,
      options?: UseQueryOptions<GetCategoryFullPathQuery, TError, TData>
    ) =>
    useQuery<GetCategoryFullPathQuery, TError, TData>(
      ['getCategoryFullPath', variables],
      fetcher<GetCategoryFullPathQuery, GetCategoryFullPathQueryVariables>(GetCategoryFullPathDocument, variables),
      options
    );
useGetCategoryFullPathQuery.document = GetCategoryFullPathDocument;


useGetCategoryFullPathQuery.getKey = (variables: GetCategoryFullPathQueryVariables) => ['getCategoryFullPath', variables];
;

useGetCategoryFullPathQuery.fetcher = (variables: GetCategoryFullPathQueryVariables, options?: RequestInit['headers']) => fetcher<GetCategoryFullPathQuery, GetCategoryFullPathQueryVariables>(GetCategoryFullPathDocument, variables, options);
export const GetCollectionDocument = `
    query GetCollection($collectionId: String!) {
  getCollection(collectionId: $collectionId) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useGetCollectionQuery = <
      TData = GetCollectionQuery,
      TError = unknown
    >(
      variables: GetCollectionQueryVariables,
      options?: UseQueryOptions<GetCollectionQuery, TError, TData>
    ) =>
    useQuery<GetCollectionQuery, TError, TData>(
      ['GetCollection', variables],
      fetcher<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, variables),
      options
    );
useGetCollectionQuery.document = GetCollectionDocument;


useGetCollectionQuery.getKey = (variables: GetCollectionQueryVariables) => ['GetCollection', variables];
;

useGetCollectionQuery.fetcher = (variables: GetCollectionQueryVariables, options?: RequestInit['headers']) => fetcher<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, variables, options);
export const GetCollectionForPortalDocument = `
    query GetCollectionForPortal($collectionId: String!) {
  getCollection(collectionId: $collectionId) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useGetCollectionForPortalQuery = <
      TData = GetCollectionForPortalQuery,
      TError = unknown
    >(
      variables: GetCollectionForPortalQueryVariables,
      options?: UseQueryOptions<GetCollectionForPortalQuery, TError, TData>
    ) =>
    useQuery<GetCollectionForPortalQuery, TError, TData>(
      ['GetCollectionForPortal', variables],
      fetcher<GetCollectionForPortalQuery, GetCollectionForPortalQueryVariables>(GetCollectionForPortalDocument, variables),
      options
    );
useGetCollectionForPortalQuery.document = GetCollectionForPortalDocument;


useGetCollectionForPortalQuery.getKey = (variables: GetCollectionForPortalQueryVariables) => ['GetCollectionForPortal', variables];
;

useGetCollectionForPortalQuery.fetcher = (variables: GetCollectionForPortalQueryVariables, options?: RequestInit['headers']) => fetcher<GetCollectionForPortalQuery, GetCollectionForPortalQueryVariables>(GetCollectionForPortalDocument, variables, options);
export const GetCreatorConnectionDocument = `
    query getCreatorConnection($id: String) {
  getCreatorConnection(id: $id) {
    brandId
    id
    inviteEmail
    merchantToken
    status
  }
}
    `;
export const useGetCreatorConnectionQuery = <
      TData = GetCreatorConnectionQuery,
      TError = unknown
    >(
      variables?: GetCreatorConnectionQueryVariables,
      options?: UseQueryOptions<GetCreatorConnectionQuery, TError, TData>
    ) =>
    useQuery<GetCreatorConnectionQuery, TError, TData>(
      variables === undefined ? ['getCreatorConnection'] : ['getCreatorConnection', variables],
      fetcher<GetCreatorConnectionQuery, GetCreatorConnectionQueryVariables>(GetCreatorConnectionDocument, variables),
      options
    );
useGetCreatorConnectionQuery.document = GetCreatorConnectionDocument;


useGetCreatorConnectionQuery.getKey = (variables?: GetCreatorConnectionQueryVariables) => variables === undefined ? ['getCreatorConnection'] : ['getCreatorConnection', variables];
;

useGetCreatorConnectionQuery.fetcher = (variables?: GetCreatorConnectionQueryVariables, options?: RequestInit['headers']) => fetcher<GetCreatorConnectionQuery, GetCreatorConnectionQueryVariables>(GetCreatorConnectionDocument, variables, options);
export const GetCreatorOrdersDocument = `
    query GetCreatorOrders($creatorId: String, $expertName: String, $startKey: String) {
  getCreatorOrders(
    creatorId: $creatorId
    expertName: $expertName
    startKey: $startKey
  ) {
    date
    customer
    lineItems {
      name
      quantity
      grossSalesPrice
      salesTax
      discount
      commissionableSales
      commissionRate
      commissionType
      earnings
    }
    grossSalesPrice
    earnings
    paid
    paidDate
  }
}
    `;
export const useGetCreatorOrdersQuery = <
      TData = GetCreatorOrdersQuery,
      TError = unknown
    >(
      variables?: GetCreatorOrdersQueryVariables,
      options?: UseQueryOptions<GetCreatorOrdersQuery, TError, TData>
    ) =>
    useQuery<GetCreatorOrdersQuery, TError, TData>(
      variables === undefined ? ['GetCreatorOrders'] : ['GetCreatorOrders', variables],
      fetcher<GetCreatorOrdersQuery, GetCreatorOrdersQueryVariables>(GetCreatorOrdersDocument, variables),
      options
    );
useGetCreatorOrdersQuery.document = GetCreatorOrdersDocument;


useGetCreatorOrdersQuery.getKey = (variables?: GetCreatorOrdersQueryVariables) => variables === undefined ? ['GetCreatorOrders'] : ['GetCreatorOrders', variables];
;

useGetCreatorOrdersQuery.fetcher = (variables?: GetCreatorOrdersQueryVariables, options?: RequestInit['headers']) => fetcher<GetCreatorOrdersQuery, GetCreatorOrdersQueryVariables>(GetCreatorOrdersDocument, variables, options);
export const GetCreatorsForApprovalDocument = `
    query GetCreatorsForApproval($storeApprovalStatus: ApprovalStatus!, $pageNumber: Int!) {
  getCreatorsForApproval(
    storeApprovalStatus: $storeApprovalStatus
    pageNumber: $pageNumber
  ) {
    experts {
      id
      name
      instagramName
      contactInfo {
        email
        phone
        firstName
        lastName
      }
      socialMedia {
        instagramName
        facebookName
        tiktokName
        pinterestName
        youtubeName
        twitterName
        threadsName
        website
      }
      storeApprovalStatus
      onboardingDescription
      score
      amzStorefront
    }
    pageSize
    totalCount
    totalPages
    pageNumber
  }
}
    `;
export const useGetCreatorsForApprovalQuery = <
      TData = GetCreatorsForApprovalQuery,
      TError = unknown
    >(
      variables: GetCreatorsForApprovalQueryVariables,
      options?: UseQueryOptions<GetCreatorsForApprovalQuery, TError, TData>
    ) =>
    useQuery<GetCreatorsForApprovalQuery, TError, TData>(
      ['GetCreatorsForApproval', variables],
      fetcher<GetCreatorsForApprovalQuery, GetCreatorsForApprovalQueryVariables>(GetCreatorsForApprovalDocument, variables),
      options
    );
useGetCreatorsForApprovalQuery.document = GetCreatorsForApprovalDocument;


useGetCreatorsForApprovalQuery.getKey = (variables: GetCreatorsForApprovalQueryVariables) => ['GetCreatorsForApproval', variables];
;

useGetCreatorsForApprovalQuery.fetcher = (variables: GetCreatorsForApprovalQueryVariables, options?: RequestInit['headers']) => fetcher<GetCreatorsForApprovalQuery, GetCreatorsForApprovalQueryVariables>(GetCreatorsForApprovalDocument, variables, options);
export const GetCreatorsForBrandDocument = `
    query GetCreatorsForBrand($brandId: [String!], $isActiveFilter: IsActiveFilter!, $onlyStoresWithBrandProducts: Boolean!, $page: Int, $nichesFilter: [String!], $genderFilter: [String!], $petsFilter: [String!], $childrenFilter: [String!], $sortBy: String, $scoreFilter: String, $allBrands: Boolean, $isDisabled: Boolean, $isAssociateDisabled: Boolean, $isEligibleForAssociates: Boolean) {
  getCreatorsForBrand(
    brandId: $brandId
    isActiveFilter: $isActiveFilter
    onlyStoresWithBrandProducts: $onlyStoresWithBrandProducts
    page: $page
    nichesFilter: $nichesFilter
    genderFilter: $genderFilter
    petsFilter: $petsFilter
    childrenFilter: $childrenFilter
    sortBy: $sortBy
    scoreFilter: $scoreFilter
    allBrands: $allBrands
    isDisabled: $isDisabled
    isAssociateDisabled: $isAssociateDisabled
    isEligibleForAssociates: $isEligibleForAssociates
  ) {
    ...CreatorForBrandFields
  }
}
    ${CreatorForBrandFieldsFragmentDoc}`;
export const useGetCreatorsForBrandQuery = <
      TData = GetCreatorsForBrandQuery,
      TError = unknown
    >(
      variables: GetCreatorsForBrandQueryVariables,
      options?: UseQueryOptions<GetCreatorsForBrandQuery, TError, TData>
    ) =>
    useQuery<GetCreatorsForBrandQuery, TError, TData>(
      ['GetCreatorsForBrand', variables],
      fetcher<GetCreatorsForBrandQuery, GetCreatorsForBrandQueryVariables>(GetCreatorsForBrandDocument, variables),
      options
    );
useGetCreatorsForBrandQuery.document = GetCreatorsForBrandDocument;


useGetCreatorsForBrandQuery.getKey = (variables: GetCreatorsForBrandQueryVariables) => ['GetCreatorsForBrand', variables];
;

useGetCreatorsForBrandQuery.fetcher = (variables: GetCreatorsForBrandQueryVariables, options?: RequestInit['headers']) => fetcher<GetCreatorsForBrandQuery, GetCreatorsForBrandQueryVariables>(GetCreatorsForBrandDocument, variables, options);
export const GetDashboardProductsDocument = `
    query GetDashboardProducts($expertName: String!, $productIds: [String!]!, $isPreview: Boolean) {
  getProducts(
    expertName: $expertName
    productIds: $productIds
    isPreview: $isPreview
  ) {
    ...ProductFields
    price
    brandType
    viewAllLinks {
      id
      shortlinkId
      slug
      url
      linkType
      createdAt
      primaryTrackingId
      subTrackingId
      amzAssociateId
      sourceName
      shortlinkUrl
    }
    commission {
      id
      coverage
      amountType
      value
      amountValue
      name
      description
    }
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useGetDashboardProductsQuery = <
      TData = GetDashboardProductsQuery,
      TError = unknown
    >(
      variables: GetDashboardProductsQueryVariables,
      options?: UseQueryOptions<GetDashboardProductsQuery, TError, TData>
    ) =>
    useQuery<GetDashboardProductsQuery, TError, TData>(
      ['GetDashboardProducts', variables],
      fetcher<GetDashboardProductsQuery, GetDashboardProductsQueryVariables>(GetDashboardProductsDocument, variables),
      options
    );
useGetDashboardProductsQuery.document = GetDashboardProductsDocument;


useGetDashboardProductsQuery.getKey = (variables: GetDashboardProductsQueryVariables) => ['GetDashboardProducts', variables];
;

useGetDashboardProductsQuery.fetcher = (variables: GetDashboardProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetDashboardProductsQuery, GetDashboardProductsQueryVariables>(GetDashboardProductsDocument, variables, options);
export const GetDownloadReportStatusDocument = `
    query getDownloadReportStatus($reportId: String) {
  getDownloadReportStatus(reportId: $reportId) {
    url
    reportId
    reportType
    status
  }
}
    `;
export const useGetDownloadReportStatusQuery = <
      TData = GetDownloadReportStatusQuery,
      TError = unknown
    >(
      variables?: GetDownloadReportStatusQueryVariables,
      options?: UseQueryOptions<GetDownloadReportStatusQuery, TError, TData>
    ) =>
    useQuery<GetDownloadReportStatusQuery, TError, TData>(
      variables === undefined ? ['getDownloadReportStatus'] : ['getDownloadReportStatus', variables],
      fetcher<GetDownloadReportStatusQuery, GetDownloadReportStatusQueryVariables>(GetDownloadReportStatusDocument, variables),
      options
    );
useGetDownloadReportStatusQuery.document = GetDownloadReportStatusDocument;


useGetDownloadReportStatusQuery.getKey = (variables?: GetDownloadReportStatusQueryVariables) => variables === undefined ? ['getDownloadReportStatus'] : ['getDownloadReportStatus', variables];
;

useGetDownloadReportStatusQuery.fetcher = (variables?: GetDownloadReportStatusQueryVariables, options?: RequestInit['headers']) => fetcher<GetDownloadReportStatusQuery, GetDownloadReportStatusQueryVariables>(GetDownloadReportStatusDocument, variables, options);
export const GetExpertDocument = `
    query GetExpert($id: String, $expertName: String, $instagramName: String) {
  getExpert(id: $id, expertName: $expertName, instagramName: $instagramName) {
    id
    name
    instagramName
    instagramAuthorized
    theme
    hasBrexPayment
    storeApprovalStatus
    storeApprovedAt
    contactInfo {
      email
      phone
      firstName
      lastName
    }
    socialMedia {
      instagramName
      facebookName
      tiktokName
      pinterestName
      youtubeName
      twitterName
      threadsName
      website
    }
    bio
    niches
    address {
      city
      postal_code
      state_province
      street_address_1
      street_address_2
      mailing_address_first_name
      mailing_address_last_name
    }
    dateOfBirth
    gender
    children
    pets
    onboardingDescription
    score
    amzAssociateTag
    amzAssociateEnabled
    amzStorefront
    isAssociateEnabled
  }
}
    `;
export const useGetExpertQuery = <
      TData = GetExpertQuery,
      TError = unknown
    >(
      variables?: GetExpertQueryVariables,
      options?: UseQueryOptions<GetExpertQuery, TError, TData>
    ) =>
    useQuery<GetExpertQuery, TError, TData>(
      variables === undefined ? ['GetExpert'] : ['GetExpert', variables],
      fetcher<GetExpertQuery, GetExpertQueryVariables>(GetExpertDocument, variables),
      options
    );
useGetExpertQuery.document = GetExpertDocument;


useGetExpertQuery.getKey = (variables?: GetExpertQueryVariables) => variables === undefined ? ['GetExpert'] : ['GetExpert', variables];
;

useGetExpertQuery.fetcher = (variables?: GetExpertQueryVariables, options?: RequestInit['headers']) => fetcher<GetExpertQuery, GetExpertQueryVariables>(GetExpertDocument, variables, options);
export const ExpertAmazonSourcesDocument = `
    query ExpertAmazonSources($creatorId: String!) {
  expertAmazonLinkSources(creatorId: $creatorId) {
    id
    primaryTrackingId
    subTrackingId
    amzAssociateId
    sourceName
    campaignId
    tag
  }
}
    `;
export const useExpertAmazonSourcesQuery = <
      TData = ExpertAmazonSourcesQuery,
      TError = unknown
    >(
      variables: ExpertAmazonSourcesQueryVariables,
      options?: UseQueryOptions<ExpertAmazonSourcesQuery, TError, TData>
    ) =>
    useQuery<ExpertAmazonSourcesQuery, TError, TData>(
      ['ExpertAmazonSources', variables],
      fetcher<ExpertAmazonSourcesQuery, ExpertAmazonSourcesQueryVariables>(ExpertAmazonSourcesDocument, variables),
      options
    );
useExpertAmazonSourcesQuery.document = ExpertAmazonSourcesDocument;


useExpertAmazonSourcesQuery.getKey = (variables: ExpertAmazonSourcesQueryVariables) => ['ExpertAmazonSources', variables];
;

useExpertAmazonSourcesQuery.fetcher = (variables: ExpertAmazonSourcesQueryVariables, options?: RequestInit['headers']) => fetcher<ExpertAmazonSourcesQuery, ExpertAmazonSourcesQueryVariables>(ExpertAmazonSourcesDocument, variables, options);
export const GetExpertForPortalDocument = `
    query GetExpertForPortal($id: String, $expertName: String) {
  getExpertForPortal(id: $id, expertName: $expertName) {
    id
    name
    createdAt
    instagramName
    instagramAuthorized
    theme
    hasBrexPayment
    brexVendorId
    storeApprovalStatus
    storeApprovedAt
    contactInfo {
      email
      phone
      firstName
      lastName
    }
    bio
    socialMedia {
      instagramName
      facebookName
      tiktokName
      pinterestName
      youtubeName
      twitterName
      threadsName
    }
    amzAssociateTag
    amzAssociateEnabled
    address {
      street_address_1
      street_address_2
      city
      state_province
      postal_code
      mailing_address_first_name
      mailing_address_last_name
    }
    score
    isAssociateEnabled
  }
}
    `;
export const useGetExpertForPortalQuery = <
      TData = GetExpertForPortalQuery,
      TError = unknown
    >(
      variables?: GetExpertForPortalQueryVariables,
      options?: UseQueryOptions<GetExpertForPortalQuery, TError, TData>
    ) =>
    useQuery<GetExpertForPortalQuery, TError, TData>(
      variables === undefined ? ['GetExpertForPortal'] : ['GetExpertForPortal', variables],
      fetcher<GetExpertForPortalQuery, GetExpertForPortalQueryVariables>(GetExpertForPortalDocument, variables),
      options
    );
useGetExpertForPortalQuery.document = GetExpertForPortalDocument;


useGetExpertForPortalQuery.getKey = (variables?: GetExpertForPortalQueryVariables) => variables === undefined ? ['GetExpertForPortal'] : ['GetExpertForPortal', variables];
;

useGetExpertForPortalQuery.fetcher = (variables?: GetExpertForPortalQueryVariables, options?: RequestInit['headers']) => fetcher<GetExpertForPortalQuery, GetExpertForPortalQueryVariables>(GetExpertForPortalDocument, variables, options);
export const GetExpertPrivateCommissionsDocument = `
    query getExpertPrivateCommissions($creatorId: String!, $brandId: [String], $page: Int, $term: String, $isActive: Boolean, $isAssociateActive: Boolean, $sellerId: [String], $hasPrivateCommission: Boolean, $hasPrivateAssociateCommission: Boolean, $applyAttributionValueFilter: Boolean, $applyAssociateValueFilter: Boolean, $attributionFilter: OfferingCommissions, $associateFilter: OfferingCommissions) {
  getExpertPrivateCommissions(
    creatorId: $creatorId
    brandId: $brandId
    page: $page
    term: $term
    isActive: $isActive
    isAssociateActive: $isAssociateActive
    sellerId: $sellerId
    hasPrivateCommission: $hasPrivateCommission
    hasPrivateAssociateCommission: $hasPrivateAssociateCommission
    applyAttributionValueFilter: $applyAttributionValueFilter
    applyAssociateValueFilter: $applyAssociateValueFilter
    attributionFilter: $attributionFilter
    associateFilter: $associateFilter
  ) {
    products {
      brandId
      brandName
      amzSellerId
      commission {
        amountType
        amountValue
        coverage
        description
        id
        name
      }
      creator {
        storeName
        lastName
        firstName
      }
      externalProductId
      isActive
      price
      name
      productId
      updatedAt
      associateCommission {
        amountType
        amountValue
        coverage
        description
        id
        name
      }
      isAssociateActive
    }
    productCount
  }
}
    `;
export const useGetExpertPrivateCommissionsQuery = <
      TData = GetExpertPrivateCommissionsQuery,
      TError = unknown
    >(
      variables: GetExpertPrivateCommissionsQueryVariables,
      options?: UseQueryOptions<GetExpertPrivateCommissionsQuery, TError, TData>
    ) =>
    useQuery<GetExpertPrivateCommissionsQuery, TError, TData>(
      ['getExpertPrivateCommissions', variables],
      fetcher<GetExpertPrivateCommissionsQuery, GetExpertPrivateCommissionsQueryVariables>(GetExpertPrivateCommissionsDocument, variables),
      options
    );
useGetExpertPrivateCommissionsQuery.document = GetExpertPrivateCommissionsDocument;


useGetExpertPrivateCommissionsQuery.getKey = (variables: GetExpertPrivateCommissionsQueryVariables) => ['getExpertPrivateCommissions', variables];
;

useGetExpertPrivateCommissionsQuery.fetcher = (variables: GetExpertPrivateCommissionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetExpertPrivateCommissionsQuery, GetExpertPrivateCommissionsQueryVariables>(GetExpertPrivateCommissionsDocument, variables, options);
export const GetLanderProductDocument = `
    query GetLanderProduct($creatorName: String!, $productId: String!, $isPreview: Boolean!) {
  getProductDetails(
    creatorName: $creatorName
    productId: $productId
    isPreview: $isPreview
  ) {
    ...ProductFields
    landerMedia {
      ...MediaFields
    }
  }
}
    ${ProductFieldsFragmentDoc}
${MediaFieldsFragmentDoc}`;
export const useGetLanderProductQuery = <
      TData = GetLanderProductQuery,
      TError = unknown
    >(
      variables: GetLanderProductQueryVariables,
      options?: UseQueryOptions<GetLanderProductQuery, TError, TData>
    ) =>
    useQuery<GetLanderProductQuery, TError, TData>(
      ['GetLanderProduct', variables],
      fetcher<GetLanderProductQuery, GetLanderProductQueryVariables>(GetLanderProductDocument, variables),
      options
    );
useGetLanderProductQuery.document = GetLanderProductDocument;


useGetLanderProductQuery.getKey = (variables: GetLanderProductQueryVariables) => ['GetLanderProduct', variables];
;

useGetLanderProductQuery.fetcher = (variables: GetLanderProductQueryVariables, options?: RequestInit['headers']) => fetcher<GetLanderProductQuery, GetLanderProductQueryVariables>(GetLanderProductDocument, variables, options);
export const GetMediaDocument = `
    query GetMedia($expertName: String!, $tag: String) {
  getMedia(expertName: $expertName, tag: $tag) {
    id
    src
    alt
    createdAt
    mediaProductId
    tags
  }
}
    `;
export const useGetMediaQuery = <
      TData = GetMediaQuery,
      TError = unknown
    >(
      variables: GetMediaQueryVariables,
      options?: UseQueryOptions<GetMediaQuery, TError, TData>
    ) =>
    useQuery<GetMediaQuery, TError, TData>(
      ['GetMedia', variables],
      fetcher<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, variables),
      options
    );
useGetMediaQuery.document = GetMediaDocument;


useGetMediaQuery.getKey = (variables: GetMediaQueryVariables) => ['GetMedia', variables];
;

useGetMediaQuery.fetcher = (variables: GetMediaQueryVariables, options?: RequestInit['headers']) => fetcher<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, variables, options);
export const GetMediaUploadUrlDocument = `
    query GetMediaUploadUrl($expertName: String!, $fileSize: Int!, $fileType: String!) {
  getMediaUploadUrl(
    expertName: $expertName
    fileSize: $fileSize
    fileType: $fileType
  ) {
    id
    uploadUrl
    mediaUrl
  }
}
    `;
export const useGetMediaUploadUrlQuery = <
      TData = GetMediaUploadUrlQuery,
      TError = unknown
    >(
      variables: GetMediaUploadUrlQueryVariables,
      options?: UseQueryOptions<GetMediaUploadUrlQuery, TError, TData>
    ) =>
    useQuery<GetMediaUploadUrlQuery, TError, TData>(
      ['GetMediaUploadUrl', variables],
      fetcher<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>(GetMediaUploadUrlDocument, variables),
      options
    );
useGetMediaUploadUrlQuery.document = GetMediaUploadUrlDocument;


useGetMediaUploadUrlQuery.getKey = (variables: GetMediaUploadUrlQueryVariables) => ['GetMediaUploadUrl', variables];
;

useGetMediaUploadUrlQuery.fetcher = (variables: GetMediaUploadUrlQueryVariables, options?: RequestInit['headers']) => fetcher<GetMediaUploadUrlQuery, GetMediaUploadUrlQueryVariables>(GetMediaUploadUrlDocument, variables, options);
export const GetPartnershipsDocument = `
    query GetPartnerships($brandId: String, $creatorId: String, $partnershipStatusFilter: PartnershipStatus) {
  getPartnerships(
    brandId: $brandId
    creatorId: $creatorId
    partnershipStatusFilter: $partnershipStatusFilter
  ) {
    id
    partnershipStatus
    brandId
    brandName
    brandLogoUrl
    creatorId
    creatorName
    creatorContactFirstName
    creatorContactLastName
    creatorContactEmail
    creatorTheme
    creatorInstagram
    requestNotes
    requestedAt
    approvedAt
    rejectedAt
    commission {
      id
      coverage
      amountType
      value
      amountValue
      name
      description
    }
    discount {
      ...DiscountFields
    }
    metaData {
      productId
      asin
      brandName
      brandId
    }
    isAssociate
  }
}
    ${DiscountFieldsFragmentDoc}`;
export const useGetPartnershipsQuery = <
      TData = GetPartnershipsQuery,
      TError = unknown
    >(
      variables?: GetPartnershipsQueryVariables,
      options?: UseQueryOptions<GetPartnershipsQuery, TError, TData>
    ) =>
    useQuery<GetPartnershipsQuery, TError, TData>(
      variables === undefined ? ['GetPartnerships'] : ['GetPartnerships', variables],
      fetcher<GetPartnershipsQuery, GetPartnershipsQueryVariables>(GetPartnershipsDocument, variables),
      options
    );
useGetPartnershipsQuery.document = GetPartnershipsDocument;


useGetPartnershipsQuery.getKey = (variables?: GetPartnershipsQueryVariables) => variables === undefined ? ['GetPartnerships'] : ['GetPartnerships', variables];
;

useGetPartnershipsQuery.fetcher = (variables?: GetPartnershipsQueryVariables, options?: RequestInit['headers']) => fetcher<GetPartnershipsQuery, GetPartnershipsQueryVariables>(GetPartnershipsDocument, variables, options);
export const GetPostDocument = `
    query GetPost($postId: String!) {
  getPost(postId: $postId) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useGetPostQuery = <
      TData = GetPostQuery,
      TError = unknown
    >(
      variables: GetPostQueryVariables,
      options?: UseQueryOptions<GetPostQuery, TError, TData>
    ) =>
    useQuery<GetPostQuery, TError, TData>(
      ['GetPost', variables],
      fetcher<GetPostQuery, GetPostQueryVariables>(GetPostDocument, variables),
      options
    );
useGetPostQuery.document = GetPostDocument;


useGetPostQuery.getKey = (variables: GetPostQueryVariables) => ['GetPost', variables];
;

useGetPostQuery.fetcher = (variables: GetPostQueryVariables, options?: RequestInit['headers']) => fetcher<GetPostQuery, GetPostQueryVariables>(GetPostDocument, variables, options);
export const GetProductDocument = `
    query GetProduct($creatorName: String!, $productId: String!, $isPreview: Boolean!) {
  getProductDetails(
    creatorName: $creatorName
    productId: $productId
    isPreview: $isPreview
  ) {
    brandType
    ...ProductFields
    isActive
    setSize
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useGetProductQuery = <
      TData = GetProductQuery,
      TError = unknown
    >(
      variables: GetProductQueryVariables,
      options?: UseQueryOptions<GetProductQuery, TError, TData>
    ) =>
    useQuery<GetProductQuery, TError, TData>(
      ['GetProduct', variables],
      fetcher<GetProductQuery, GetProductQueryVariables>(GetProductDocument, variables),
      options
    );
useGetProductQuery.document = GetProductDocument;


useGetProductQuery.getKey = (variables: GetProductQueryVariables) => ['GetProduct', variables];
;

useGetProductQuery.fetcher = (variables: GetProductQueryVariables, options?: RequestInit['headers']) => fetcher<GetProductQuery, GetProductQueryVariables>(GetProductDocument, variables, options);
export const GetProductIdsForExpertDocument = `
    query GetProductIdsForExpert($expertName: String!, $isStoreVisibleFilter: IsStoreVisibleFilter) {
  getProductIdsForExpert(
    expertName: $expertName
    isStoreVisibleFilter: $isStoreVisibleFilter
  ) {
    id
    externalId
    shoppingType
  }
}
    `;
export const useGetProductIdsForExpertQuery = <
      TData = GetProductIdsForExpertQuery,
      TError = unknown
    >(
      variables: GetProductIdsForExpertQueryVariables,
      options?: UseQueryOptions<GetProductIdsForExpertQuery, TError, TData>
    ) =>
    useQuery<GetProductIdsForExpertQuery, TError, TData>(
      ['GetProductIdsForExpert', variables],
      fetcher<GetProductIdsForExpertQuery, GetProductIdsForExpertQueryVariables>(GetProductIdsForExpertDocument, variables),
      options
    );
useGetProductIdsForExpertQuery.document = GetProductIdsForExpertDocument;


useGetProductIdsForExpertQuery.getKey = (variables: GetProductIdsForExpertQueryVariables) => ['GetProductIdsForExpert', variables];
;

useGetProductIdsForExpertQuery.fetcher = (variables: GetProductIdsForExpertQueryVariables, options?: RequestInit['headers']) => fetcher<GetProductIdsForExpertQuery, GetProductIdsForExpertQueryVariables>(GetProductIdsForExpertDocument, variables, options);
export const ViewProductLinksDocument = `
    query ViewProductLinks($creatorId: String!, $productId: String!) {
  viewProductLinks(creatorId: $creatorId, productId: $productId) {
    id
    shortlinkId
    slug
    url
    linkType
    createdAt
    primaryTrackingId
    subTrackingId
    amzAssociateId
    sourceName
    shortlinkUrl
  }
}
    `;
export const useViewProductLinksQuery = <
      TData = ViewProductLinksQuery,
      TError = unknown
    >(
      variables: ViewProductLinksQueryVariables,
      options?: UseQueryOptions<ViewProductLinksQuery, TError, TData>
    ) =>
    useQuery<ViewProductLinksQuery, TError, TData>(
      ['ViewProductLinks', variables],
      fetcher<ViewProductLinksQuery, ViewProductLinksQueryVariables>(ViewProductLinksDocument, variables),
      options
    );
useViewProductLinksQuery.document = ViewProductLinksDocument;


useViewProductLinksQuery.getKey = (variables: ViewProductLinksQueryVariables) => ['ViewProductLinks', variables];
;

useViewProductLinksQuery.fetcher = (variables: ViewProductLinksQueryVariables, options?: RequestInit['headers']) => fetcher<ViewProductLinksQuery, ViewProductLinksQueryVariables>(ViewProductLinksDocument, variables, options);
export const GetProductSyncStatusDocument = `
    query GetProductSyncStatus($brandId: String!) {
  getProductSyncStatus(brandId: $brandId) {
    totalProducts
    syncedProducts
    syncComplete
  }
}
    `;
export const useGetProductSyncStatusQuery = <
      TData = GetProductSyncStatusQuery,
      TError = unknown
    >(
      variables: GetProductSyncStatusQueryVariables,
      options?: UseQueryOptions<GetProductSyncStatusQuery, TError, TData>
    ) =>
    useQuery<GetProductSyncStatusQuery, TError, TData>(
      ['GetProductSyncStatus', variables],
      fetcher<GetProductSyncStatusQuery, GetProductSyncStatusQueryVariables>(GetProductSyncStatusDocument, variables),
      options
    );
useGetProductSyncStatusQuery.document = GetProductSyncStatusDocument;


useGetProductSyncStatusQuery.getKey = (variables: GetProductSyncStatusQueryVariables) => ['GetProductSyncStatus', variables];
;

useGetProductSyncStatusQuery.fetcher = (variables: GetProductSyncStatusQueryVariables, options?: RequestInit['headers']) => fetcher<GetProductSyncStatusQuery, GetProductSyncStatusQueryVariables>(GetProductSyncStatusDocument, variables, options);
export const GetProductsDocument = `
    query GetProducts($expertName: String!, $productIds: [String!]!, $externalProductIds: [String!], $isPreview: Boolean) {
  getProducts(
    expertName: $expertName
    productIds: $productIds
    externalProductIds: $externalProductIds
    isPreview: $isPreview
  ) {
    ...ProductFields
    brandType
    setSize
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useGetProductsQuery = <
      TData = GetProductsQuery,
      TError = unknown
    >(
      variables: GetProductsQueryVariables,
      options?: UseQueryOptions<GetProductsQuery, TError, TData>
    ) =>
    useQuery<GetProductsQuery, TError, TData>(
      ['GetProducts', variables],
      fetcher<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, variables),
      options
    );
useGetProductsQuery.document = GetProductsDocument;


useGetProductsQuery.getKey = (variables: GetProductsQueryVariables) => ['GetProducts', variables];
;

useGetProductsQuery.fetcher = (variables: GetProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, variables, options);
export const GetRecommendedProductsDocument = `
    query GetRecommendedProducts($creatorId: String!) {
  getRecommendedProducts(creatorId: $creatorId) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useGetRecommendedProductsQuery = <
      TData = GetRecommendedProductsQuery,
      TError = unknown
    >(
      variables: GetRecommendedProductsQueryVariables,
      options?: UseQueryOptions<GetRecommendedProductsQuery, TError, TData>
    ) =>
    useQuery<GetRecommendedProductsQuery, TError, TData>(
      ['GetRecommendedProducts', variables],
      fetcher<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, variables),
      options
    );
useGetRecommendedProductsQuery.document = GetRecommendedProductsDocument;


useGetRecommendedProductsQuery.getKey = (variables: GetRecommendedProductsQueryVariables) => ['GetRecommendedProducts', variables];
;

useGetRecommendedProductsQuery.fetcher = (variables: GetRecommendedProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetRecommendedProductsQuery, GetRecommendedProductsQueryVariables>(GetRecommendedProductsDocument, variables, options);
export const GetShortlinkBySlugDocument = `
    query GetShortlinkBySlug($slug: String!) {
  getShortlinkBySlug(slug: $slug) {
    id
    slug
    linkType
    data
    createdAt
  }
}
    `;
export const useGetShortlinkBySlugQuery = <
      TData = GetShortlinkBySlugQuery,
      TError = unknown
    >(
      variables: GetShortlinkBySlugQueryVariables,
      options?: UseQueryOptions<GetShortlinkBySlugQuery, TError, TData>
    ) =>
    useQuery<GetShortlinkBySlugQuery, TError, TData>(
      ['GetShortlinkBySlug', variables],
      fetcher<GetShortlinkBySlugQuery, GetShortlinkBySlugQueryVariables>(GetShortlinkBySlugDocument, variables),
      options
    );
useGetShortlinkBySlugQuery.document = GetShortlinkBySlugDocument;


useGetShortlinkBySlugQuery.getKey = (variables: GetShortlinkBySlugQueryVariables) => ['GetShortlinkBySlug', variables];
;

useGetShortlinkBySlugQuery.fetcher = (variables: GetShortlinkBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetShortlinkBySlugQuery, GetShortlinkBySlugQueryVariables>(GetShortlinkBySlugDocument, variables, options);
export const GetStorefrontLinkSourcesForExpertDocument = `
    query getStorefrontLinkSourcesForExpert($expertId: String!) {
  getStorefrontLinkSourcesForExpert(expertId: $expertId) {
    sources {
      id
      sourceName
      primaryTrackingId
      subTrackingId
      amzAssociateTag
      tag
      campaignId
    }
  }
}
    `;
export const useGetStorefrontLinkSourcesForExpertQuery = <
      TData = GetStorefrontLinkSourcesForExpertQuery,
      TError = unknown
    >(
      variables: GetStorefrontLinkSourcesForExpertQueryVariables,
      options?: UseQueryOptions<GetStorefrontLinkSourcesForExpertQuery, TError, TData>
    ) =>
    useQuery<GetStorefrontLinkSourcesForExpertQuery, TError, TData>(
      ['getStorefrontLinkSourcesForExpert', variables],
      fetcher<GetStorefrontLinkSourcesForExpertQuery, GetStorefrontLinkSourcesForExpertQueryVariables>(GetStorefrontLinkSourcesForExpertDocument, variables),
      options
    );
useGetStorefrontLinkSourcesForExpertQuery.document = GetStorefrontLinkSourcesForExpertDocument;


useGetStorefrontLinkSourcesForExpertQuery.getKey = (variables: GetStorefrontLinkSourcesForExpertQueryVariables) => ['getStorefrontLinkSourcesForExpert', variables];
;

useGetStorefrontLinkSourcesForExpertQuery.fetcher = (variables: GetStorefrontLinkSourcesForExpertQueryVariables, options?: RequestInit['headers']) => fetcher<GetStorefrontLinkSourcesForExpertQuery, GetStorefrontLinkSourcesForExpertQueryVariables>(GetStorefrontLinkSourcesForExpertDocument, variables, options);
export const GetStorefrontsForBrandDocument = `
    query getStorefrontsForBrand($abstractBrandId: String!) {
  getStorefrontsForBrand(abstractBrandId: $abstractBrandId) {
    storefront {
      store_name
      pages {
        store_page_id
        store_page_url
        store_page_name
        is_active
        is_primary
      }
    }
  }
}
    `;
export const useGetStorefrontsForBrandQuery = <
      TData = GetStorefrontsForBrandQuery,
      TError = unknown
    >(
      variables: GetStorefrontsForBrandQueryVariables,
      options?: UseQueryOptions<GetStorefrontsForBrandQuery, TError, TData>
    ) =>
    useQuery<GetStorefrontsForBrandQuery, TError, TData>(
      ['getStorefrontsForBrand', variables],
      fetcher<GetStorefrontsForBrandQuery, GetStorefrontsForBrandQueryVariables>(GetStorefrontsForBrandDocument, variables),
      options
    );
useGetStorefrontsForBrandQuery.document = GetStorefrontsForBrandDocument;


useGetStorefrontsForBrandQuery.getKey = (variables: GetStorefrontsForBrandQueryVariables) => ['getStorefrontsForBrand', variables];
;

useGetStorefrontsForBrandQuery.fetcher = (variables: GetStorefrontsForBrandQueryVariables, options?: RequestInit['headers']) => fetcher<GetStorefrontsForBrandQuery, GetStorefrontsForBrandQueryVariables>(GetStorefrontsForBrandDocument, variables, options);
export const GetStripeBillingDocument = `
    query getStripeBilling($brandId: String!) {
  getStripeBilling(brandId: $brandId) {
    paymentMethodAttached
  }
}
    `;
export const useGetStripeBillingQuery = <
      TData = GetStripeBillingQuery,
      TError = unknown
    >(
      variables: GetStripeBillingQueryVariables,
      options?: UseQueryOptions<GetStripeBillingQuery, TError, TData>
    ) =>
    useQuery<GetStripeBillingQuery, TError, TData>(
      ['getStripeBilling', variables],
      fetcher<GetStripeBillingQuery, GetStripeBillingQueryVariables>(GetStripeBillingDocument, variables),
      options
    );
useGetStripeBillingQuery.document = GetStripeBillingDocument;


useGetStripeBillingQuery.getKey = (variables: GetStripeBillingQueryVariables) => ['getStripeBilling', variables];
;

useGetStripeBillingQuery.fetcher = (variables: GetStripeBillingQueryVariables, options?: RequestInit['headers']) => fetcher<GetStripeBillingQuery, GetStripeBillingQueryVariables>(GetStripeBillingDocument, variables, options);
export const GetUploadRequestStatusDocument = `
    query getUploadRequestStatus($reportId: String!) {
  getUploadRequestStatus(reportId: $reportId) {
    reportId
    reportType
    status
    url
    summary {
      totalRows
      totalSuccessRows
      processedRows
      totalErrorRows
      message
      successData {
        rowNum
        message
        key
        fields {
          field
          currentValue
          newValue
        }
      }
      errorData {
        rowNum
        message
        key
        fields {
          field
          currentValue
          newValue
        }
      }
    }
  }
}
    `;
export const useGetUploadRequestStatusQuery = <
      TData = GetUploadRequestStatusQuery,
      TError = unknown
    >(
      variables: GetUploadRequestStatusQueryVariables,
      options?: UseQueryOptions<GetUploadRequestStatusQuery, TError, TData>
    ) =>
    useQuery<GetUploadRequestStatusQuery, TError, TData>(
      ['getUploadRequestStatus', variables],
      fetcher<GetUploadRequestStatusQuery, GetUploadRequestStatusQueryVariables>(GetUploadRequestStatusDocument, variables),
      options
    );
useGetUploadRequestStatusQuery.document = GetUploadRequestStatusDocument;


useGetUploadRequestStatusQuery.getKey = (variables: GetUploadRequestStatusQueryVariables) => ['getUploadRequestStatus', variables];
;

useGetUploadRequestStatusQuery.fetcher = (variables: GetUploadRequestStatusQueryVariables, options?: RequestInit['headers']) => fetcher<GetUploadRequestStatusQuery, GetUploadRequestStatusQueryVariables>(GetUploadRequestStatusDocument, variables, options);
export const GetVisibleProductsDocument = `
    query GetVisibleProducts($expertName: String!, $productIds: [String!]!, $externalProductIds: [String!], $isPreview: Boolean) {
  getProducts(
    expertName: $expertName
    productIds: $productIds
    externalProductIds: $externalProductIds
    isPreview: $isPreview
  ) {
    id
    externalId
    isVisibleInStore
  }
}
    `;
export const useGetVisibleProductsQuery = <
      TData = GetVisibleProductsQuery,
      TError = unknown
    >(
      variables: GetVisibleProductsQueryVariables,
      options?: UseQueryOptions<GetVisibleProductsQuery, TError, TData>
    ) =>
    useQuery<GetVisibleProductsQuery, TError, TData>(
      ['GetVisibleProducts', variables],
      fetcher<GetVisibleProductsQuery, GetVisibleProductsQueryVariables>(GetVisibleProductsDocument, variables),
      options
    );
useGetVisibleProductsQuery.document = GetVisibleProductsDocument;


useGetVisibleProductsQuery.getKey = (variables: GetVisibleProductsQueryVariables) => ['GetVisibleProducts', variables];
;

useGetVisibleProductsQuery.fetcher = (variables: GetVisibleProductsQueryVariables, options?: RequestInit['headers']) => fetcher<GetVisibleProductsQuery, GetVisibleProductsQueryVariables>(GetVisibleProductsDocument, variables, options);
export const CreateInviteToOrgDocument = `
    mutation createInviteToOrg($brandId: String!, $email: String!, $firstName: String, $lastName: String) {
  createInviteToOrg(
    brandId: $brandId
    email: $email
    firstName: $firstName
    lastName: $lastName
  )
}
    `;
export const useCreateInviteToOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateInviteToOrgMutation, TError, CreateInviteToOrgMutationVariables, TContext>) =>
    useMutation<CreateInviteToOrgMutation, TError, CreateInviteToOrgMutationVariables, TContext>(
      ['createInviteToOrg'],
      (variables?: CreateInviteToOrgMutationVariables) => fetcher<CreateInviteToOrgMutation, CreateInviteToOrgMutationVariables>(CreateInviteToOrgDocument, variables)(),
      options
    );
useCreateInviteToOrgMutation.getKey = () => ['createInviteToOrg'];

useCreateInviteToOrgMutation.fetcher = (variables: CreateInviteToOrgMutationVariables, options?: RequestInit['headers']) => fetcher<CreateInviteToOrgMutation, CreateInviteToOrgMutationVariables>(CreateInviteToOrgDocument, variables, options);
export const ListAmazonBrandItemsDocument = `
    query listAmazonBrandItems($brandId: String!, $page: Int, $term: String, $childBrandIds: [String], $isAttributionActive: Boolean, $isAssociateActive: Boolean) {
  listAmazonBrandItems(
    brandId: $brandId
    page: $page
    term: $term
    childBrandIds: $childBrandIds
    isAttributionActive: $isAttributionActive
    isAssociateActive: $isAssociateActive
  ) {
    brandCount
    brands {
      id
      brandName
      sellerAccount
      status
      enabledProducts
      brandLogo
      brandBio
      commission {
        amountType
        amountValue
      }
      isAttributionActive
      isAssociateActive
      associateProductCount
      childBrands {
        id
        brandName
        sellerAccount
        status
        enabledProducts
        brandLogo
        abstractBrandId
        isAttributionActive
        isAssociateActive
        associateProductCount
      }
    }
  }
}
    `;
export const useListAmazonBrandItemsQuery = <
      TData = ListAmazonBrandItemsQuery,
      TError = unknown
    >(
      variables: ListAmazonBrandItemsQueryVariables,
      options?: UseQueryOptions<ListAmazonBrandItemsQuery, TError, TData>
    ) =>
    useQuery<ListAmazonBrandItemsQuery, TError, TData>(
      ['listAmazonBrandItems', variables],
      fetcher<ListAmazonBrandItemsQuery, ListAmazonBrandItemsQueryVariables>(ListAmazonBrandItemsDocument, variables),
      options
    );
useListAmazonBrandItemsQuery.document = ListAmazonBrandItemsDocument;


useListAmazonBrandItemsQuery.getKey = (variables: ListAmazonBrandItemsQueryVariables) => ['listAmazonBrandItems', variables];
;

useListAmazonBrandItemsQuery.fetcher = (variables: ListAmazonBrandItemsQueryVariables, options?: RequestInit['headers']) => fetcher<ListAmazonBrandItemsQuery, ListAmazonBrandItemsQueryVariables>(ListAmazonBrandItemsDocument, variables, options);
export const ListBrandNamesDocument = `
    query ListBrandNames($term: String, $carouselId: String, $categoryId: String, $creatorId: String) {
  listBrandNames(
    term: $term
    carouselId: $carouselId
    categoryId: $categoryId
    creatorId: $creatorId
  ) {
    id
    brandName
    brandType
  }
}
    `;
export const useListBrandNamesQuery = <
      TData = ListBrandNamesQuery,
      TError = unknown
    >(
      variables?: ListBrandNamesQueryVariables,
      options?: UseQueryOptions<ListBrandNamesQuery, TError, TData>
    ) =>
    useQuery<ListBrandNamesQuery, TError, TData>(
      variables === undefined ? ['ListBrandNames'] : ['ListBrandNames', variables],
      fetcher<ListBrandNamesQuery, ListBrandNamesQueryVariables>(ListBrandNamesDocument, variables),
      options
    );
useListBrandNamesQuery.document = ListBrandNamesDocument;


useListBrandNamesQuery.getKey = (variables?: ListBrandNamesQueryVariables) => variables === undefined ? ['ListBrandNames'] : ['ListBrandNames', variables];
;

useListBrandNamesQuery.fetcher = (variables?: ListBrandNamesQueryVariables, options?: RequestInit['headers']) => fetcher<ListBrandNamesQuery, ListBrandNamesQueryVariables>(ListBrandNamesDocument, variables, options);
export const ListBrandsDocument = `
    query ListBrands($page: Int!, $creatorId: String, $brandType: [String], $relationshipStatus: [String], $orderBy: String, $sortBy: String, $name: String, $categoryId: String, $pageSize: Int) {
  listBrands(
    page: $page
    creatorId: $creatorId
    brandType: $brandType
    relationshipStatus: $relationshipStatus
    orderBy: $orderBy
    sortBy: $sortBy
    name: $name
    categoryId: $categoryId
    pageSize: $pageSize
  ) {
    brands {
      ...BrandResponseFields
    }
    brandCount
  }
}
    ${BrandResponseFieldsFragmentDoc}`;
export const useListBrandsQuery = <
      TData = ListBrandsQuery,
      TError = unknown
    >(
      variables: ListBrandsQueryVariables,
      options?: UseQueryOptions<ListBrandsQuery, TError, TData>
    ) =>
    useQuery<ListBrandsQuery, TError, TData>(
      ['ListBrands', variables],
      fetcher<ListBrandsQuery, ListBrandsQueryVariables>(ListBrandsDocument, variables),
      options
    );
useListBrandsQuery.document = ListBrandsDocument;


useListBrandsQuery.getKey = (variables: ListBrandsQueryVariables) => ['ListBrands', variables];
;

useListBrandsQuery.fetcher = (variables: ListBrandsQueryVariables, options?: RequestInit['headers']) => fetcher<ListBrandsQuery, ListBrandsQueryVariables>(ListBrandsDocument, variables, options);
export const ListCollectionsDocument = `
    query ListCollections($expertName: String!) {
  listCollections(expertName: $expertName) {
    ...CollectionFields
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useListCollectionsQuery = <
      TData = ListCollectionsQuery,
      TError = unknown
    >(
      variables: ListCollectionsQueryVariables,
      options?: UseQueryOptions<ListCollectionsQuery, TError, TData>
    ) =>
    useQuery<ListCollectionsQuery, TError, TData>(
      ['ListCollections', variables],
      fetcher<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, variables),
      options
    );
useListCollectionsQuery.document = ListCollectionsDocument;


useListCollectionsQuery.getKey = (variables: ListCollectionsQueryVariables) => ['ListCollections', variables];
;

useListCollectionsQuery.fetcher = (variables: ListCollectionsQueryVariables, options?: RequestInit['headers']) => fetcher<ListCollectionsQuery, ListCollectionsQueryVariables>(ListCollectionsDocument, variables, options);
export const ListCollectionsForNavigationDocument = `
    query ListCollectionsForNavigation($expertName: String!) {
  listCollections(expertName: $expertName) {
    id
    slug
    name
    displayInNavigation
  }
}
    `;
export const useListCollectionsForNavigationQuery = <
      TData = ListCollectionsForNavigationQuery,
      TError = unknown
    >(
      variables: ListCollectionsForNavigationQueryVariables,
      options?: UseQueryOptions<ListCollectionsForNavigationQuery, TError, TData>
    ) =>
    useQuery<ListCollectionsForNavigationQuery, TError, TData>(
      ['ListCollectionsForNavigation', variables],
      fetcher<ListCollectionsForNavigationQuery, ListCollectionsForNavigationQueryVariables>(ListCollectionsForNavigationDocument, variables),
      options
    );
useListCollectionsForNavigationQuery.document = ListCollectionsForNavigationDocument;


useListCollectionsForNavigationQuery.getKey = (variables: ListCollectionsForNavigationQueryVariables) => ['ListCollectionsForNavigation', variables];
;

useListCollectionsForNavigationQuery.fetcher = (variables: ListCollectionsForNavigationQueryVariables, options?: RequestInit['headers']) => fetcher<ListCollectionsForNavigationQuery, ListCollectionsForNavigationQueryVariables>(ListCollectionsForNavigationDocument, variables, options);
export const ListCollectionsNoProductsDocument = `
    query ListCollectionsNoProducts($expertName: String!) {
  listCollections(expertName: $expertName) {
    id
    name
    slug
    description
    displayInNavigation
    displayInHomePage
    bannerImageUrl
  }
}
    `;
export const useListCollectionsNoProductsQuery = <
      TData = ListCollectionsNoProductsQuery,
      TError = unknown
    >(
      variables: ListCollectionsNoProductsQueryVariables,
      options?: UseQueryOptions<ListCollectionsNoProductsQuery, TError, TData>
    ) =>
    useQuery<ListCollectionsNoProductsQuery, TError, TData>(
      ['ListCollectionsNoProducts', variables],
      fetcher<ListCollectionsNoProductsQuery, ListCollectionsNoProductsQueryVariables>(ListCollectionsNoProductsDocument, variables),
      options
    );
useListCollectionsNoProductsQuery.document = ListCollectionsNoProductsDocument;


useListCollectionsNoProductsQuery.getKey = (variables: ListCollectionsNoProductsQueryVariables) => ['ListCollectionsNoProducts', variables];
;

useListCollectionsNoProductsQuery.fetcher = (variables: ListCollectionsNoProductsQueryVariables, options?: RequestInit['headers']) => fetcher<ListCollectionsNoProductsQuery, ListCollectionsNoProductsQueryVariables>(ListCollectionsNoProductsDocument, variables, options);
export const ListCollectionsWithProductsDocument = `
    query ListCollectionsWithProducts($expertName: String!) {
  listCollections(expertName: $expertName) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useListCollectionsWithProductsQuery = <
      TData = ListCollectionsWithProductsQuery,
      TError = unknown
    >(
      variables: ListCollectionsWithProductsQueryVariables,
      options?: UseQueryOptions<ListCollectionsWithProductsQuery, TError, TData>
    ) =>
    useQuery<ListCollectionsWithProductsQuery, TError, TData>(
      ['ListCollectionsWithProducts', variables],
      fetcher<ListCollectionsWithProductsQuery, ListCollectionsWithProductsQueryVariables>(ListCollectionsWithProductsDocument, variables),
      options
    );
useListCollectionsWithProductsQuery.document = ListCollectionsWithProductsDocument;


useListCollectionsWithProductsQuery.getKey = (variables: ListCollectionsWithProductsQueryVariables) => ['ListCollectionsWithProducts', variables];
;

useListCollectionsWithProductsQuery.fetcher = (variables: ListCollectionsWithProductsQueryVariables, options?: RequestInit['headers']) => fetcher<ListCollectionsWithProductsQuery, ListCollectionsWithProductsQueryVariables>(ListCollectionsWithProductsDocument, variables, options);
export const ListCreatorConnectionsDocument = `
    query listCreatorConnections($brandId: String) {
  listCreatorConnections(brandId: $brandId) {
    brandId
    id
    inviteEmail
    merchantToken
    status
  }
}
    `;
export const useListCreatorConnectionsQuery = <
      TData = ListCreatorConnectionsQuery,
      TError = unknown
    >(
      variables?: ListCreatorConnectionsQueryVariables,
      options?: UseQueryOptions<ListCreatorConnectionsQuery, TError, TData>
    ) =>
    useQuery<ListCreatorConnectionsQuery, TError, TData>(
      variables === undefined ? ['listCreatorConnections'] : ['listCreatorConnections', variables],
      fetcher<ListCreatorConnectionsQuery, ListCreatorConnectionsQueryVariables>(ListCreatorConnectionsDocument, variables),
      options
    );
useListCreatorConnectionsQuery.document = ListCreatorConnectionsDocument;


useListCreatorConnectionsQuery.getKey = (variables?: ListCreatorConnectionsQueryVariables) => variables === undefined ? ['listCreatorConnections'] : ['listCreatorConnections', variables];
;

useListCreatorConnectionsQuery.fetcher = (variables?: ListCreatorConnectionsQueryVariables, options?: RequestInit['headers']) => fetcher<ListCreatorConnectionsQuery, ListCreatorConnectionsQueryVariables>(ListCreatorConnectionsDocument, variables, options);
export const ListCustomersDocument = `
    query ListCustomers($creatorId: String!, $startKey: String) {
  listCustomers(creatorId: $creatorId, startKey: $startKey) {
    customers {
      name
      email
      stateCode
      firstPurchaseDate
      totalPurchases
      totalGmvPurchased
    }
    nextPageStartKey
  }
}
    `;
export const useListCustomersQuery = <
      TData = ListCustomersQuery,
      TError = unknown
    >(
      variables: ListCustomersQueryVariables,
      options?: UseQueryOptions<ListCustomersQuery, TError, TData>
    ) =>
    useQuery<ListCustomersQuery, TError, TData>(
      ['ListCustomers', variables],
      fetcher<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, variables),
      options
    );
useListCustomersQuery.document = ListCustomersDocument;


useListCustomersQuery.getKey = (variables: ListCustomersQueryVariables) => ['ListCustomers', variables];
;

useListCustomersQuery.fetcher = (variables: ListCustomersQueryVariables, options?: RequestInit['headers']) => fetcher<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, variables, options);
export const ListPostsDocument = `
    query ListPosts($creatorName: String!, $page: Int!) {
  listPosts(creatorName: $creatorName, page: $page) {
    ...CollectionFields
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useListPostsQuery = <
      TData = ListPostsQuery,
      TError = unknown
    >(
      variables: ListPostsQueryVariables,
      options?: UseQueryOptions<ListPostsQuery, TError, TData>
    ) =>
    useQuery<ListPostsQuery, TError, TData>(
      ['ListPosts', variables],
      fetcher<ListPostsQuery, ListPostsQueryVariables>(ListPostsDocument, variables),
      options
    );
useListPostsQuery.document = ListPostsDocument;


useListPostsQuery.getKey = (variables: ListPostsQueryVariables) => ['ListPosts', variables];
;

useListPostsQuery.fetcher = (variables: ListPostsQueryVariables, options?: RequestInit['headers']) => fetcher<ListPostsQuery, ListPostsQueryVariables>(ListPostsDocument, variables, options);
export const ListRecommendationsDocument = `
    query listRecommendations($creatorId: String!, $context: RecommendationContext!) {
  listRecommendations(creatorId: $creatorId, context: $context) {
    id
    title
    description
    productIds
  }
}
    `;
export const useListRecommendationsQuery = <
      TData = ListRecommendationsQuery,
      TError = unknown
    >(
      variables: ListRecommendationsQueryVariables,
      options?: UseQueryOptions<ListRecommendationsQuery, TError, TData>
    ) =>
    useQuery<ListRecommendationsQuery, TError, TData>(
      ['listRecommendations', variables],
      fetcher<ListRecommendationsQuery, ListRecommendationsQueryVariables>(ListRecommendationsDocument, variables),
      options
    );
useListRecommendationsQuery.document = ListRecommendationsDocument;


useListRecommendationsQuery.getKey = (variables: ListRecommendationsQueryVariables) => ['listRecommendations', variables];
;

useListRecommendationsQuery.fetcher = (variables: ListRecommendationsQueryVariables, options?: RequestInit['headers']) => fetcher<ListRecommendationsQuery, ListRecommendationsQueryVariables>(ListRecommendationsDocument, variables, options);
export const ListUserBrandsDocument = `
    query listUserBrands($brandId: String) {
  listUserBrands(brandId: $brandId) {
    brandId
    id
    name
    onboardingStatus
    isOwner
    syncBrandCount
    activeBrandCount
  }
}
    `;
export const useListUserBrandsQuery = <
      TData = ListUserBrandsQuery,
      TError = unknown
    >(
      variables?: ListUserBrandsQueryVariables,
      options?: UseQueryOptions<ListUserBrandsQuery, TError, TData>
    ) =>
    useQuery<ListUserBrandsQuery, TError, TData>(
      variables === undefined ? ['listUserBrands'] : ['listUserBrands', variables],
      fetcher<ListUserBrandsQuery, ListUserBrandsQueryVariables>(ListUserBrandsDocument, variables),
      options
    );
useListUserBrandsQuery.document = ListUserBrandsDocument;


useListUserBrandsQuery.getKey = (variables?: ListUserBrandsQueryVariables) => variables === undefined ? ['listUserBrands'] : ['listUserBrands', variables];
;

useListUserBrandsQuery.fetcher = (variables?: ListUserBrandsQueryVariables, options?: RequestInit['headers']) => fetcher<ListUserBrandsQuery, ListUserBrandsQueryVariables>(ListUserBrandsDocument, variables, options);
export const MergeBrandsToNewAbstractBrandDocument = `
    mutation mergeBrandsToNewAbstractBrand($abstractBrandName: String!, $brandId: String!, $childBrandIds: [String!]!, $abstractBrandBio: String, $abstractBrandCommission: String, $abstractBrandLogo: String, $setDefaultCommission: Boolean, $isHidden: Boolean, $requiresApproval: Boolean, $isApproved: Boolean, $deferBrand: String) {
  mergeBrandsToNewAbstractBrand(
    abstractBrandName: $abstractBrandName
    brandId: $brandId
    childBrandIds: $childBrandIds
    abstractBrandBio: $abstractBrandBio
    abstractBrandCommission: $abstractBrandCommission
    abstractBrandLogo: $abstractBrandLogo
    setDefaultCommission: $setDefaultCommission
    isHidden: $isHidden
    requiresApproval: $requiresApproval
    isApproved: $isApproved
    deferBrand: $deferBrand
  ) {
    error
    success
    abstractBrandId
  }
}
    `;
export const useMergeBrandsToNewAbstractBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeBrandsToNewAbstractBrandMutation, TError, MergeBrandsToNewAbstractBrandMutationVariables, TContext>) =>
    useMutation<MergeBrandsToNewAbstractBrandMutation, TError, MergeBrandsToNewAbstractBrandMutationVariables, TContext>(
      ['mergeBrandsToNewAbstractBrand'],
      (variables?: MergeBrandsToNewAbstractBrandMutationVariables) => fetcher<MergeBrandsToNewAbstractBrandMutation, MergeBrandsToNewAbstractBrandMutationVariables>(MergeBrandsToNewAbstractBrandDocument, variables)(),
      options
    );
useMergeBrandsToNewAbstractBrandMutation.getKey = () => ['mergeBrandsToNewAbstractBrand'];

useMergeBrandsToNewAbstractBrandMutation.fetcher = (variables: MergeBrandsToNewAbstractBrandMutationVariables, options?: RequestInit['headers']) => fetcher<MergeBrandsToNewAbstractBrandMutation, MergeBrandsToNewAbstractBrandMutationVariables>(MergeBrandsToNewAbstractBrandDocument, variables, options);
export const MergeChildBrandIntoExistingAbstractBrandDocument = `
    mutation mergeChildBrandIntoExistingAbstractBrand($abstractBrandId: String!, $childBrandIds: [String!]!) {
  mergeChildBrandIntoExistingAbstractBrand(
    abstractBrandId: $abstractBrandId
    childBrandIds: $childBrandIds
  ) {
    brandId
    success
    error
  }
}
    `;
export const useMergeChildBrandIntoExistingAbstractBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeChildBrandIntoExistingAbstractBrandMutation, TError, MergeChildBrandIntoExistingAbstractBrandMutationVariables, TContext>) =>
    useMutation<MergeChildBrandIntoExistingAbstractBrandMutation, TError, MergeChildBrandIntoExistingAbstractBrandMutationVariables, TContext>(
      ['mergeChildBrandIntoExistingAbstractBrand'],
      (variables?: MergeChildBrandIntoExistingAbstractBrandMutationVariables) => fetcher<MergeChildBrandIntoExistingAbstractBrandMutation, MergeChildBrandIntoExistingAbstractBrandMutationVariables>(MergeChildBrandIntoExistingAbstractBrandDocument, variables)(),
      options
    );
useMergeChildBrandIntoExistingAbstractBrandMutation.getKey = () => ['mergeChildBrandIntoExistingAbstractBrand'];

useMergeChildBrandIntoExistingAbstractBrandMutation.fetcher = (variables: MergeChildBrandIntoExistingAbstractBrandMutationVariables, options?: RequestInit['headers']) => fetcher<MergeChildBrandIntoExistingAbstractBrandMutation, MergeChildBrandIntoExistingAbstractBrandMutationVariables>(MergeChildBrandIntoExistingAbstractBrandDocument, variables, options);
export const DeleteUserOrgDocument = `
    mutation deleteUserOrg($id: String!, $isInvited: Boolean) {
  deleteUserOrg(id: $id, isInvited: $isInvited)
}
    `;
export const useDeleteUserOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserOrgMutation, TError, DeleteUserOrgMutationVariables, TContext>) =>
    useMutation<DeleteUserOrgMutation, TError, DeleteUserOrgMutationVariables, TContext>(
      ['deleteUserOrg'],
      (variables?: DeleteUserOrgMutationVariables) => fetcher<DeleteUserOrgMutation, DeleteUserOrgMutationVariables>(DeleteUserOrgDocument, variables)(),
      options
    );
useDeleteUserOrgMutation.getKey = () => ['deleteUserOrg'];

useDeleteUserOrgMutation.fetcher = (variables: DeleteUserOrgMutationVariables, options?: RequestInit['headers']) => fetcher<DeleteUserOrgMutation, DeleteUserOrgMutationVariables>(DeleteUserOrgDocument, variables, options);
export const RemoveExpertPrivateAssociateCommissionDocument = `
    mutation removeExpertPrivateAssociateCommission($expertId: [String], $productId: [String]) {
  removeExpertPrivateAssociateCommission(
    expertId: $expertId
    productId: $productId
  )
}
    `;
export const useRemoveExpertPrivateAssociateCommissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveExpertPrivateAssociateCommissionMutation, TError, RemoveExpertPrivateAssociateCommissionMutationVariables, TContext>) =>
    useMutation<RemoveExpertPrivateAssociateCommissionMutation, TError, RemoveExpertPrivateAssociateCommissionMutationVariables, TContext>(
      ['removeExpertPrivateAssociateCommission'],
      (variables?: RemoveExpertPrivateAssociateCommissionMutationVariables) => fetcher<RemoveExpertPrivateAssociateCommissionMutation, RemoveExpertPrivateAssociateCommissionMutationVariables>(RemoveExpertPrivateAssociateCommissionDocument, variables)(),
      options
    );
useRemoveExpertPrivateAssociateCommissionMutation.getKey = () => ['removeExpertPrivateAssociateCommission'];

useRemoveExpertPrivateAssociateCommissionMutation.fetcher = (variables?: RemoveExpertPrivateAssociateCommissionMutationVariables, options?: RequestInit['headers']) => fetcher<RemoveExpertPrivateAssociateCommissionMutation, RemoveExpertPrivateAssociateCommissionMutationVariables>(RemoveExpertPrivateAssociateCommissionDocument, variables, options);
export const RemoveExpertPrivateCommissionDocument = `
    mutation RemoveExpertPrivateCommission($expertId: [String], $productId: [String]) {
  removeExpertPrivateCommission(expertId: $expertId, productId: $productId)
}
    `;
export const useRemoveExpertPrivateCommissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveExpertPrivateCommissionMutation, TError, RemoveExpertPrivateCommissionMutationVariables, TContext>) =>
    useMutation<RemoveExpertPrivateCommissionMutation, TError, RemoveExpertPrivateCommissionMutationVariables, TContext>(
      ['RemoveExpertPrivateCommission'],
      (variables?: RemoveExpertPrivateCommissionMutationVariables) => fetcher<RemoveExpertPrivateCommissionMutation, RemoveExpertPrivateCommissionMutationVariables>(RemoveExpertPrivateCommissionDocument, variables)(),
      options
    );
useRemoveExpertPrivateCommissionMutation.getKey = () => ['RemoveExpertPrivateCommission'];

useRemoveExpertPrivateCommissionMutation.fetcher = (variables?: RemoveExpertPrivateCommissionMutationVariables, options?: RequestInit['headers']) => fetcher<RemoveExpertPrivateCommissionMutation, RemoveExpertPrivateCommissionMutationVariables>(RemoveExpertPrivateCommissionDocument, variables, options);
export const RemoveProductFromExpertDocument = `
    mutation RemoveProductFromExpert($expertId: String!, $productId: String, $externalProductId: String) {
  removeProductFromExpert(
    expertId: $expertId
    productId: $productId
    externalProductId: $externalProductId
  )
}
    `;
export const useRemoveProductFromExpertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProductFromExpertMutation, TError, RemoveProductFromExpertMutationVariables, TContext>) =>
    useMutation<RemoveProductFromExpertMutation, TError, RemoveProductFromExpertMutationVariables, TContext>(
      ['RemoveProductFromExpert'],
      (variables?: RemoveProductFromExpertMutationVariables) => fetcher<RemoveProductFromExpertMutation, RemoveProductFromExpertMutationVariables>(RemoveProductFromExpertDocument, variables)(),
      options
    );
useRemoveProductFromExpertMutation.getKey = () => ['RemoveProductFromExpert'];

useRemoveProductFromExpertMutation.fetcher = (variables: RemoveProductFromExpertMutationVariables, options?: RequestInit['headers']) => fetcher<RemoveProductFromExpertMutation, RemoveProductFromExpertMutationVariables>(RemoveProductFromExpertDocument, variables, options);
export const SendDownloadReportRequestDocument = `
    mutation sendDownloadReportRequest($reportType: String!, $parameters: DownloadReportRequestParameters) {
  sendDownloadReportRequest(reportType: $reportType, parameters: $parameters) {
    url
    reportId
    reportType
    status
  }
}
    `;
export const useSendDownloadReportRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendDownloadReportRequestMutation, TError, SendDownloadReportRequestMutationVariables, TContext>) =>
    useMutation<SendDownloadReportRequestMutation, TError, SendDownloadReportRequestMutationVariables, TContext>(
      ['sendDownloadReportRequest'],
      (variables?: SendDownloadReportRequestMutationVariables) => fetcher<SendDownloadReportRequestMutation, SendDownloadReportRequestMutationVariables>(SendDownloadReportRequestDocument, variables)(),
      options
    );
useSendDownloadReportRequestMutation.getKey = () => ['sendDownloadReportRequest'];

useSendDownloadReportRequestMutation.fetcher = (variables: SendDownloadReportRequestMutationVariables, options?: RequestInit['headers']) => fetcher<SendDownloadReportRequestMutation, SendDownloadReportRequestMutationVariables>(SendDownloadReportRequestDocument, variables, options);
export const RequestSampleDocument = `
    query RequestSample($subscriberKey: String!, $productId: String!, $productType: String!, $productTitle: String!, $message: String!, $mailingAddress: String!, $mailingAddress2: String!, $city: String!, $state: String!, $zipCode: String!, $firstName: String!, $lastName: String!, $mailingAddressFirstName: String!, $mailingAddressLastName: String!, $creatorName: String!, $creatorId: String!, $replyAddress: String!, $instagramHandle: String!, $tiktokHandle: String!, $facebookHandle: String!, $youtubeHandle: String!, $twitterHandle: String!, $threadsHandle: String!, $pinterestHandle: String!) {
  requestSample(
    input: {subscriberKey: $subscriberKey, product_id: $productId, product_type: $productType, product_title: $productTitle, message: $message, mailing_address: $mailingAddress, mailing_address_2: $mailingAddress2, city: $city, state: $state, zip_code: $zipCode, mailing_address_first_name: $mailingAddressFirstName, mailing_address_last_name: $mailingAddressLastName, first_name: $firstName, last_name: $lastName, creator_name: $creatorName, creator_id: $creatorId, replyAddress: $replyAddress, instagram_handle: $instagramHandle, tiktok_handle: $tiktokHandle, facebook_handle: $facebookHandle, youtube_handle: $youtubeHandle, twitter_handle: $twitterHandle, threads_handle: $threadsHandle, pinterest_handle: $pinterestHandle}
  ) {
    success
  }
}
    `;
export const useRequestSampleQuery = <
      TData = RequestSampleQuery,
      TError = unknown
    >(
      variables: RequestSampleQueryVariables,
      options?: UseQueryOptions<RequestSampleQuery, TError, TData>
    ) =>
    useQuery<RequestSampleQuery, TError, TData>(
      ['RequestSample', variables],
      fetcher<RequestSampleQuery, RequestSampleQueryVariables>(RequestSampleDocument, variables),
      options
    );
useRequestSampleQuery.document = RequestSampleDocument;


useRequestSampleQuery.getKey = (variables: RequestSampleQueryVariables) => ['RequestSample', variables];
;

useRequestSampleQuery.fetcher = (variables: RequestSampleQueryVariables, options?: RequestInit['headers']) => fetcher<RequestSampleQuery, RequestSampleQueryVariables>(RequestSampleDocument, variables, options);
export const SearchBrandsDocument = `
    query SearchBrands($name: String!, $creatorId: String, $includeHybrid: Boolean) {
  searchBrands(name: $name, creatorId: $creatorId, includeHybrid: $includeHybrid) {
    ...BrandResponseFields
  }
}
    ${BrandResponseFieldsFragmentDoc}`;
export const useSearchBrandsQuery = <
      TData = SearchBrandsQuery,
      TError = unknown
    >(
      variables: SearchBrandsQueryVariables,
      options?: UseQueryOptions<SearchBrandsQuery, TError, TData>
    ) =>
    useQuery<SearchBrandsQuery, TError, TData>(
      ['SearchBrands', variables],
      fetcher<SearchBrandsQuery, SearchBrandsQueryVariables>(SearchBrandsDocument, variables),
      options
    );
useSearchBrandsQuery.document = SearchBrandsDocument;


useSearchBrandsQuery.getKey = (variables: SearchBrandsQueryVariables) => ['SearchBrands', variables];
;

useSearchBrandsQuery.fetcher = (variables: SearchBrandsQueryVariables, options?: RequestInit['headers']) => fetcher<SearchBrandsQuery, SearchBrandsQueryVariables>(SearchBrandsDocument, variables, options);
export const SearchCreatorsDocument = `
    query SearchCreators($name: String!, $brandId: String!, $sortBy: String, $page: Int) {
  searchCreators(name: $name, brandId: $brandId, sortBy: $sortBy, page: $page) {
    ...CreatorForBrandFields
  }
}
    ${CreatorForBrandFieldsFragmentDoc}`;
export const useSearchCreatorsQuery = <
      TData = SearchCreatorsQuery,
      TError = unknown
    >(
      variables: SearchCreatorsQueryVariables,
      options?: UseQueryOptions<SearchCreatorsQuery, TError, TData>
    ) =>
    useQuery<SearchCreatorsQuery, TError, TData>(
      ['SearchCreators', variables],
      fetcher<SearchCreatorsQuery, SearchCreatorsQueryVariables>(SearchCreatorsDocument, variables),
      options
    );
useSearchCreatorsQuery.document = SearchCreatorsDocument;


useSearchCreatorsQuery.getKey = (variables: SearchCreatorsQueryVariables) => ['SearchCreators', variables];
;

useSearchCreatorsQuery.fetcher = (variables: SearchCreatorsQueryVariables, options?: RequestInit['headers']) => fetcher<SearchCreatorsQuery, SearchCreatorsQueryVariables>(SearchCreatorsDocument, variables, options);
export const SearchProductsAndBrandsForShopperDocument = `
    query SearchProductsAndBrandsForShopper($query: String!, $creatorName: String!, $page: Int!) {
  searchProductsAndBrandsForShopper(
    query: $query
    creatorName: $creatorName
    page: $page
  ) {
    products {
      requiresApproval
      partnershipStatus
      product {
        ...ProductFields
      }
      defaultBrandCommission {
        id
        coverage
        amountType
        value
        amountValue
        name
        description
      }
      defaultBrandDiscount {
        ...DiscountFields
      }
    }
    brands {
      brandName
      brandId
      brandLogoUrl
      brandSlug
    }
  }
}
    ${ProductFieldsFragmentDoc}
${DiscountFieldsFragmentDoc}`;
export const useSearchProductsAndBrandsForShopperQuery = <
      TData = SearchProductsAndBrandsForShopperQuery,
      TError = unknown
    >(
      variables: SearchProductsAndBrandsForShopperQueryVariables,
      options?: UseQueryOptions<SearchProductsAndBrandsForShopperQuery, TError, TData>
    ) =>
    useQuery<SearchProductsAndBrandsForShopperQuery, TError, TData>(
      ['SearchProductsAndBrandsForShopper', variables],
      fetcher<SearchProductsAndBrandsForShopperQuery, SearchProductsAndBrandsForShopperQueryVariables>(SearchProductsAndBrandsForShopperDocument, variables),
      options
    );
useSearchProductsAndBrandsForShopperQuery.document = SearchProductsAndBrandsForShopperDocument;


useSearchProductsAndBrandsForShopperQuery.getKey = (variables: SearchProductsAndBrandsForShopperQueryVariables) => ['SearchProductsAndBrandsForShopper', variables];
;

useSearchProductsAndBrandsForShopperQuery.fetcher = (variables: SearchProductsAndBrandsForShopperQueryVariables, options?: RequestInit['headers']) => fetcher<SearchProductsAndBrandsForShopperQuery, SearchProductsAndBrandsForShopperQueryVariables>(SearchProductsAndBrandsForShopperDocument, variables, options);
export const SearchProductsForCreatorDocument = `
    query SearchProductsForCreator($query: String!, $creatorId: String!, $page: Int!, $sortCriteria: SearchProductsForCreatorSortCriteria, $filterOptions: SearchProductsForCreatorFilterOptions, $combineInternalProducts: Boolean) {
  searchProductsForCreator(
    query: $query
    creatorId: $creatorId
    page: $page
    sortCriteria: $sortCriteria
    filterOptions: $filterOptions
    combineInternalProducts: $combineInternalProducts
  ) {
    products {
      requiresApproval
      partnershipStatus
      product {
        ...ProductFields
        requiresApproval
        partnershipStatus
      }
      defaultBrandCommission {
        id
        coverage
        amountType
        value
        amountValue
        name
        description
      }
      defaultBrandDiscount {
        ...DiscountFields
      }
    }
    marketplaceProducts {
      products {
        product {
          ...ProductFields
        }
        defaultBrandCommission {
          id
          coverage
          amountType
          value
          amountValue
          name
          description
        }
        defaultBrandDiscount {
          ...DiscountFields
        }
        requiresApproval
        partnershipStatus
      }
      affiliateSubType
    }
    productCount
    affiliateProducts {
      requiresApproval
      partnershipStatus
      product {
        ...ProductFields
      }
      defaultBrandCommission {
        id
        coverage
        amountType
        value
        amountValue
        name
        description
      }
      defaultBrandDiscount {
        ...DiscountFields
      }
    }
  }
}
    ${ProductFieldsFragmentDoc}
${DiscountFieldsFragmentDoc}`;
export const useSearchProductsForCreatorQuery = <
      TData = SearchProductsForCreatorQuery,
      TError = unknown
    >(
      variables: SearchProductsForCreatorQueryVariables,
      options?: UseQueryOptions<SearchProductsForCreatorQuery, TError, TData>
    ) =>
    useQuery<SearchProductsForCreatorQuery, TError, TData>(
      ['SearchProductsForCreator', variables],
      fetcher<SearchProductsForCreatorQuery, SearchProductsForCreatorQueryVariables>(SearchProductsForCreatorDocument, variables),
      options
    );
useSearchProductsForCreatorQuery.document = SearchProductsForCreatorDocument;


useSearchProductsForCreatorQuery.getKey = (variables: SearchProductsForCreatorQueryVariables) => ['SearchProductsForCreator', variables];
;

useSearchProductsForCreatorQuery.fetcher = (variables: SearchProductsForCreatorQueryVariables, options?: RequestInit['headers']) => fetcher<SearchProductsForCreatorQuery, SearchProductsForCreatorQueryVariables>(SearchProductsForCreatorDocument, variables, options);
export const SendMessageToBrandDocument = `
    query SendMessageToBrand($creator_id: String!, $creator_email: String, $creator_name: String!, $message: String!, $brand_id: String!, $brand_email: String) {
  sendMessageToBrand(
    creator_id: $creator_id
    creator_email: $creator_email
    creator_name: $creator_name
    message: $message
    brand_id: $brand_id
    brand_email: $brand_email
  )
}
    `;
export const useSendMessageToBrandQuery = <
      TData = SendMessageToBrandQuery,
      TError = unknown
    >(
      variables: SendMessageToBrandQueryVariables,
      options?: UseQueryOptions<SendMessageToBrandQuery, TError, TData>
    ) =>
    useQuery<SendMessageToBrandQuery, TError, TData>(
      ['SendMessageToBrand', variables],
      fetcher<SendMessageToBrandQuery, SendMessageToBrandQueryVariables>(SendMessageToBrandDocument, variables),
      options
    );
useSendMessageToBrandQuery.document = SendMessageToBrandDocument;


useSendMessageToBrandQuery.getKey = (variables: SendMessageToBrandQueryVariables) => ['SendMessageToBrand', variables];
;

useSendMessageToBrandQuery.fetcher = (variables: SendMessageToBrandQueryVariables, options?: RequestInit['headers']) => fetcher<SendMessageToBrandQuery, SendMessageToBrandQueryVariables>(SendMessageToBrandDocument, variables, options);
export const SendMessageToCreatorDocument = `
    query SendMessageToCreator($creatorId: String!, $creator_email: String, $message: String!, $brand_id: String!, $brand_name: String!, $brand_email: String, $brand_first_name: String!) {
  sendMessageToCreator(
    creator_id: $creatorId
    creator_email: $creator_email
    message: $message
    brand_id: $brand_id
    brand_name: $brand_name
    brand_email: $brand_email
    brand_first_name: $brand_first_name
  )
}
    `;
export const useSendMessageToCreatorQuery = <
      TData = SendMessageToCreatorQuery,
      TError = unknown
    >(
      variables: SendMessageToCreatorQueryVariables,
      options?: UseQueryOptions<SendMessageToCreatorQuery, TError, TData>
    ) =>
    useQuery<SendMessageToCreatorQuery, TError, TData>(
      ['SendMessageToCreator', variables],
      fetcher<SendMessageToCreatorQuery, SendMessageToCreatorQueryVariables>(SendMessageToCreatorDocument, variables),
      options
    );
useSendMessageToCreatorQuery.document = SendMessageToCreatorDocument;


useSendMessageToCreatorQuery.getKey = (variables: SendMessageToCreatorQueryVariables) => ['SendMessageToCreator', variables];
;

useSendMessageToCreatorQuery.fetcher = (variables: SendMessageToCreatorQueryVariables, options?: RequestInit['headers']) => fetcher<SendMessageToCreatorQuery, SendMessageToCreatorQueryVariables>(SendMessageToCreatorDocument, variables, options);
export const SendUploadRequestDocument = `
    mutation sendUploadRequest($reportType: String!, $parameters: UploadRequestParameters) {
  sendUploadRequest(reportType: $reportType, parameters: $parameters) {
    url
    reportId
    reportType
    status
  }
}
    `;
export const useSendUploadRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendUploadRequestMutation, TError, SendUploadRequestMutationVariables, TContext>) =>
    useMutation<SendUploadRequestMutation, TError, SendUploadRequestMutationVariables, TContext>(
      ['sendUploadRequest'],
      (variables?: SendUploadRequestMutationVariables) => fetcher<SendUploadRequestMutation, SendUploadRequestMutationVariables>(SendUploadRequestDocument, variables)(),
      options
    );
useSendUploadRequestMutation.getKey = () => ['sendUploadRequest'];

useSendUploadRequestMutation.fetcher = (variables: SendUploadRequestMutationVariables, options?: RequestInit['headers']) => fetcher<SendUploadRequestMutation, SendUploadRequestMutationVariables>(SendUploadRequestDocument, variables, options);
export const SetBillingSubscriptionDocument = `
    mutation setBillingSubscription($brandId: String!) {
  setBillingSubscription(brandId: $brandId) {
    internalSubscriptionId
    success
    error
  }
}
    `;
export const useSetBillingSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetBillingSubscriptionMutation, TError, SetBillingSubscriptionMutationVariables, TContext>) =>
    useMutation<SetBillingSubscriptionMutation, TError, SetBillingSubscriptionMutationVariables, TContext>(
      ['setBillingSubscription'],
      (variables?: SetBillingSubscriptionMutationVariables) => fetcher<SetBillingSubscriptionMutation, SetBillingSubscriptionMutationVariables>(SetBillingSubscriptionDocument, variables)(),
      options
    );
useSetBillingSubscriptionMutation.getKey = () => ['setBillingSubscription'];

useSetBillingSubscriptionMutation.fetcher = (variables: SetBillingSubscriptionMutationVariables, options?: RequestInit['headers']) => fetcher<SetBillingSubscriptionMutation, SetBillingSubscriptionMutationVariables>(SetBillingSubscriptionDocument, variables, options);
export const SetOnboardingFlagDocument = `
    mutation setOnboardingFlag($brandId: String!) {
  setOnboardingFlag(brandId: $brandId)
}
    `;
export const useSetOnboardingFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetOnboardingFlagMutation, TError, SetOnboardingFlagMutationVariables, TContext>) =>
    useMutation<SetOnboardingFlagMutation, TError, SetOnboardingFlagMutationVariables, TContext>(
      ['setOnboardingFlag'],
      (variables?: SetOnboardingFlagMutationVariables) => fetcher<SetOnboardingFlagMutation, SetOnboardingFlagMutationVariables>(SetOnboardingFlagDocument, variables)(),
      options
    );
useSetOnboardingFlagMutation.getKey = () => ['setOnboardingFlag'];

useSetOnboardingFlagMutation.fetcher = (variables: SetOnboardingFlagMutationVariables, options?: RequestInit['headers']) => fetcher<SetOnboardingFlagMutation, SetOnboardingFlagMutationVariables>(SetOnboardingFlagDocument, variables, options);
export const SetProductAssociateCommissionsDocument = `
    mutation setProductAssociateCommissions($brandId: [String!], $productId: [String!], $commission: DefaultCommissionInput, $discount: DefaultDiscountInput, $setDefaultCommission: Boolean, $setParentDefaultCommission: Boolean, $expertId: [String!]) {
  setProductAssociateCommissions(
    brandId: $brandId
    productId: $productId
    commission: $commission
    discount: $discount
    setDefaultCommission: $setDefaultCommission
    setParentDefaultCommission: $setParentDefaultCommission
    expertId: $expertId
  )
}
    `;
export const useSetProductAssociateCommissionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductAssociateCommissionsMutation, TError, SetProductAssociateCommissionsMutationVariables, TContext>) =>
    useMutation<SetProductAssociateCommissionsMutation, TError, SetProductAssociateCommissionsMutationVariables, TContext>(
      ['setProductAssociateCommissions'],
      (variables?: SetProductAssociateCommissionsMutationVariables) => fetcher<SetProductAssociateCommissionsMutation, SetProductAssociateCommissionsMutationVariables>(SetProductAssociateCommissionsDocument, variables)(),
      options
    );
useSetProductAssociateCommissionsMutation.getKey = () => ['setProductAssociateCommissions'];

useSetProductAssociateCommissionsMutation.fetcher = (variables?: SetProductAssociateCommissionsMutationVariables, options?: RequestInit['headers']) => fetcher<SetProductAssociateCommissionsMutation, SetProductAssociateCommissionsMutationVariables>(SetProductAssociateCommissionsDocument, variables, options);
export const SetProductSpecificCommissionsDocument = `
    mutation setProductSpecificCommissions($brandId: [String!], $productId: [String!], $commission: DefaultCommissionInput, $discount: DefaultDiscountInput, $setDefaultCommission: Boolean, $setParentDefaultCommission: Boolean, $expertId: [String!]) {
  setProductSpecificCommissions(
    brandId: $brandId
    productId: $productId
    commission: $commission
    discount: $discount
    setDefaultCommission: $setDefaultCommission
    setParentDefaultCommission: $setParentDefaultCommission
    expertId: $expertId
  )
}
    `;
export const useSetProductSpecificCommissionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetProductSpecificCommissionsMutation, TError, SetProductSpecificCommissionsMutationVariables, TContext>) =>
    useMutation<SetProductSpecificCommissionsMutation, TError, SetProductSpecificCommissionsMutationVariables, TContext>(
      ['setProductSpecificCommissions'],
      (variables?: SetProductSpecificCommissionsMutationVariables) => fetcher<SetProductSpecificCommissionsMutation, SetProductSpecificCommissionsMutationVariables>(SetProductSpecificCommissionsDocument, variables)(),
      options
    );
useSetProductSpecificCommissionsMutation.getKey = () => ['setProductSpecificCommissions'];

useSetProductSpecificCommissionsMutation.fetcher = (variables?: SetProductSpecificCommissionsMutationVariables, options?: RequestInit['headers']) => fetcher<SetProductSpecificCommissionsMutation, SetProductSpecificCommissionsMutationVariables>(SetProductSpecificCommissionsDocument, variables, options);
export const SetStripeBillingDocument = `
    mutation setStripeBilling($brandId: String!) {
  setStripeBilling(brandId: $brandId) {
    clientSecret
  }
}
    `;
export const useSetStripeBillingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetStripeBillingMutation, TError, SetStripeBillingMutationVariables, TContext>) =>
    useMutation<SetStripeBillingMutation, TError, SetStripeBillingMutationVariables, TContext>(
      ['setStripeBilling'],
      (variables?: SetStripeBillingMutationVariables) => fetcher<SetStripeBillingMutation, SetStripeBillingMutationVariables>(SetStripeBillingDocument, variables)(),
      options
    );
useSetStripeBillingMutation.getKey = () => ['setStripeBilling'];

useSetStripeBillingMutation.fetcher = (variables: SetStripeBillingMutationVariables, options?: RequestInit['headers']) => fetcher<SetStripeBillingMutation, SetStripeBillingMutationVariables>(SetStripeBillingDocument, variables, options);
export const SyncAmazonAdsDocument = `
    mutation syncAmazonAds($brandId: String!, $tokenId: String!, $profiles: [String]) {
  syncAmazonAds(brandId: $brandId, tokenId: $tokenId, profiles: $profiles) {
    brandId
    requestId
    jobStatus
  }
}
    `;
export const useSyncAmazonAdsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SyncAmazonAdsMutation, TError, SyncAmazonAdsMutationVariables, TContext>) =>
    useMutation<SyncAmazonAdsMutation, TError, SyncAmazonAdsMutationVariables, TContext>(
      ['syncAmazonAds'],
      (variables?: SyncAmazonAdsMutationVariables) => fetcher<SyncAmazonAdsMutation, SyncAmazonAdsMutationVariables>(SyncAmazonAdsDocument, variables)(),
      options
    );
useSyncAmazonAdsMutation.getKey = () => ['syncAmazonAds'];

useSyncAmazonAdsMutation.fetcher = (variables: SyncAmazonAdsMutationVariables, options?: RequestInit['headers']) => fetcher<SyncAmazonAdsMutation, SyncAmazonAdsMutationVariables>(SyncAmazonAdsDocument, variables, options);
export const TriggerCrawlDocument = `
    mutation triggerCrawl($id: String, $type: String) {
  triggerCrawl(id: $id, type: $type)
}
    `;
export const useTriggerCrawlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TriggerCrawlMutation, TError, TriggerCrawlMutationVariables, TContext>) =>
    useMutation<TriggerCrawlMutation, TError, TriggerCrawlMutationVariables, TContext>(
      ['triggerCrawl'],
      (variables?: TriggerCrawlMutationVariables) => fetcher<TriggerCrawlMutation, TriggerCrawlMutationVariables>(TriggerCrawlDocument, variables)(),
      options
    );
useTriggerCrawlMutation.getKey = () => ['triggerCrawl'];

useTriggerCrawlMutation.fetcher = (variables?: TriggerCrawlMutationVariables, options?: RequestInit['headers']) => fetcher<TriggerCrawlMutation, TriggerCrawlMutationVariables>(TriggerCrawlDocument, variables, options);
export const UnMergeChildBrandFromAbstractBrandDocument = `
    mutation unMergeChildBrandFromAbstractBrand($brandId: String!, $childBrandId: String!, $inheritDetailsFromAbstract: Boolean, $inheritCreatorPermissions: Boolean) {
  unMergeChildBrandFromAbstractBrand(
    brandId: $brandId
    childBrandId: $childBrandId
    inheritDetailsFromAbstract: $inheritDetailsFromAbstract
    inheritCreatorPermissions: $inheritCreatorPermissions
  ) {
    brandId
    success
    error
  }
}
    `;
export const useUnMergeChildBrandFromAbstractBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnMergeChildBrandFromAbstractBrandMutation, TError, UnMergeChildBrandFromAbstractBrandMutationVariables, TContext>) =>
    useMutation<UnMergeChildBrandFromAbstractBrandMutation, TError, UnMergeChildBrandFromAbstractBrandMutationVariables, TContext>(
      ['unMergeChildBrandFromAbstractBrand'],
      (variables?: UnMergeChildBrandFromAbstractBrandMutationVariables) => fetcher<UnMergeChildBrandFromAbstractBrandMutation, UnMergeChildBrandFromAbstractBrandMutationVariables>(UnMergeChildBrandFromAbstractBrandDocument, variables)(),
      options
    );
useUnMergeChildBrandFromAbstractBrandMutation.getKey = () => ['unMergeChildBrandFromAbstractBrand'];

useUnMergeChildBrandFromAbstractBrandMutation.fetcher = (variables: UnMergeChildBrandFromAbstractBrandMutationVariables, options?: RequestInit['headers']) => fetcher<UnMergeChildBrandFromAbstractBrandMutation, UnMergeChildBrandFromAbstractBrandMutationVariables>(UnMergeChildBrandFromAbstractBrandDocument, variables, options);
export const UpdateAmazonTokenRefreshDocument = `
    mutation updateAmazonTokenRefresh($brandId: String!, $refreshToken: String!) {
  updateAmazonTokenRefresh(brandId: $brandId, refreshToken: $refreshToken) {
    totalProfiles
    token
    profileExists
    profiles {
      id
      sellerId
      name
      type
      newSync
      syncOverLap
      syncOverlapSameBrand
      isActive
    }
  }
}
    `;
export const useUpdateAmazonTokenRefreshMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAmazonTokenRefreshMutation, TError, UpdateAmazonTokenRefreshMutationVariables, TContext>) =>
    useMutation<UpdateAmazonTokenRefreshMutation, TError, UpdateAmazonTokenRefreshMutationVariables, TContext>(
      ['updateAmazonTokenRefresh'],
      (variables?: UpdateAmazonTokenRefreshMutationVariables) => fetcher<UpdateAmazonTokenRefreshMutation, UpdateAmazonTokenRefreshMutationVariables>(UpdateAmazonTokenRefreshDocument, variables)(),
      options
    );
useUpdateAmazonTokenRefreshMutation.getKey = () => ['updateAmazonTokenRefresh'];

useUpdateAmazonTokenRefreshMutation.fetcher = (variables: UpdateAmazonTokenRefreshMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateAmazonTokenRefreshMutation, UpdateAmazonTokenRefreshMutationVariables>(UpdateAmazonTokenRefreshDocument, variables, options);
export const UpdateAccStatusDocument = `
    mutation updateAccStatus($brandId: String!, $accEnabled: Boolean) {
  updateAccStatus(brandId: $brandId, accEnabled: $accEnabled)
}
    `;
export const useUpdateAccStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAccStatusMutation, TError, UpdateAccStatusMutationVariables, TContext>) =>
    useMutation<UpdateAccStatusMutation, TError, UpdateAccStatusMutationVariables, TContext>(
      ['updateAccStatus'],
      (variables?: UpdateAccStatusMutationVariables) => fetcher<UpdateAccStatusMutation, UpdateAccStatusMutationVariables>(UpdateAccStatusDocument, variables)(),
      options
    );
useUpdateAccStatusMutation.getKey = () => ['updateAccStatus'];

useUpdateAccStatusMutation.fetcher = (variables: UpdateAccStatusMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateAccStatusMutation, UpdateAccStatusMutationVariables>(UpdateAccStatusDocument, variables, options);
export const UpdateBioLinkOrderDocument = `
    mutation UpdateBioLinkOrder($creatorId: String!, $bioLinkOrder: [String!]!) {
  updateBioLinkOrder(creatorId: $creatorId, bioLinkOrder: $bioLinkOrder)
}
    `;
export const useUpdateBioLinkOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBioLinkOrderMutation, TError, UpdateBioLinkOrderMutationVariables, TContext>) =>
    useMutation<UpdateBioLinkOrderMutation, TError, UpdateBioLinkOrderMutationVariables, TContext>(
      ['UpdateBioLinkOrder'],
      (variables?: UpdateBioLinkOrderMutationVariables) => fetcher<UpdateBioLinkOrderMutation, UpdateBioLinkOrderMutationVariables>(UpdateBioLinkOrderDocument, variables)(),
      options
    );
useUpdateBioLinkOrderMutation.getKey = () => ['UpdateBioLinkOrder'];

useUpdateBioLinkOrderMutation.fetcher = (variables: UpdateBioLinkOrderMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateBioLinkOrderMutation, UpdateBioLinkOrderMutationVariables>(UpdateBioLinkOrderDocument, variables, options);
export const UpdateBrandStatusBulkDocument = `
    mutation updateBrandStatusBulk($brandIds: [String], $isAttribution: Boolean, $isAssociate: Boolean) {
  updateBrandStatusBulk(
    brandIds: $brandIds
    isAttribution: $isAttribution
    isAssociate: $isAssociate
  )
}
    `;
export const useUpdateBrandStatusBulkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBrandStatusBulkMutation, TError, UpdateBrandStatusBulkMutationVariables, TContext>) =>
    useMutation<UpdateBrandStatusBulkMutation, TError, UpdateBrandStatusBulkMutationVariables, TContext>(
      ['updateBrandStatusBulk'],
      (variables?: UpdateBrandStatusBulkMutationVariables) => fetcher<UpdateBrandStatusBulkMutation, UpdateBrandStatusBulkMutationVariables>(UpdateBrandStatusBulkDocument, variables)(),
      options
    );
useUpdateBrandStatusBulkMutation.getKey = () => ['updateBrandStatusBulk'];

useUpdateBrandStatusBulkMutation.fetcher = (variables?: UpdateBrandStatusBulkMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateBrandStatusBulkMutation, UpdateBrandStatusBulkMutationVariables>(UpdateBrandStatusBulkDocument, variables, options);
export const UpdateBrandStorefrontPagesDocument = `
    mutation UpdateBrandStorefrontPages($pages: [UpdateBrandStorefrontPageArgs!]!) {
  updateBrandStorefrontPages(pages: $pages)
}
    `;
export const useUpdateBrandStorefrontPagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBrandStorefrontPagesMutation, TError, UpdateBrandStorefrontPagesMutationVariables, TContext>) =>
    useMutation<UpdateBrandStorefrontPagesMutation, TError, UpdateBrandStorefrontPagesMutationVariables, TContext>(
      ['UpdateBrandStorefrontPages'],
      (variables?: UpdateBrandStorefrontPagesMutationVariables) => fetcher<UpdateBrandStorefrontPagesMutation, UpdateBrandStorefrontPagesMutationVariables>(UpdateBrandStorefrontPagesDocument, variables)(),
      options
    );
useUpdateBrandStorefrontPagesMutation.getKey = () => ['UpdateBrandStorefrontPages'];

useUpdateBrandStorefrontPagesMutation.fetcher = (variables: UpdateBrandStorefrontPagesMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateBrandStorefrontPagesMutation, UpdateBrandStorefrontPagesMutationVariables>(UpdateBrandStorefrontPagesDocument, variables, options);
export const UpdateCollectionOrderDocument = `
    mutation updateCollectionOrder($creatorId: String!, $collectionOrder: [String!]!) {
  updateCollectionOrder(creatorId: $creatorId, collectionOrder: $collectionOrder)
}
    `;
export const useUpdateCollectionOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCollectionOrderMutation, TError, UpdateCollectionOrderMutationVariables, TContext>) =>
    useMutation<UpdateCollectionOrderMutation, TError, UpdateCollectionOrderMutationVariables, TContext>(
      ['updateCollectionOrder'],
      (variables?: UpdateCollectionOrderMutationVariables) => fetcher<UpdateCollectionOrderMutation, UpdateCollectionOrderMutationVariables>(UpdateCollectionOrderDocument, variables)(),
      options
    );
useUpdateCollectionOrderMutation.getKey = () => ['updateCollectionOrder'];

useUpdateCollectionOrderMutation.fetcher = (variables: UpdateCollectionOrderMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCollectionOrderMutation, UpdateCollectionOrderMutationVariables>(UpdateCollectionOrderDocument, variables, options);
export const UpdateCreatorLinksDocument = `
    mutation UpdateCreatorLinks($creatorId: String!, $linksInput: LinksInput!) {
  updateCreatorLinks(creatorId: $creatorId, linksInput: $linksInput) {
    instagramName
    facebookName
    tiktokName
    pinterestName
    youtubeName
    twitterName
    threadsName
  }
}
    `;
export const useUpdateCreatorLinksMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCreatorLinksMutation, TError, UpdateCreatorLinksMutationVariables, TContext>) =>
    useMutation<UpdateCreatorLinksMutation, TError, UpdateCreatorLinksMutationVariables, TContext>(
      ['UpdateCreatorLinks'],
      (variables?: UpdateCreatorLinksMutationVariables) => fetcher<UpdateCreatorLinksMutation, UpdateCreatorLinksMutationVariables>(UpdateCreatorLinksDocument, variables)(),
      options
    );
useUpdateCreatorLinksMutation.getKey = () => ['UpdateCreatorLinks'];

useUpdateCreatorLinksMutation.fetcher = (variables: UpdateCreatorLinksMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCreatorLinksMutation, UpdateCreatorLinksMutationVariables>(UpdateCreatorLinksDocument, variables, options);
export const UpdateCreatorProductDocument = `
    mutation UpdateCreatorProduct($updateCreatorProductArgs: UpdateCreatorProductArgs!) {
  updateCreatorProduct(updateCreatorProductArgs: $updateCreatorProductArgs) {
    ...BaseProductFields
    landerMedia {
      ...MediaFields
    }
  }
}
    ${BaseProductFieldsFragmentDoc}
${MediaFieldsFragmentDoc}`;
export const useUpdateCreatorProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCreatorProductMutation, TError, UpdateCreatorProductMutationVariables, TContext>) =>
    useMutation<UpdateCreatorProductMutation, TError, UpdateCreatorProductMutationVariables, TContext>(
      ['UpdateCreatorProduct'],
      (variables?: UpdateCreatorProductMutationVariables) => fetcher<UpdateCreatorProductMutation, UpdateCreatorProductMutationVariables>(UpdateCreatorProductDocument, variables)(),
      options
    );
useUpdateCreatorProductMutation.getKey = () => ['UpdateCreatorProduct'];

useUpdateCreatorProductMutation.fetcher = (variables: UpdateCreatorProductMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCreatorProductMutation, UpdateCreatorProductMutationVariables>(UpdateCreatorProductDocument, variables, options);
export const UpdateCreatorSpecificCommissionDocument = `
    mutation UpdateCreatorSpecificCommission($creatorId: String!, $brandId: String!, $commission: CreatorCommissionInput!) {
  updateCreatorSpecificCommission(
    creatorId: $creatorId
    brandId: $brandId
    commission: $commission
  ) {
    id
  }
}
    `;
export const useUpdateCreatorSpecificCommissionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCreatorSpecificCommissionMutation, TError, UpdateCreatorSpecificCommissionMutationVariables, TContext>) =>
    useMutation<UpdateCreatorSpecificCommissionMutation, TError, UpdateCreatorSpecificCommissionMutationVariables, TContext>(
      ['UpdateCreatorSpecificCommission'],
      (variables?: UpdateCreatorSpecificCommissionMutationVariables) => fetcher<UpdateCreatorSpecificCommissionMutation, UpdateCreatorSpecificCommissionMutationVariables>(UpdateCreatorSpecificCommissionDocument, variables)(),
      options
    );
useUpdateCreatorSpecificCommissionMutation.getKey = () => ['UpdateCreatorSpecificCommission'];

useUpdateCreatorSpecificCommissionMutation.fetcher = (variables: UpdateCreatorSpecificCommissionMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCreatorSpecificCommissionMutation, UpdateCreatorSpecificCommissionMutationVariables>(UpdateCreatorSpecificCommissionDocument, variables, options);
export const UpdateCreatorSpecificDiscountDocument = `
    mutation updateCreatorSpecificDiscount($creatorId: String!, $brandId: String!, $discount: CreatorDiscountInput!) {
  updateCreatorSpecificDiscount(
    creatorId: $creatorId
    brandId: $brandId
    discount: $discount
  ) {
    id
  }
}
    `;
export const useUpdateCreatorSpecificDiscountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCreatorSpecificDiscountMutation, TError, UpdateCreatorSpecificDiscountMutationVariables, TContext>) =>
    useMutation<UpdateCreatorSpecificDiscountMutation, TError, UpdateCreatorSpecificDiscountMutationVariables, TContext>(
      ['updateCreatorSpecificDiscount'],
      (variables?: UpdateCreatorSpecificDiscountMutationVariables) => fetcher<UpdateCreatorSpecificDiscountMutation, UpdateCreatorSpecificDiscountMutationVariables>(UpdateCreatorSpecificDiscountDocument, variables)(),
      options
    );
useUpdateCreatorSpecificDiscountMutation.getKey = () => ['updateCreatorSpecificDiscount'];

useUpdateCreatorSpecificDiscountMutation.fetcher = (variables: UpdateCreatorSpecificDiscountMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateCreatorSpecificDiscountMutation, UpdateCreatorSpecificDiscountMutationVariables>(UpdateCreatorSpecificDiscountDocument, variables, options);
export const UpdateExpertThemeDocument = `
    mutation UpdateExpertTheme($expertName: String, $theme: String!) {
  updateExpertTheme(expertName: $expertName, theme: $theme)
}
    `;
export const useUpdateExpertThemeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateExpertThemeMutation, TError, UpdateExpertThemeMutationVariables, TContext>) =>
    useMutation<UpdateExpertThemeMutation, TError, UpdateExpertThemeMutationVariables, TContext>(
      ['UpdateExpertTheme'],
      (variables?: UpdateExpertThemeMutationVariables) => fetcher<UpdateExpertThemeMutation, UpdateExpertThemeMutationVariables>(UpdateExpertThemeDocument, variables)(),
      options
    );
useUpdateExpertThemeMutation.getKey = () => ['UpdateExpertTheme'];

useUpdateExpertThemeMutation.fetcher = (variables: UpdateExpertThemeMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateExpertThemeMutation, UpdateExpertThemeMutationVariables>(UpdateExpertThemeDocument, variables, options);
export const UpdatePartnershipDocument = `
    mutation UpdatePartnership($expertId: String!, $brandId: [String!], $partnershipStatus: PartnershipStatus, $requestNotes: String, $productId: String, $allBrands: Boolean) {
  updatePartnership(
    expertId: $expertId
    brandId: $brandId
    partnershipStatus: $partnershipStatus
    requestNotes: $requestNotes
    productId: $productId
    allBrands: $allBrands
  )
}
    `;
export const useUpdatePartnershipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartnershipMutation, TError, UpdatePartnershipMutationVariables, TContext>) =>
    useMutation<UpdatePartnershipMutation, TError, UpdatePartnershipMutationVariables, TContext>(
      ['UpdatePartnership'],
      (variables?: UpdatePartnershipMutationVariables) => fetcher<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>(UpdatePartnershipDocument, variables)(),
      options
    );
useUpdatePartnershipMutation.getKey = () => ['UpdatePartnership'];

useUpdatePartnershipMutation.fetcher = (variables: UpdatePartnershipMutationVariables, options?: RequestInit['headers']) => fetcher<UpdatePartnershipMutation, UpdatePartnershipMutationVariables>(UpdatePartnershipDocument, variables, options);
export const UpdatePartnershipsBulkDocument = `
    mutation updatePartnershipsBulk($creatorId: String!, $brandIds: [UpdateBrandPartnerships], $parentBrandId: String) {
  updatePartnershipsBulk(
    creatorId: $creatorId
    brandIds: $brandIds
    parentBrandId: $parentBrandId
  )
}
    `;
export const useUpdatePartnershipsBulkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePartnershipsBulkMutation, TError, UpdatePartnershipsBulkMutationVariables, TContext>) =>
    useMutation<UpdatePartnershipsBulkMutation, TError, UpdatePartnershipsBulkMutationVariables, TContext>(
      ['updatePartnershipsBulk'],
      (variables?: UpdatePartnershipsBulkMutationVariables) => fetcher<UpdatePartnershipsBulkMutation, UpdatePartnershipsBulkMutationVariables>(UpdatePartnershipsBulkDocument, variables)(),
      options
    );
useUpdatePartnershipsBulkMutation.getKey = () => ['updatePartnershipsBulk'];

useUpdatePartnershipsBulkMutation.fetcher = (variables: UpdatePartnershipsBulkMutationVariables, options?: RequestInit['headers']) => fetcher<UpdatePartnershipsBulkMutation, UpdatePartnershipsBulkMutationVariables>(UpdatePartnershipsBulkDocument, variables, options);
export const UpdateProductIsActiveDocument = `
    mutation UpdateProductIsActive($productIds: [String!]!, $isAttribution: Boolean, $isAssociate: Boolean, $brandId: [String]) {
  updateProductsIsActive(
    productIds: $productIds
    isAttribution: $isAttribution
    isAssociate: $isAssociate
    brandId: $brandId
  )
}
    `;
export const useUpdateProductIsActiveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductIsActiveMutation, TError, UpdateProductIsActiveMutationVariables, TContext>) =>
    useMutation<UpdateProductIsActiveMutation, TError, UpdateProductIsActiveMutationVariables, TContext>(
      ['UpdateProductIsActive'],
      (variables?: UpdateProductIsActiveMutationVariables) => fetcher<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>(UpdateProductIsActiveDocument, variables)(),
      options
    );
useUpdateProductIsActiveMutation.getKey = () => ['UpdateProductIsActive'];

useUpdateProductIsActiveMutation.fetcher = (variables: UpdateProductIsActiveMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateProductIsActiveMutation, UpdateProductIsActiveMutationVariables>(UpdateProductIsActiveDocument, variables, options);
export const UpdateUploadRequestDocument = `
    mutation updateUploadRequest($action: String!, $reportId: String!) {
  updateUploadRequest(action: $action, reportId: $reportId) {
    success
    message
  }
}
    `;
export const useUpdateUploadRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUploadRequestMutation, TError, UpdateUploadRequestMutationVariables, TContext>) =>
    useMutation<UpdateUploadRequestMutation, TError, UpdateUploadRequestMutationVariables, TContext>(
      ['updateUploadRequest'],
      (variables?: UpdateUploadRequestMutationVariables) => fetcher<UpdateUploadRequestMutation, UpdateUploadRequestMutationVariables>(UpdateUploadRequestDocument, variables)(),
      options
    );
useUpdateUploadRequestMutation.getKey = () => ['updateUploadRequest'];

useUpdateUploadRequestMutation.fetcher = (variables: UpdateUploadRequestMutationVariables, options?: RequestInit['headers']) => fetcher<UpdateUploadRequestMutation, UpdateUploadRequestMutationVariables>(UpdateUploadRequestDocument, variables, options);
export const UpsertAffiliateProductDocument = `
    mutation UpsertAffiliateProduct($affiliateProductInput: AffiliateProductInput!) {
  upsertAffiliateProduct(affiliateProductInput: $affiliateProductInput) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export const useUpsertAffiliateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertAffiliateProductMutation, TError, UpsertAffiliateProductMutationVariables, TContext>) =>
    useMutation<UpsertAffiliateProductMutation, TError, UpsertAffiliateProductMutationVariables, TContext>(
      ['UpsertAffiliateProduct'],
      (variables?: UpsertAffiliateProductMutationVariables) => fetcher<UpsertAffiliateProductMutation, UpsertAffiliateProductMutationVariables>(UpsertAffiliateProductDocument, variables)(),
      options
    );
useUpsertAffiliateProductMutation.getKey = () => ['UpsertAffiliateProduct'];

useUpsertAffiliateProductMutation.fetcher = (variables: UpsertAffiliateProductMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertAffiliateProductMutation, UpsertAffiliateProductMutationVariables>(UpsertAffiliateProductDocument, variables, options);
export const UpsertAmazonStorefrontDocument = `
    mutation UpsertAmazonStorefront($upsertAmazonStorefrontInput: UpsertAmazonStorefrontInput!) {
  upsertAmazonStorefront(
    upsertAmazonStorefrontInput: $upsertAmazonStorefrontInput
  ) {
    ...AmazonStorefrontFields
  }
}
    ${AmazonStorefrontFieldsFragmentDoc}`;
export const useUpsertAmazonStorefrontMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertAmazonStorefrontMutation, TError, UpsertAmazonStorefrontMutationVariables, TContext>) =>
    useMutation<UpsertAmazonStorefrontMutation, TError, UpsertAmazonStorefrontMutationVariables, TContext>(
      ['UpsertAmazonStorefront'],
      (variables?: UpsertAmazonStorefrontMutationVariables) => fetcher<UpsertAmazonStorefrontMutation, UpsertAmazonStorefrontMutationVariables>(UpsertAmazonStorefrontDocument, variables)(),
      options
    );
useUpsertAmazonStorefrontMutation.getKey = () => ['UpsertAmazonStorefront'];

useUpsertAmazonStorefrontMutation.fetcher = (variables: UpsertAmazonStorefrontMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertAmazonStorefrontMutation, UpsertAmazonStorefrontMutationVariables>(UpsertAmazonStorefrontDocument, variables, options);
export const UpsertBioLinkDocument = `
    mutation UpsertBioLink($upsertBioLinkInput: UpsertBioLinkInput!) {
  upsertBioLink(upsertBioLinkInput: $upsertBioLinkInput) {
    id
    linkType
    data
  }
}
    `;
export const useUpsertBioLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertBioLinkMutation, TError, UpsertBioLinkMutationVariables, TContext>) =>
    useMutation<UpsertBioLinkMutation, TError, UpsertBioLinkMutationVariables, TContext>(
      ['UpsertBioLink'],
      (variables?: UpsertBioLinkMutationVariables) => fetcher<UpsertBioLinkMutation, UpsertBioLinkMutationVariables>(UpsertBioLinkDocument, variables)(),
      options
    );
useUpsertBioLinkMutation.getKey = () => ['UpsertBioLink'];

useUpsertBioLinkMutation.fetcher = (variables: UpsertBioLinkMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertBioLinkMutation, UpsertBioLinkMutationVariables>(UpsertBioLinkDocument, variables, options);
export const UpsertBrandDocument = `
    mutation UpsertBrand($brandId: String, $companyInfo: CompanyInfoInput, $contactInfo: ContactInfoInput, $externalStoreInfo: ExternalStoreInfoInput, $defaultCommission: DefaultCommissionInput, $defaultDiscount: DefaultDiscountInput, $customerSupport: CustomerSupportInput, $termsOfServiceAccepted: Boolean, $brexPaymentId: String, $brexVendorId: String, $requiresApproval: Boolean, $createOrderTags: Boolean, $logoUrl: String, $brandPlatform: BrandPlatform, $bio: String, $isActive: Boolean, $isHidden: Boolean, $isAssociate: Boolean, $isAssociateHidden: Boolean, $associateRequiresApproval: Boolean, $source: String, $onboardingInfoClicked: Boolean, $countryCode: String) {
  upsertBrand(
    brandId: $brandId
    companyInfo: $companyInfo
    contactInfo: $contactInfo
    externalStoreInfo: $externalStoreInfo
    defaultCommission: $defaultCommission
    defaultDiscount: $defaultDiscount
    customerSupport: $customerSupport
    termsOfServiceAccepted: $termsOfServiceAccepted
    brexPaymentId: $brexPaymentId
    requiresApproval: $requiresApproval
    brexVendorId: $brexVendorId
    createOrderTags: $createOrderTags
    logoUrl: $logoUrl
    brandPlatform: $brandPlatform
    bio: $bio
    isActive: $isActive
    isHidden: $isHidden
    isAssociate: $isAssociate
    isAssociateHidden: $isAssociateHidden
    associateRequiresApproval: $associateRequiresApproval
    source: $source
    onboardingInfoClicked: $onboardingInfoClicked
    countryCode: $countryCode
  ) {
    id
    createdAt
    onboardingStatus
    termsOfServiceAccepted
    hasBrexPayment
    requiresApproval
    brexVendorId
    logoUrl
    companyInfo {
      name
      website
    }
    customerSupport {
      returnPolicy
      supportEmail
    }
    contactInfo {
      firstName
      lastName
      phone
      email
      title
    }
    externalStoreInfo {
      externalStore
      externalStoreView
    }
    defaultCommission {
      amountType
      amountValue
    }
    defaultDiscount {
      amountType
      amountValue
    }
    brandPlatform
    bio
    isActive
    isDefaultHidden
    requiresAssociatesApproval
    isAssociateActive
    isAssociateDefaultHidden
    associateProductStatus
    associateFeatureFlag
    source
    onBoardingInfoClicked
  }
}
    `;
export const useUpsertBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertBrandMutation, TError, UpsertBrandMutationVariables, TContext>) =>
    useMutation<UpsertBrandMutation, TError, UpsertBrandMutationVariables, TContext>(
      ['UpsertBrand'],
      (variables?: UpsertBrandMutationVariables) => fetcher<UpsertBrandMutation, UpsertBrandMutationVariables>(UpsertBrandDocument, variables)(),
      options
    );
useUpsertBrandMutation.getKey = () => ['UpsertBrand'];

useUpsertBrandMutation.fetcher = (variables?: UpsertBrandMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertBrandMutation, UpsertBrandMutationVariables>(UpsertBrandDocument, variables, options);
export const UpsertCollectionDocument = `
    mutation UpsertCollection($upsertCollectionInput: UpsertCollectionInput!) {
  upsertCollection(upsertCollectionInput: $upsertCollectionInput) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useUpsertCollectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCollectionMutation, TError, UpsertCollectionMutationVariables, TContext>) =>
    useMutation<UpsertCollectionMutation, TError, UpsertCollectionMutationVariables, TContext>(
      ['UpsertCollection'],
      (variables?: UpsertCollectionMutationVariables) => fetcher<UpsertCollectionMutation, UpsertCollectionMutationVariables>(UpsertCollectionDocument, variables)(),
      options
    );
useUpsertCollectionMutation.getKey = () => ['UpsertCollection'];

useUpsertCollectionMutation.fetcher = (variables: UpsertCollectionMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertCollectionMutation, UpsertCollectionMutationVariables>(UpsertCollectionDocument, variables, options);
export const UpsertCreatorConnectionsDocument = `
    mutation upsertCreatorConnections($brandId: String, $merchantToken: String) {
  upsertCreatorConnections(brandId: $brandId, merchantToken: $merchantToken) {
    brandId
    id
    inviteEmail
    merchantToken
    status
  }
}
    `;
export const useUpsertCreatorConnectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCreatorConnectionsMutation, TError, UpsertCreatorConnectionsMutationVariables, TContext>) =>
    useMutation<UpsertCreatorConnectionsMutation, TError, UpsertCreatorConnectionsMutationVariables, TContext>(
      ['upsertCreatorConnections'],
      (variables?: UpsertCreatorConnectionsMutationVariables) => fetcher<UpsertCreatorConnectionsMutation, UpsertCreatorConnectionsMutationVariables>(UpsertCreatorConnectionsDocument, variables)(),
      options
    );
useUpsertCreatorConnectionsMutation.getKey = () => ['upsertCreatorConnections'];

useUpsertCreatorConnectionsMutation.fetcher = (variables?: UpsertCreatorConnectionsMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertCreatorConnectionsMutation, UpsertCreatorConnectionsMutationVariables>(UpsertCreatorConnectionsDocument, variables, options);
export const UpsertExpertDocument = `
    mutation upsertExpert($name: String!, $instagramName: String, $instagramAuthorized: Boolean, $contactInfo: ExpertContactInfoInput, $brexPaymentId: String, $brexVendorId: String, $termsOfServiceAccepted: Boolean, $storeApprovalStatus: ApprovalStatus, $brandInvite: String, $bio: String, $dateOfBirth: String, $gender: Gender, $children: [Children], $pets: [Pets], $niches: [Niche], $socialAccounts: LinksInput, $onboardingDescription: String, $score: String, $inviteCode: String, $amzStorefront: String) {
  upsertExpert(
    name: $name
    instagramName: $instagramName
    instagramAuthorized: $instagramAuthorized
    contactInfo: $contactInfo
    brexPaymentId: $brexPaymentId
    brexVendorId: $brexVendorId
    termsOfServiceAccepted: $termsOfServiceAccepted
    storeApprovalStatus: $storeApprovalStatus
    brandInvite: $brandInvite
    bio: $bio
    dateOfBirth: $dateOfBirth
    gender: $gender
    children: $children
    pets: $pets
    niches: $niches
    socialAccounts: $socialAccounts
    onboardingDescription: $onboardingDescription
    score: $score
    inviteCode: $inviteCode
    amzStorefront: $amzStorefront
  ) {
    id
    name
    instagramName
    instagramAuthorized
    theme
    hasBrexPayment
    brexVendorId
    contactInfo {
      email
      phone
      firstName
      lastName
    }
    bio
    dateOfBirth
    gender
    children
    pets
    niches
    socialMedia {
      instagramName
      facebookName
      tiktokName
      pinterestName
      youtubeName
      twitterName
      threadsName
      website
    }
    onboardingDescription
    score
    amzStorefront
  }
}
    `;
export const useUpsertExpertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertExpertMutation, TError, UpsertExpertMutationVariables, TContext>) =>
    useMutation<UpsertExpertMutation, TError, UpsertExpertMutationVariables, TContext>(
      ['upsertExpert'],
      (variables?: UpsertExpertMutationVariables) => fetcher<UpsertExpertMutation, UpsertExpertMutationVariables>(UpsertExpertDocument, variables)(),
      options
    );
useUpsertExpertMutation.getKey = () => ['upsertExpert'];

useUpsertExpertMutation.fetcher = (variables: UpsertExpertMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertExpertMutation, UpsertExpertMutationVariables>(UpsertExpertDocument, variables, options);
export const UpsertPostDocument = `
    mutation UpsertPost($upsertPostInput: UpsertPostInput!) {
  upsertPost(upsertPostInput: $upsertPostInput) {
    ...CollectionFields
    productIds
  }
}
    ${CollectionFieldsFragmentDoc}`;
export const useUpsertPostMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertPostMutation, TError, UpsertPostMutationVariables, TContext>) =>
    useMutation<UpsertPostMutation, TError, UpsertPostMutationVariables, TContext>(
      ['UpsertPost'],
      (variables?: UpsertPostMutationVariables) => fetcher<UpsertPostMutation, UpsertPostMutationVariables>(UpsertPostDocument, variables)(),
      options
    );
useUpsertPostMutation.getKey = () => ['UpsertPost'];

useUpsertPostMutation.fetcher = (variables: UpsertPostMutationVariables, options?: RequestInit['headers']) => fetcher<UpsertPostMutation, UpsertPostMutationVariables>(UpsertPostDocument, variables, options);
export const CheckInvitationDocument = `
    query checkInvitation($id: String!) {
  checkInvitation(id: $id) {
    brandName
    inviteeEmail
    inviterName
    expireDate
    isInviteeUserExist
  }
}
    `;
export const useCheckInvitationQuery = <
      TData = CheckInvitationQuery,
      TError = unknown
    >(
      variables: CheckInvitationQueryVariables,
      options?: UseQueryOptions<CheckInvitationQuery, TError, TData>
    ) =>
    useQuery<CheckInvitationQuery, TError, TData>(
      ['checkInvitation', variables],
      fetcher<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, variables),
      options
    );
useCheckInvitationQuery.document = CheckInvitationDocument;


useCheckInvitationQuery.getKey = (variables: CheckInvitationQueryVariables) => ['checkInvitation', variables];
;

useCheckInvitationQuery.fetcher = (variables: CheckInvitationQueryVariables, options?: RequestInit['headers']) => fetcher<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, variables, options);
export const ViewCarouselItemsDocument = `
    query viewCarouselItems($creatorId: String!, $carouselId: String, $page: Int, $pageSize: Int) {
  viewCarouselItems(
    creatorId: $creatorId
    carouselId: $carouselId
    page: $page
    pageSize: $pageSize
  ) {
    id
    name
    displayName
    displayPosition
    carouselType
    updatedAt
    productCount
    products {
      ...ProductFields
    }
    brands {
      ...BrandResponseFields
    }
  }
}
    ${ProductFieldsFragmentDoc}
${BrandResponseFieldsFragmentDoc}`;
export const useViewCarouselItemsQuery = <
      TData = ViewCarouselItemsQuery,
      TError = unknown
    >(
      variables: ViewCarouselItemsQueryVariables,
      options?: UseQueryOptions<ViewCarouselItemsQuery, TError, TData>
    ) =>
    useQuery<ViewCarouselItemsQuery, TError, TData>(
      ['viewCarouselItems', variables],
      fetcher<ViewCarouselItemsQuery, ViewCarouselItemsQueryVariables>(ViewCarouselItemsDocument, variables),
      options
    );
useViewCarouselItemsQuery.document = ViewCarouselItemsDocument;


useViewCarouselItemsQuery.getKey = (variables: ViewCarouselItemsQueryVariables) => ['viewCarouselItems', variables];
;

useViewCarouselItemsQuery.fetcher = (variables: ViewCarouselItemsQueryVariables, options?: RequestInit['headers']) => fetcher<ViewCarouselItemsQuery, ViewCarouselItemsQueryVariables>(ViewCarouselItemsDocument, variables, options);